import { openBlock as A, createElementBlock as V, createElementVNode as R, defineComponent as D, createVNode as z, unref as F, normalizeClass as Z, createBlock as H, renderSlot as ye, cloneVNode as Zn, h as Y, Fragment as pe, inject as me, provide as fe, ref as C, onMounted as X, watchEffect as ce, nextTick as ie, computed as S, toRaw as ee, watch as se, onUnmounted as xe, Teleport as ho, reactive as mo, shallowRef as Kt, resolveDirective as Qn, withDirectives as qt, createCommentVNode as Q, toDisplayString as re, isRef as Ke, withCtx as N, createTextVNode as ge, renderList as Le, mergeProps as Ie, vModelText as bo, Transition as Xn, resolveDynamicComponent as Ca, getCurrentScope as yo, onScopeDispose as go, shallowReadonly as Ze, toRef as Sr, onBeforeUnmount as wo, withModifiers as xo } from "vue";
const $o = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, So = /* @__PURE__ */ R("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 3a9 9 0 1 0 9 9"
}, null, -1), To = [
  So
];
function Oo(e, t) {
  return A(), V("svg", $o, To);
}
const Co = { name: "tune-spinner", render: Oo }, Ao = { class: "flex items-center" }, Aa = /* @__PURE__ */ D({
  __name: "TuneLoadingSpinner",
  setup(e) {
    return (t, n) => (A(), V("div", Ao, [
      z(F(Co), { class: "h-[22px] animate-spin" })
    ]));
  }
}), Eo = ["type", "disabled"], Yt = /* @__PURE__ */ D({
  __name: "TuneButton",
  props: {
    type: { default: "button" },
    primary: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (A(), V("button", {
      type: e.type,
      class: Z([
        "tune-button",
        {
          primary: e.primary,
          disabled: e.disabled
        }
      ]),
      disabled: e.disabled || e.loading
    }, [
      e.loading ? (A(), H(Aa, { key: 0 })) : ye(t.$slots, "default", { key: 1 })
    ], 10, Eo));
  }
});
function J(e, t, ...n) {
  if (e in t) {
    let r = t[e];
    return typeof r == "function" ? r(...n) : r;
  }
  let l = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((r) => `"${r}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(l, J), l;
}
var we = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(we || {}), Me = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Me || {});
function q({ visible: e = !0, features: t = 0, ourProps: n, theirProps: l, ...r }) {
  var a;
  let o = Pa(l, n), i = Object.assign(r, { props: o });
  if (e || t & 2 && o.static)
    return gn(i);
  if (t & 1) {
    let s = (a = o.unmount) == null || a ? 0 : 1;
    return J(s, { [0]() {
      return null;
    }, [1]() {
      return gn({ ...r, props: { ...o, hidden: !0, style: { display: "none" } } });
    } });
  }
  return gn(i);
}
function gn({ props: e, attrs: t, slots: n, slot: l, name: r }) {
  var a, o;
  let { as: i, ...s } = nt(e, ["unmount", "static"]), u = (a = n.default) == null ? void 0 : a.call(n, l), c = {};
  if (l) {
    let d = !1, f = [];
    for (let [v, p] of Object.entries(l))
      typeof p == "boolean" && (d = !0), p === !0 && f.push(v);
    d && (c["data-headlessui-state"] = f.join(" "));
  }
  if (i === "template") {
    if (u = Ea(u ?? []), Object.keys(s).length > 0 || Object.keys(t).length > 0) {
      let [d, ...f] = u ?? [];
      if (!Po(d) || f.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${r} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(s).concat(Object.keys(t)).map((m) => m.trim()).filter((m, h, b) => b.indexOf(m) === h).sort((m, h) => m.localeCompare(h)).map((m) => `  - ${m}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((m) => `  - ${m}`).join(`
`)].join(`
`));
      let v = Pa((o = d.props) != null ? o : {}, s), p = Zn(d, v);
      for (let m in v)
        m.startsWith("on") && (p.props || (p.props = {}), p.props[m] = v[m]);
      return p;
    }
    return Array.isArray(u) && u.length === 1 ? u[0] : u;
  }
  return Y(i, Object.assign({}, s, c), { default: () => u });
}
function Ea(e) {
  return e.flatMap((t) => t.type === pe ? Ea(t.children) : [t]);
}
function Pa(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, n = {};
  for (let l of e)
    for (let r in l)
      r.startsWith("on") && typeof l[r] == "function" ? (n[r] != null || (n[r] = []), n[r].push(l[r])) : t[r] = l[r];
  if (t.disabled || t["aria-disabled"])
    return Object.assign(t, Object.fromEntries(Object.keys(n).map((l) => [l, void 0])));
  for (let l in n)
    Object.assign(t, { [l](r, ...a) {
      let o = n[l];
      for (let i of o) {
        if (r instanceof Event && r.defaultPrevented)
          return;
        i(r, ...a);
      }
    } });
  return t;
}
function er(e) {
  let t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
function nt(e, t = []) {
  let n = Object.assign({}, e);
  for (let l of t)
    l in n && delete n[l];
  return n;
}
function Po(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
let Fo = 0;
function Io() {
  return ++Fo;
}
function ae() {
  return Io();
}
var B = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(B || {});
function _o(e) {
  throw new Error("Unexpected object: " + e);
}
var W = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(W || {});
function tr(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0)
    return null;
  let l = t.resolveActiveIndex(), r = l ?? -1, a = (() => {
    switch (e.focus) {
      case 0:
        return n.findIndex((o) => !t.resolveDisabled(o));
      case 1: {
        let o = n.slice().reverse().findIndex((i, s, u) => r !== -1 && u.length - s - 1 >= r ? !1 : !t.resolveDisabled(i));
        return o === -1 ? o : n.length - 1 - o;
      }
      case 2:
        return n.findIndex((o, i) => i <= r ? !1 : !t.resolveDisabled(o));
      case 3: {
        let o = n.slice().reverse().findIndex((i) => !t.resolveDisabled(i));
        return o === -1 ? o : n.length - 1 - o;
      }
      case 4:
        return n.findIndex((o) => t.resolveId(o) === e.id);
      case 5:
        return null;
      default:
        _o(e);
    }
  })();
  return a === -1 ? l : a;
}
function T(e) {
  var t;
  return e == null || e.value == null ? null : (t = e.value.$el) != null ? t : e.value;
}
let Fa = Symbol("Context");
var ne = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(ne || {});
function Lo() {
  return ze() !== null;
}
function ze() {
  return me(Fa, null);
}
function gt(e) {
  fe(Fa, e);
}
function Tr(e, t) {
  if (e)
    return e;
  let n = t ?? "button";
  if (typeof n == "string" && n.toLowerCase() === "button")
    return "button";
}
function wt(e, t) {
  let n = C(Tr(e.value.type, e.value.as));
  return X(() => {
    n.value = Tr(e.value.type, e.value.as);
  }), ce(() => {
    var l;
    n.value || T(t) && T(t) instanceof HTMLButtonElement && !((l = T(t)) != null && l.hasAttribute("type")) && (n.value = "button");
  }), n;
}
var ko = Object.defineProperty, Do = (e, t, n) => t in e ? ko(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Or = (e, t, n) => (Do(e, typeof t != "symbol" ? t + "" : t, n), n);
let Ro = class {
  constructor() {
    Or(this, "current", this.detect()), Or(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, xt = new Ro();
function Pe(e) {
  if (xt.isServer)
    return null;
  if (e instanceof Node)
    return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = T(e);
    if (t)
      return t.ownerDocument;
  }
  return document;
}
function Ia({ container: e, accept: t, walk: n, enabled: l }) {
  ce(() => {
    let r = e.value;
    if (!r || l !== void 0 && !l.value)
      return;
    let a = Pe(e);
    if (!a)
      return;
    let o = Object.assign((s) => t(s), { acceptNode: t }), i = a.createTreeWalker(r, NodeFilter.SHOW_ELEMENT, o, !1);
    for (; i.nextNode(); )
      n(i.currentNode);
  });
}
let Ln = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var he = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(he || {}), mt = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(mt || {}), Vo = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(Vo || {});
function $t(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Ln)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var St = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(St || {});
function Tt(e, t = 0) {
  var n;
  return e === ((n = Pe(e)) == null ? void 0 : n.body) ? !1 : J(t, { [0]() {
    return e.matches(Ln);
  }, [1]() {
    let l = e;
    for (; l !== null; ) {
      if (l.matches(Ln))
        return !0;
      l = l.parentElement;
    }
    return !1;
  } });
}
function _a(e) {
  let t = Pe(e);
  ie(() => {
    t && !Tt(t.activeElement, 0) && je(e);
  });
}
function je(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let Mo = ["textarea", "input"].join(",");
function jo(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, Mo)) != null ? n : !1;
}
function Jt(e, t = (n) => n) {
  return e.slice().sort((n, l) => {
    let r = t(n), a = t(l);
    if (r === null || a === null)
      return 0;
    let o = r.compareDocumentPosition(a);
    return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Bo(e, t) {
  return Oe($t(), t, { relativeTo: e });
}
function Oe(e, t, { sorted: n = !0, relativeTo: l = null, skipElements: r = [] } = {}) {
  var a;
  let o = (a = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e == null ? void 0 : e.ownerDocument) != null ? a : document, i = Array.isArray(e) ? n ? Jt(e) : e : $t(e);
  r.length > 0 && i.length > 1 && (i = i.filter((p) => !r.includes(p))), l = l ?? o.activeElement;
  let s = (() => {
    if (t & 5)
      return 1;
    if (t & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = (() => {
    if (t & 1)
      return 0;
    if (t & 2)
      return Math.max(0, i.indexOf(l)) - 1;
    if (t & 4)
      return Math.max(0, i.indexOf(l)) + 1;
    if (t & 8)
      return i.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = t & 32 ? { preventScroll: !0 } : {}, d = 0, f = i.length, v;
  do {
    if (d >= f || d + f <= 0)
      return 0;
    let p = u + d;
    if (t & 16)
      p = (p + f) % f;
    else {
      if (p < 0)
        return 3;
      if (p >= f)
        return 1;
    }
    v = i[p], v == null || v.focus(c), d += s;
  } while (v !== o.activeElement);
  return t & 6 && jo(v) && v.select(), v.hasAttribute("tabindex") || v.setAttribute("tabindex", "0"), 2;
}
function wn(e, t, n) {
  xt.isServer || ce((l) => {
    document.addEventListener(e, t, n), l(() => document.removeEventListener(e, t, n));
  });
}
function Ot(e, t, n = S(() => !0)) {
  function l(a, o) {
    if (!n.value || a.defaultPrevented)
      return;
    let i = o(a);
    if (i === null || !i.getRootNode().contains(i))
      return;
    let s = function u(c) {
      return typeof c == "function" ? u(c()) : Array.isArray(c) || c instanceof Set ? c : [c];
    }(e);
    for (let u of s) {
      if (u === null)
        continue;
      let c = u instanceof HTMLElement ? u : T(u);
      if (c != null && c.contains(i) || a.composed && a.composedPath().includes(c))
        return;
    }
    return !Tt(i, St.Loose) && i.tabIndex !== -1 && a.preventDefault(), t(a, i);
  }
  let r = C(null);
  wn("mousedown", (a) => {
    var o, i;
    n.value && (r.value = ((i = (o = a.composedPath) == null ? void 0 : o.call(a)) == null ? void 0 : i[0]) || a.target);
  }, !0), wn("click", (a) => {
    r.value && (l(a, () => r.value), r.value = null);
  }, !0), wn("blur", (a) => l(a, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
var ke = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(ke || {});
let Ve = D({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: n }) {
  return () => {
    let { features: l, ...r } = e, a = { "aria-hidden": (l & 2) === 2 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(l & 4) === 4 && (l & 2) !== 2 && { display: "none" } } };
    return q({ ourProps: a, theirProps: r, slot: {}, attrs: n, slots: t, name: "Hidden" });
  };
} });
function nr(e = {}, t = null, n = []) {
  for (let [l, r] of Object.entries(e))
    ka(n, La(t, l), r);
  return n;
}
function La(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function ka(e, t, n) {
  if (Array.isArray(n))
    for (let [l, r] of n.entries())
      ka(e, La(t, l.toString()), r);
  else
    n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, `${n}`]) : n == null ? e.push([t, ""]) : nr(n, t, e);
}
function No(e) {
  var t;
  let n = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (n) {
    for (let l of n.elements)
      if (l.tagName === "INPUT" && l.type === "submit" || l.tagName === "BUTTON" && l.type === "submit" || l.nodeName === "INPUT" && l.type === "image") {
        l.click();
        return;
      }
  }
}
function rr(e, t, n) {
  let l = C(n == null ? void 0 : n.value), r = S(() => e.value !== void 0);
  return [S(() => r.value ? e.value : l.value), function(a) {
    return r.value || (l.value = a), t == null ? void 0 : t(a);
  }];
}
function Cr(e) {
  return [e.screenX, e.screenY];
}
function ar() {
  let e = C([-1, -1]);
  return { wasMoved(t) {
    let n = Cr(t);
    return e.value[0] === n[0] && e.value[1] === n[1] ? !1 : (e.value = n, !0);
  }, update(t) {
    e.value = Cr(t);
  } };
}
function Da() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function zo() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Uo() {
  return Da() || zo();
}
function Ho(e, t) {
  return e === t;
}
var Go = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Go || {}), Wo = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Wo || {}), Ko = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(Ko || {});
let Ra = Symbol("ComboboxContext");
function rt(e) {
  let t = me(Ra, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, rt), n;
  }
  return t;
}
let Va = D({ name: "Combobox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => Ho }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, name: { type: String }, nullable: { type: Boolean, default: !1 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: t, attrs: n, emit: l }) {
  let r = C(1), a = C(null), o = C(null), i = C(null), s = C(null), u = C({ static: !1, hold: !1 }), c = C([]), d = C(null), f = C(1), v = C(!1);
  function p($ = (E) => E) {
    let E = d.value !== null ? c.value[d.value] : null, O = Jt($(c.value.slice()), (I) => T(I.dataRef.domRef)), P = E ? O.indexOf(E) : null;
    return P === -1 && (P = null), { options: O, activeOptionIndex: P };
  }
  let m = S(() => e.multiple ? 1 : 0), h = S(() => e.nullable), [b, y] = rr(S(() => e.modelValue === void 0 ? J(m.value, { [1]: [], [0]: void 0 }) : e.modelValue), ($) => l("update:modelValue", $), S(() => e.defaultValue)), g = { comboboxState: r, value: b, mode: m, compare($, E) {
    if (typeof e.by == "string") {
      let O = e.by;
      return ($ == null ? void 0 : $[O]) === (E == null ? void 0 : E[O]);
    }
    return e.by($, E);
  }, defaultValue: S(() => e.defaultValue), nullable: h, inputRef: o, labelRef: a, buttonRef: i, optionsRef: s, disabled: S(() => e.disabled), options: c, change($) {
    y($);
  }, activeOptionIndex: S(() => {
    if (v.value && d.value === null && c.value.length > 0) {
      let $ = c.value.findIndex((E) => !E.dataRef.disabled);
      if ($ !== -1)
        return $;
    }
    return d.value;
  }), activationTrigger: f, optionsPropsRef: u, closeCombobox() {
    v.value = !1, !e.disabled && r.value !== 1 && (r.value = 1, d.value = null);
  }, openCombobox() {
    if (v.value = !0, e.disabled || r.value === 0)
      return;
    let $ = c.value.findIndex((E) => {
      let O = ee(E.dataRef.value);
      return J(m.value, { [0]: () => g.compare(ee(g.value.value), ee(O)), [1]: () => ee(g.value.value).some((P) => g.compare(ee(P), ee(O))) });
    });
    $ !== -1 && (d.value = $), r.value = 0;
  }, goToOption($, E, O) {
    if (v.value = !1, e.disabled || s.value && !u.value.static && r.value === 1)
      return;
    let P = p();
    if (P.activeOptionIndex === null) {
      let L = P.options.findIndex((M) => !M.dataRef.disabled);
      L !== -1 && (P.activeOptionIndex = L);
    }
    let I = tr($ === W.Specific ? { focus: W.Specific, id: E } : { focus: $ }, { resolveItems: () => P.options, resolveActiveIndex: () => P.activeOptionIndex, resolveId: (L) => L.id, resolveDisabled: (L) => L.dataRef.disabled });
    d.value = I, f.value = O ?? 1, c.value = P.options;
  }, selectOption($) {
    let E = c.value.find((P) => P.id === $);
    if (!E)
      return;
    let { dataRef: O } = E;
    y(J(m.value, { [0]: () => O.value, [1]: () => {
      let P = ee(g.value.value).slice(), I = ee(O.value), L = P.findIndex((M) => g.compare(I, ee(M)));
      return L === -1 ? P.push(I) : P.splice(L, 1), P;
    } }));
  }, selectActiveOption() {
    if (g.activeOptionIndex.value === null)
      return;
    let { dataRef: $, id: E } = c.value[g.activeOptionIndex.value];
    y(J(m.value, { [0]: () => $.value, [1]: () => {
      let O = ee(g.value.value).slice(), P = ee($.value), I = O.findIndex((L) => g.compare(P, ee(L)));
      return I === -1 ? O.push(P) : O.splice(I, 1), O;
    } })), g.goToOption(W.Specific, E);
  }, registerOption($, E) {
    let O = { id: $, dataRef: E }, P = p((I) => [...I, O]);
    if (d.value === null) {
      let I = E.value.value;
      J(m.value, { [0]: () => g.compare(ee(g.value.value), ee(I)), [1]: () => ee(g.value.value).some((L) => g.compare(ee(L), ee(I))) }) && (P.activeOptionIndex = P.options.indexOf(O));
    }
    c.value = P.options, d.value = P.activeOptionIndex, f.value = 1;
  }, unregisterOption($) {
    var E;
    g.activeOptionIndex.value !== null && ((E = g.options.value[g.activeOptionIndex.value]) == null ? void 0 : E.id) === $ && (v.value = !0);
    let O = p((P) => {
      let I = P.findIndex((L) => L.id === $);
      return I !== -1 && P.splice(I, 1), P;
    });
    c.value = O.options, d.value = O.activeOptionIndex, f.value = 1;
  } };
  Ot([o, i, s], () => g.closeCombobox(), S(() => r.value === 0)), fe(Ra, g), gt(S(() => J(r.value, { [0]: ne.Open, [1]: ne.Closed })));
  let x = S(() => g.activeOptionIndex.value === null ? null : c.value[g.activeOptionIndex.value].dataRef.value), w = S(() => {
    var $;
    return ($ = T(o)) == null ? void 0 : $.closest("form");
  });
  return X(() => {
    se([w], () => {
      if (!w.value || e.defaultValue === void 0)
        return;
      function $() {
        g.change(e.defaultValue);
      }
      return w.value.addEventListener("reset", $), () => {
        var E;
        (E = w.value) == null || E.removeEventListener("reset", $);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: $, disabled: E, ...O } = e, P = { open: r.value === 0, disabled: E, activeIndex: g.activeOptionIndex.value, activeOption: x.value, value: b.value };
    return Y(pe, [...$ != null && b.value != null ? nr({ [$]: b.value }).map(([I, L]) => Y(Ve, er({ features: ke.Hidden, key: I, as: "input", type: "hidden", hidden: !0, readOnly: !0, name: I, value: L }))) : [], q({ theirProps: { ...n, ...nt(O, ["modelValue", "defaultValue", "nullable", "multiple", "onUpdate:modelValue", "by"]) }, ourProps: {}, slot: P, slots: t, attrs: n, name: "Combobox" })]);
  };
} }), Ma = D({ name: "ComboboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: () => `headlessui-combobox-label-${ae()}` } }, setup(e, { attrs: t, slots: n }) {
  let l = rt("ComboboxLabel");
  function r() {
    var a;
    (a = T(l.inputRef)) == null || a.focus({ preventScroll: !0 });
  }
  return () => {
    let a = { open: l.comboboxState.value === 0, disabled: l.disabled.value }, { id: o, ...i } = e, s = { id: o, ref: l.labelRef, onClick: r };
    return q({ ourProps: s, theirProps: i, slot: a, attrs: t, slots: n, name: "ComboboxLabel" });
  };
} }), jt = D({ name: "ComboboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-combobox-button-${ae()}` } }, setup(e, { attrs: t, slots: n, expose: l }) {
  let r = rt("ComboboxButton");
  l({ el: r.buttonRef, $el: r.buttonRef });
  function a(s) {
    r.disabled.value || (r.comboboxState.value === 0 ? r.closeCombobox() : (s.preventDefault(), r.openCombobox()), ie(() => {
      var u;
      return (u = T(r.inputRef)) == null ? void 0 : u.focus({ preventScroll: !0 });
    }));
  }
  function o(s) {
    switch (s.key) {
      case B.ArrowDown:
        s.preventDefault(), s.stopPropagation(), r.comboboxState.value === 1 && r.openCombobox(), ie(() => {
          var u;
          return (u = r.inputRef.value) == null ? void 0 : u.focus({ preventScroll: !0 });
        });
        return;
      case B.ArrowUp:
        s.preventDefault(), s.stopPropagation(), r.comboboxState.value === 1 && (r.openCombobox(), ie(() => {
          r.value.value || r.goToOption(W.Last);
        })), ie(() => {
          var u;
          return (u = r.inputRef.value) == null ? void 0 : u.focus({ preventScroll: !0 });
        });
        return;
      case B.Escape:
        if (r.comboboxState.value !== 0)
          return;
        s.preventDefault(), r.optionsRef.value && !r.optionsPropsRef.value.static && s.stopPropagation(), r.closeCombobox(), ie(() => {
          var u;
          return (u = r.inputRef.value) == null ? void 0 : u.focus({ preventScroll: !0 });
        });
        return;
    }
  }
  let i = wt(S(() => ({ as: e.as, type: t.type })), r.buttonRef);
  return () => {
    var s, u;
    let c = { open: r.comboboxState.value === 0, disabled: r.disabled.value, value: r.value.value }, { id: d, ...f } = e, v = { ref: r.buttonRef, id: d, type: i.value, tabindex: "-1", "aria-haspopup": "listbox", "aria-controls": (s = T(r.optionsRef)) == null ? void 0 : s.id, "aria-expanded": r.disabled.value ? void 0 : r.comboboxState.value === 0, "aria-labelledby": r.labelRef.value ? [(u = T(r.labelRef)) == null ? void 0 : u.id, d].join(" ") : void 0, disabled: r.disabled.value === !0 ? !0 : void 0, onKeydown: o, onClick: a };
    return q({ ourProps: v, theirProps: f, slot: c, attrs: t, slots: n, name: "ComboboxButton" });
  };
} }), ja = D({ name: "ComboboxInput", props: { as: { type: [Object, String], default: "input" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, displayValue: { type: Function }, defaultValue: { type: String, default: void 0 }, id: { type: String, default: () => `headlessui-combobox-input-${ae()}` } }, emits: { change: (e) => !0 }, setup(e, { emit: t, attrs: n, slots: l, expose: r }) {
  let a = rt("ComboboxInput"), o = { value: !1 };
  r({ el: a.inputRef, $el: a.inputRef });
  let i = S(() => {
    var m;
    let h = a.value.value;
    return T(a.inputRef) ? typeof e.displayValue < "u" && h !== void 0 ? (m = e.displayValue(h)) != null ? m : "" : typeof h == "string" ? h : "" : "";
  });
  X(() => {
    se([i, a.comboboxState], ([m, h], [b, y]) => {
      if (o.value)
        return;
      let g = T(a.inputRef);
      g && (y === 0 && h === 1 || m !== b) && (g.value = m);
    }, { immediate: !0 }), se([a.comboboxState], ([m], [h]) => {
      if (m === 0 && h === 1) {
        let b = T(a.inputRef);
        if (!b)
          return;
        let y = b.value, { selectionStart: g, selectionEnd: x, selectionDirection: w } = b;
        b.value = "", b.value = y, w !== null ? b.setSelectionRange(g, x, w) : b.setSelectionRange(g, x);
      }
    });
  });
  let s = C(!1);
  function u() {
    s.value = !0;
  }
  function c() {
    setTimeout(() => {
      s.value = !1;
    });
  }
  function d(m) {
    switch (o.value = !0, m.key) {
      case B.Backspace:
      case B.Delete:
        if (a.mode.value !== 0 || !a.nullable.value)
          return;
        let h = m.currentTarget;
        requestAnimationFrame(() => {
          if (h.value === "") {
            a.change(null);
            let b = T(a.optionsRef);
            b && (b.scrollTop = 0), a.goToOption(W.Nothing);
          }
        });
        break;
      case B.Enter:
        if (o.value = !1, a.comboboxState.value !== 0 || s.value)
          return;
        if (m.preventDefault(), m.stopPropagation(), a.activeOptionIndex.value === null) {
          a.closeCombobox();
          return;
        }
        a.selectActiveOption(), a.mode.value === 0 && a.closeCombobox();
        break;
      case B.ArrowDown:
        return o.value = !1, m.preventDefault(), m.stopPropagation(), J(a.comboboxState.value, { [0]: () => a.goToOption(W.Next), [1]: () => a.openCombobox() });
      case B.ArrowUp:
        return o.value = !1, m.preventDefault(), m.stopPropagation(), J(a.comboboxState.value, { [0]: () => a.goToOption(W.Previous), [1]: () => {
          a.openCombobox(), ie(() => {
            a.value.value || a.goToOption(W.Last);
          });
        } });
      case B.Home:
        if (m.shiftKey)
          break;
        return o.value = !1, m.preventDefault(), m.stopPropagation(), a.goToOption(W.First);
      case B.PageUp:
        return o.value = !1, m.preventDefault(), m.stopPropagation(), a.goToOption(W.First);
      case B.End:
        if (m.shiftKey)
          break;
        return o.value = !1, m.preventDefault(), m.stopPropagation(), a.goToOption(W.Last);
      case B.PageDown:
        return o.value = !1, m.preventDefault(), m.stopPropagation(), a.goToOption(W.Last);
      case B.Escape:
        if (o.value = !1, a.comboboxState.value !== 0)
          return;
        m.preventDefault(), a.optionsRef.value && !a.optionsPropsRef.value.static && m.stopPropagation(), a.closeCombobox();
        break;
      case B.Tab:
        if (o.value = !1, a.comboboxState.value !== 0)
          return;
        a.mode.value === 0 && a.selectActiveOption(), a.closeCombobox();
        break;
    }
  }
  function f(m) {
    a.openCombobox(), t("change", m);
  }
  function v() {
    o.value = !1;
  }
  let p = S(() => {
    var m, h, b, y;
    return (y = (b = (h = e.defaultValue) != null ? h : a.defaultValue.value !== void 0 ? (m = e.displayValue) == null ? void 0 : m.call(e, a.defaultValue.value) : null) != null ? b : a.defaultValue.value) != null ? y : "";
  });
  return () => {
    var m, h, b, y, g, x;
    let w = { open: a.comboboxState.value === 0 }, { id: $, displayValue: E, onChange: O, ...P } = e, I = { "aria-controls": (m = a.optionsRef.value) == null ? void 0 : m.id, "aria-expanded": a.disabled.value ? void 0 : a.comboboxState.value === 0, "aria-activedescendant": a.activeOptionIndex.value === null || (h = a.options.value[a.activeOptionIndex.value]) == null ? void 0 : h.id, "aria-labelledby": (g = (b = T(a.labelRef)) == null ? void 0 : b.id) != null ? g : (y = T(a.buttonRef)) == null ? void 0 : y.id, "aria-autocomplete": "list", id: $, onCompositionstart: u, onCompositionend: c, onKeydown: d, onInput: f, onBlur: v, role: "combobox", type: (x = n.type) != null ? x : "text", tabIndex: 0, ref: a.inputRef, defaultValue: p.value };
    return q({ ourProps: I, theirProps: P, slot: w, attrs: n, slots: l, features: we.RenderStrategy | we.Static, name: "ComboboxInput" });
  };
} }), Ba = D({ name: "ComboboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, hold: { type: [Boolean], default: !1 } }, setup(e, { attrs: t, slots: n, expose: l }) {
  let r = rt("ComboboxOptions"), a = `headlessui-combobox-options-${ae()}`;
  l({ el: r.optionsRef, $el: r.optionsRef }), ce(() => {
    r.optionsPropsRef.value.static = e.static;
  }), ce(() => {
    r.optionsPropsRef.value.hold = e.hold;
  });
  let o = ze(), i = S(() => o !== null ? (o.value & ne.Open) === ne.Open : r.comboboxState.value === 0);
  return Ia({ container: S(() => T(r.optionsRef)), enabled: S(() => r.comboboxState.value === 0), accept(s) {
    return s.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : s.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(s) {
    s.setAttribute("role", "none");
  } }), () => {
    var s, u, c;
    let d = { open: r.comboboxState.value === 0 }, f = { "aria-labelledby": (c = (s = T(r.labelRef)) == null ? void 0 : s.id) != null ? c : (u = T(r.buttonRef)) == null ? void 0 : u.id, id: a, ref: r.optionsRef, role: "listbox", "aria-multiselectable": r.mode.value === 1 ? !0 : void 0 }, v = nt(e, ["hold"]);
    return q({ ourProps: f, theirProps: v, slot: d, attrs: t, slots: n, features: we.RenderStrategy | we.Static, visible: i.value, name: "ComboboxOptions" });
  };
} }), Na = D({ name: "ComboboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 } }, setup(e, { slots: t, attrs: n, expose: l }) {
  let r = rt("ComboboxOption"), a = `headlessui-combobox-option-${ae()}`, o = C(null);
  l({ el: o, $el: o });
  let i = S(() => r.activeOptionIndex.value !== null ? r.options.value[r.activeOptionIndex.value].id === a : !1), s = S(() => J(r.mode.value, { [0]: () => r.compare(ee(r.value.value), ee(e.value)), [1]: () => ee(r.value.value).some((h) => r.compare(ee(h), ee(e.value))) })), u = S(() => ({ disabled: e.disabled, value: e.value, domRef: o }));
  X(() => r.registerOption(a, u)), xe(() => r.unregisterOption(a)), ce(() => {
    r.comboboxState.value === 0 && i.value && r.activationTrigger.value !== 0 && ie(() => {
      var h, b;
      return (b = (h = T(o)) == null ? void 0 : h.scrollIntoView) == null ? void 0 : b.call(h, { block: "nearest" });
    });
  });
  function c(h) {
    if (e.disabled)
      return h.preventDefault();
    r.selectOption(a), r.mode.value === 0 && r.closeCombobox(), Uo() || requestAnimationFrame(() => {
      var b;
      return (b = T(r.inputRef)) == null ? void 0 : b.focus();
    });
  }
  function d() {
    if (e.disabled)
      return r.goToOption(W.Nothing);
    r.goToOption(W.Specific, a);
  }
  let f = ar();
  function v(h) {
    f.update(h);
  }
  function p(h) {
    f.wasMoved(h) && (e.disabled || i.value || r.goToOption(W.Specific, a, 0));
  }
  function m(h) {
    f.wasMoved(h) && (e.disabled || i.value && (r.optionsPropsRef.value.hold || r.goToOption(W.Nothing)));
  }
  return () => {
    let { disabled: h } = e, b = { active: i.value, selected: s.value, disabled: h }, y = { id: a, ref: o, role: "option", tabIndex: h === !0 ? void 0 : -1, "aria-disabled": h === !0 ? !0 : void 0, "aria-selected": s.value, disabled: void 0, onClick: c, onFocus: d, onPointerenter: v, onMouseenter: v, onPointermove: p, onMousemove: p, onPointerleave: m, onMouseleave: m };
    return q({ ourProps: y, theirProps: e, slot: b, attrs: n, slots: t, name: "ComboboxOption" });
  };
} });
function qo(e, t, n) {
  xt.isServer || ce((l) => {
    window.addEventListener(e, t, n), l(() => window.removeEventListener(e, t, n));
  });
}
var Se = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Se || {});
function lr() {
  let e = C(0);
  return qo("keydown", (t) => {
    t.key === "Tab" && (e.value = t.shiftKey ? 1 : 0);
  }), e;
}
function or(e, t, n, l) {
  xt.isServer || ce((r) => {
    e = e ?? window, e.addEventListener(t, n, l), r(() => e.removeEventListener(t, n, l));
  });
}
function za(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function Ua(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  if (typeof e == "function")
    return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let n of e.value) {
    let l = T(n);
    l instanceof HTMLElement && t.add(l);
  }
  return t;
}
var Ha = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(Ha || {});
let ct = Object.assign(D({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: C(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: l }) {
  let r = C(null);
  l({ el: r, $el: r });
  let a = S(() => Pe(r)), o = C(!1);
  X(() => o.value = !0), xe(() => o.value = !1), Jo({ ownerDocument: a }, S(() => o.value && !!(e.features & 16)));
  let i = Zo({ ownerDocument: a, container: r, initialFocus: S(() => e.initialFocus) }, S(() => o.value && !!(e.features & 2)));
  Qo({ ownerDocument: a, container: r, containers: e.containers, previousActiveElement: i }, S(() => o.value && !!(e.features & 8)));
  let s = lr();
  function u(v) {
    let p = T(r);
    p && ((m) => m())(() => {
      J(s.value, { [Se.Forwards]: () => {
        Oe(p, he.First, { skipElements: [v.relatedTarget] });
      }, [Se.Backwards]: () => {
        Oe(p, he.Last, { skipElements: [v.relatedTarget] });
      } });
    });
  }
  let c = C(!1);
  function d(v) {
    v.key === "Tab" && (c.value = !0, requestAnimationFrame(() => {
      c.value = !1;
    }));
  }
  function f(v) {
    if (!o.value)
      return;
    let p = Ua(e.containers);
    T(r) instanceof HTMLElement && p.add(T(r));
    let m = v.relatedTarget;
    m instanceof HTMLElement && m.dataset.headlessuiFocusGuard !== "true" && (Ga(p, m) || (c.value ? Oe(T(r), J(s.value, { [Se.Forwards]: () => he.Next, [Se.Backwards]: () => he.Previous }) | he.WrapAround, { relativeTo: v.target }) : v.target instanceof HTMLElement && je(v.target)));
  }
  return () => {
    let v = {}, p = { ref: r, onKeydown: d, onFocusout: f }, { features: m, initialFocus: h, containers: b, ...y } = e;
    return Y(pe, [!!(m & 4) && Y(Ve, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: u, features: ke.Focusable }), q({ ourProps: p, theirProps: { ...t, ...y }, slot: v, attrs: t, slots: n, name: "FocusTrap" }), !!(m & 4) && Y(Ve, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: u, features: ke.Focusable })]);
  };
} }), { features: Ha }), Ge = [];
if (typeof window < "u" && typeof document < "u") {
  let e = function(t) {
    t.target instanceof HTMLElement && t.target !== document.body && Ge[0] !== t.target && (Ge.unshift(t.target), Ge = Ge.filter((n) => n != null && n.isConnected), Ge.splice(10));
  };
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
}
function Yo(e) {
  let t = C(Ge.slice());
  return se([e], ([n], [l]) => {
    l === !0 && n === !1 ? za(() => {
      t.value.splice(0);
    }) : l === !1 && n === !0 && (t.value = Ge.slice());
  }, { flush: "post" }), () => {
    var n;
    return (n = t.value.find((l) => l != null && l.isConnected)) != null ? n : null;
  };
}
function Jo({ ownerDocument: e }, t) {
  let n = Yo(t);
  X(() => {
    ce(() => {
      var l, r;
      t.value || ((l = e.value) == null ? void 0 : l.activeElement) === ((r = e.value) == null ? void 0 : r.body) && je(n());
    }, { flush: "post" });
  }), xe(() => {
    je(n());
  });
}
function Zo({ ownerDocument: e, container: t, initialFocus: n }, l) {
  let r = C(null), a = C(!1);
  return X(() => a.value = !0), xe(() => a.value = !1), X(() => {
    se([t, n, l], (o, i) => {
      if (o.every((u, c) => (i == null ? void 0 : i[c]) === u) || !l.value)
        return;
      let s = T(t);
      s && za(() => {
        var u, c;
        if (!a.value)
          return;
        let d = T(n), f = (u = e.value) == null ? void 0 : u.activeElement;
        if (d) {
          if (d === f) {
            r.value = f;
            return;
          }
        } else if (s.contains(f)) {
          r.value = f;
          return;
        }
        d ? je(d) : Oe(s, he.First | he.NoScroll) === mt.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), r.value = (c = e.value) == null ? void 0 : c.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), r;
}
function Qo({ ownerDocument: e, container: t, containers: n, previousActiveElement: l }, r) {
  var a;
  or((a = e.value) == null ? void 0 : a.defaultView, "focus", (o) => {
    if (!r.value)
      return;
    let i = Ua(n);
    T(t) instanceof HTMLElement && i.add(T(t));
    let s = l.value;
    if (!s)
      return;
    let u = o.target;
    u && u instanceof HTMLElement ? Ga(i, u) ? (l.value = u, je(u)) : (o.preventDefault(), o.stopPropagation(), je(s)) : je(l.value);
  }, !0);
}
function Ga(e, t) {
  for (let n of e)
    if (n.contains(t))
      return !0;
  return !1;
}
let xn = /* @__PURE__ */ new Map(), dt = /* @__PURE__ */ new Map();
function Ar(e, t = C(!0)) {
  ce((n) => {
    var l;
    if (!t.value)
      return;
    let r = T(e);
    if (!r)
      return;
    n(function() {
      var o;
      if (!r)
        return;
      let i = (o = dt.get(r)) != null ? o : 1;
      if (i === 1 ? dt.delete(r) : dt.set(r, i - 1), i !== 1)
        return;
      let s = xn.get(r);
      s && (s["aria-hidden"] === null ? r.removeAttribute("aria-hidden") : r.setAttribute("aria-hidden", s["aria-hidden"]), r.inert = s.inert, xn.delete(r));
    });
    let a = (l = dt.get(r)) != null ? l : 0;
    dt.set(r, a + 1), a === 0 && (xn.set(r, { "aria-hidden": r.getAttribute("aria-hidden"), inert: r.inert }), r.setAttribute("aria-hidden", "true"), r.inert = !0);
  });
}
let Wa = Symbol("ForcePortalRootContext");
function Xo() {
  return me(Wa, !1);
}
let kn = D({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(e, { slots: t, attrs: n }) {
  return fe(Wa, e.force), () => {
    let { force: l, ...r } = e;
    return q({ theirProps: r, ourProps: {}, slot: {}, slots: t, attrs: n, name: "ForcePortalRoot" });
  };
} });
function ei(e) {
  let t = Pe(e);
  if (!t) {
    if (e === null)
      return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
  }
  let n = t.getElementById("headlessui-portal-root");
  if (n)
    return n;
  let l = t.createElement("div");
  return l.setAttribute("id", "headlessui-portal-root"), t.body.appendChild(l);
}
let ir = D({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: n }) {
  let l = C(null), r = S(() => Pe(l)), a = Xo(), o = me(Ka, null), i = C(a === !0 || o == null ? ei(l.value) : o.resolveTarget());
  return ce(() => {
    a || o != null && (i.value = o.resolveTarget());
  }), xe(() => {
    var s, u;
    let c = (s = r.value) == null ? void 0 : s.getElementById("headlessui-portal-root");
    c && i.value === c && i.value.children.length <= 0 && ((u = i.value.parentElement) == null || u.removeChild(i.value));
  }), () => {
    if (i.value === null)
      return null;
    let s = { ref: l, "data-headlessui-portal": "" };
    return Y(ho, { to: i.value }, q({ ourProps: s, theirProps: e, slot: {}, attrs: n, slots: t, name: "Portal" }));
  };
} }), Ka = Symbol("PortalGroupContext"), ti = D({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(e, { attrs: t, slots: n }) {
  let l = mo({ resolveTarget() {
    return e.target;
  } });
  return fe(Ka, l), () => {
    let { target: r, ...a } = e;
    return q({ theirProps: a, ourProps: {}, slot: {}, attrs: t, slots: n, name: "PortalGroup" });
  };
} }), qa = Symbol("StackContext");
var Dn = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(Dn || {});
function ni() {
  return me(qa, () => {
  });
}
function ri({ type: e, enabled: t, element: n, onUpdate: l }) {
  let r = ni();
  function a(...o) {
    l == null || l(...o), r(...o);
  }
  X(() => {
    se(t, (o, i) => {
      o ? a(0, e, n) : i === !0 && a(1, e, n);
    }, { immediate: !0, flush: "sync" });
  }), xe(() => {
    t.value && a(1, e, n);
  }), fe(qa, a);
}
let Ya = Symbol("DescriptionContext");
function ai() {
  let e = me(Ya, null);
  if (e === null)
    throw new Error("Missing parent");
  return e;
}
function Ja({ slot: e = C({}), name: t = "Description", props: n = {} } = {}) {
  let l = C([]);
  function r(a) {
    return l.value.push(a), () => {
      let o = l.value.indexOf(a);
      o !== -1 && l.value.splice(o, 1);
    };
  }
  return fe(Ya, { register: r, slot: e, name: t, props: n }), S(() => l.value.length > 0 ? l.value.join(" ") : void 0);
}
D({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: () => `headlessui-description-${ae()}` } }, setup(e, { attrs: t, slots: n }) {
  let l = ai();
  return X(() => xe(l.register(e.id))), () => {
    let { name: r = "Description", slot: a = C({}), props: o = {} } = l, { id: i, ...s } = e, u = { ...Object.entries(o).reduce((c, [d, f]) => Object.assign(c, { [d]: F(f) }), {}), id: i };
    return q({ ourProps: u, theirProps: s, slot: a.value, attrs: t, slots: n, name: r });
  };
} });
function li(e) {
  let t = Kt(e.getSnapshot());
  return xe(e.subscribe(() => {
    t.value = e.getSnapshot();
  })), t;
}
function Zt() {
  let e = [], t = { addEventListener(n, l, r, a) {
    return n.addEventListener(l, r, a), t.add(() => n.removeEventListener(l, r, a));
  }, requestAnimationFrame(...n) {
    let l = requestAnimationFrame(...n);
    t.add(() => cancelAnimationFrame(l));
  }, nextFrame(...n) {
    t.requestAnimationFrame(() => {
      t.requestAnimationFrame(...n);
    });
  }, setTimeout(...n) {
    let l = setTimeout(...n);
    t.add(() => clearTimeout(l));
  }, style(n, l, r) {
    let a = n.style.getPropertyValue(l);
    return Object.assign(n.style, { [l]: r }), this.add(() => {
      Object.assign(n.style, { [l]: a });
    });
  }, group(n) {
    let l = Zt();
    return n(l), this.add(() => l.dispose());
  }, add(n) {
    return e.push(n), () => {
      let l = e.indexOf(n);
      if (l >= 0)
        for (let r of e.splice(l, 1))
          r();
    };
  }, dispose() {
    for (let n of e.splice(0))
      n();
  } };
  return t;
}
function oi(e, t) {
  let n = e(), l = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return n;
  }, subscribe(r) {
    return l.add(r), () => l.delete(r);
  }, dispatch(r, ...a) {
    let o = t[r].call(n, ...a);
    o && (n = o, l.forEach((i) => i()));
  } };
}
function ii() {
  let e;
  return { before({ doc: t }) {
    var n;
    let l = t.documentElement;
    e = ((n = t.defaultView) != null ? n : window).innerWidth - l.clientWidth;
  }, after({ doc: t, d: n }) {
    let l = t.documentElement, r = l.clientWidth - l.offsetWidth, a = e - r;
    n.style(l, "paddingRight", `${a}px`);
  } };
}
function ui() {
  if (!Da())
    return {};
  let e;
  return { before() {
    e = window.pageYOffset;
  }, after({ doc: t, d: n, meta: l }) {
    function r(o) {
      return l.containers.flatMap((i) => i()).some((i) => i.contains(o));
    }
    n.style(t.body, "marginTop", `-${e}px`), window.scrollTo(0, 0);
    let a = null;
    n.addEventListener(t, "click", (o) => {
      if (o.target instanceof HTMLElement)
        try {
          let i = o.target.closest("a");
          if (!i)
            return;
          let { hash: s } = new URL(i.href), u = t.querySelector(s);
          u && !r(u) && (a = u);
        } catch {
        }
    }, !0), n.addEventListener(t, "touchmove", (o) => {
      o.target instanceof HTMLElement && !r(o.target) && o.preventDefault();
    }, { passive: !1 }), n.add(() => {
      window.scrollTo(0, window.pageYOffset + e), a && a.isConnected && (a.scrollIntoView({ block: "nearest" }), a = null);
    });
  } };
}
function si() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function ci(e) {
  let t = {};
  for (let n of e)
    Object.assign(t, n(t));
  return t;
}
let We = oi(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var n;
  let l = (n = this.get(e)) != null ? n : { doc: e, count: 0, d: Zt(), meta: /* @__PURE__ */ new Set() };
  return l.count++, l.meta.add(t), this.set(e, l), this;
}, POP(e, t) {
  let n = this.get(e);
  return n && (n.count--, n.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: n }) {
  let l = { doc: e, d: t, meta: ci(n) }, r = [ui(), ii(), si()];
  r.forEach(({ before: a }) => a == null ? void 0 : a(l)), r.forEach(({ after: a }) => a == null ? void 0 : a(l));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
We.subscribe(() => {
  let e = We.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [n] of e)
    t.set(n, n.documentElement.style.overflow);
  for (let n of e.values()) {
    let l = t.get(n.doc) === "hidden", r = n.count !== 0;
    (r && !l || !r && l) && We.dispatch(n.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n), n.count === 0 && We.dispatch("TEARDOWN", n);
  }
});
function di(e, t, n) {
  let l = li(We), r = S(() => {
    let a = e.value ? l.value.get(e.value) : void 0;
    return a ? a.count > 0 : !1;
  });
  return se([e, t], ([a, o], [i], s) => {
    if (!a || !o)
      return;
    We.dispatch("PUSH", a, n);
    let u = !1;
    s(() => {
      u || (We.dispatch("POP", i ?? a, n), u = !0);
    });
  }, { immediate: !0 }), r;
}
var fi = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(fi || {});
let Rn = Symbol("DialogContext");
function Ct(e) {
  let t = me(Rn, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Ct), n;
  }
  return t;
}
let It = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", vi = D({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: It }, initialFocus: { type: Object, default: null }, id: { type: String, default: () => `headlessui-dialog-${ae()}` } }, emits: { close: (e) => !0 }, setup(e, { emit: t, attrs: n, slots: l, expose: r }) {
  var a;
  let o = C(!1);
  X(() => {
    o.value = !0;
  });
  let i = C(0), s = ze(), u = S(() => e.open === It && s !== null ? (s.value & ne.Open) === ne.Open : e.open), c = C(null), d = C(null), f = S(() => Pe(c));
  if (r({ el: c, $el: c }), !(e.open !== It || s !== null))
    throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof u.value != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${u.value === It ? void 0 : e.open}`);
  let v = S(() => o.value && u.value ? 0 : 1), p = S(() => v.value === 0), m = S(() => i.value > 1), h = me(Rn, null) !== null, b = S(() => m.value ? "parent" : "leaf"), y = S(() => s !== null ? (s.value & ne.Closing) === ne.Closing : !1), g = S(() => h || y.value ? !1 : p.value), x = S(() => {
    var k, U, G;
    return (G = Array.from((U = (k = f.value) == null ? void 0 : k.querySelectorAll("body > *")) != null ? U : []).find((te) => te.id === "headlessui-portal-root" ? !1 : te.contains(T(d)) && te instanceof HTMLElement)) != null ? G : null;
  });
  Ar(x, g);
  let w = S(() => m.value ? !0 : p.value), $ = S(() => {
    var k, U, G;
    return (G = Array.from((U = (k = f.value) == null ? void 0 : k.querySelectorAll("[data-headlessui-portal]")) != null ? U : []).find((te) => te.contains(T(d)) && te instanceof HTMLElement)) != null ? G : null;
  });
  Ar($, w), ri({ type: "Dialog", enabled: S(() => v.value === 0), element: c, onUpdate: (k, U) => {
    if (U === "Dialog")
      return J(k, { [Dn.Add]: () => i.value += 1, [Dn.Remove]: () => i.value -= 1 });
  } });
  let E = Ja({ name: "DialogDescription", slot: S(() => ({ open: u.value })) }), O = C(null), P = { titleId: O, panelRef: C(null), dialogState: v, setTitleId(k) {
    O.value !== k && (O.value = k);
  }, close() {
    t("close", !1);
  } };
  fe(Rn, P);
  function I() {
    var k, U, G;
    return [...Array.from((U = (k = f.value) == null ? void 0 : k.querySelectorAll("html > *, body > *, [data-headlessui-portal]")) != null ? U : []).filter((te) => !(te === document.body || te === document.head || !(te instanceof HTMLElement) || te.contains(T(d)) || P.panelRef.value && te.contains(P.panelRef.value))), (G = P.panelRef.value) != null ? G : c.value];
  }
  let L = S(() => !(!p.value || m.value));
  Ot(() => I(), (k, U) => {
    P.close(), ie(() => U == null ? void 0 : U.focus());
  }, L);
  let M = S(() => !(m.value || v.value !== 0));
  or((a = f.value) == null ? void 0 : a.defaultView, "keydown", (k) => {
    M.value && (k.defaultPrevented || k.key === B.Escape && (k.preventDefault(), k.stopPropagation(), P.close()));
  });
  let j = S(() => !(y.value || v.value !== 0 || h));
  return di(f, j, (k) => {
    var U;
    return { containers: [...(U = k.containers) != null ? U : [], I] };
  }), ce((k) => {
    if (v.value !== 0)
      return;
    let U = T(c);
    if (!U)
      return;
    let G = new ResizeObserver((te) => {
      for (let $e of te) {
        let ve = $e.target.getBoundingClientRect();
        ve.x === 0 && ve.y === 0 && ve.width === 0 && ve.height === 0 && P.close();
      }
    });
    G.observe(U), k(() => G.disconnect());
  }), () => {
    let { id: k, open: U, initialFocus: G, ...te } = e, $e = { ...n, ref: c, id: k, role: "dialog", "aria-modal": v.value === 0 ? !0 : void 0, "aria-labelledby": O.value, "aria-describedby": E.value }, ve = { open: v.value === 0 };
    return Y(kn, { force: !0 }, () => [Y(ir, () => Y(ti, { target: c.value }, () => Y(kn, { force: !1 }, () => Y(ct, { initialFocus: G, containers: I, features: p.value ? J(b.value, { parent: ct.features.RestoreFocus, leaf: ct.features.All & ~ct.features.FocusLock }) : ct.features.None }, () => q({ ourProps: $e, theirProps: te, slot: ve, attrs: n, slots: l, visible: v.value === 0, features: we.RenderStrategy | we.Static, name: "Dialog" }))))), Y(Ve, { features: ke.Hidden, ref: d })]);
  };
} });
D({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: () => `headlessui-dialog-overlay-${ae()}` } }, setup(e, { attrs: t, slots: n }) {
  let l = Ct("DialogOverlay");
  function r(a) {
    a.target === a.currentTarget && (a.preventDefault(), a.stopPropagation(), l.close());
  }
  return () => {
    let { id: a, ...o } = e;
    return q({ ourProps: { id: a, "aria-hidden": !0, onClick: r }, theirProps: o, slot: { open: l.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogOverlay" });
  };
} });
D({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: () => `headlessui-dialog-backdrop-${ae()}` } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: l }) {
  let r = Ct("DialogBackdrop"), a = C(null);
  return l({ el: a, $el: a }), X(() => {
    if (r.panelRef.value === null)
      throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { id: o, ...i } = e, s = { id: o, ref: a, "aria-hidden": !0 };
    return Y(kn, { force: !0 }, () => Y(ir, () => q({ ourProps: s, theirProps: { ...t, ...i }, slot: { open: r.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogBackdrop" })));
  };
} });
let pi = D({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: () => `headlessui-dialog-panel-${ae()}` } }, setup(e, { attrs: t, slots: n, expose: l }) {
  let r = Ct("DialogPanel");
  l({ el: r.panelRef, $el: r.panelRef });
  function a(o) {
    o.stopPropagation();
  }
  return () => {
    let { id: o, ...i } = e, s = { id: o, ref: r.panelRef, onClick: a };
    return q({ ourProps: s, theirProps: i, slot: { open: r.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogPanel" });
  };
} }), hi = D({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: () => `headlessui-dialog-title-${ae()}` } }, setup(e, { attrs: t, slots: n }) {
  let l = Ct("DialogTitle");
  return X(() => {
    l.setTitleId(e.id), xe(() => l.setTitleId(null));
  }), () => {
    let { id: r, ...a } = e;
    return q({ ourProps: { id: r }, theirProps: a, slot: { open: l.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogTitle" });
  };
} });
function mi(e, t) {
  return e === t;
}
var bi = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(bi || {}), yi = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(yi || {}), gi = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(gi || {});
function wi(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let Za = Symbol("ListboxContext");
function At(e) {
  let t = me(Za, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, At), n;
  }
  return t;
}
let Qa = D({ name: "Listbox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => mi }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: t, attrs: n, emit: l }) {
  let r = C(1), a = C(null), o = C(null), i = C(null), s = C([]), u = C(""), c = C(null), d = C(1);
  function f(y = (g) => g) {
    let g = c.value !== null ? s.value[c.value] : null, x = Jt(y(s.value.slice()), ($) => T($.dataRef.domRef)), w = g ? x.indexOf(g) : null;
    return w === -1 && (w = null), { options: x, activeOptionIndex: w };
  }
  let v = S(() => e.multiple ? 1 : 0), [p, m] = rr(S(() => e.modelValue === void 0 ? J(v.value, { [1]: [], [0]: void 0 }) : e.modelValue), (y) => l("update:modelValue", y), S(() => e.defaultValue)), h = { listboxState: r, value: p, mode: v, compare(y, g) {
    if (typeof e.by == "string") {
      let x = e.by;
      return (y == null ? void 0 : y[x]) === (g == null ? void 0 : g[x]);
    }
    return e.by(y, g);
  }, orientation: S(() => e.horizontal ? "horizontal" : "vertical"), labelRef: a, buttonRef: o, optionsRef: i, disabled: S(() => e.disabled), options: s, searchQuery: u, activeOptionIndex: c, activationTrigger: d, closeListbox() {
    e.disabled || r.value !== 1 && (r.value = 1, c.value = null);
  }, openListbox() {
    e.disabled || r.value !== 0 && (r.value = 0);
  }, goToOption(y, g, x) {
    if (e.disabled || r.value === 1)
      return;
    let w = f(), $ = tr(y === W.Specific ? { focus: W.Specific, id: g } : { focus: y }, { resolveItems: () => w.options, resolveActiveIndex: () => w.activeOptionIndex, resolveId: (E) => E.id, resolveDisabled: (E) => E.dataRef.disabled });
    u.value = "", c.value = $, d.value = x ?? 1, s.value = w.options;
  }, search(y) {
    if (e.disabled || r.value === 1)
      return;
    let g = u.value !== "" ? 0 : 1;
    u.value += y.toLowerCase();
    let x = (c.value !== null ? s.value.slice(c.value + g).concat(s.value.slice(0, c.value + g)) : s.value).find(($) => $.dataRef.textValue.startsWith(u.value) && !$.dataRef.disabled), w = x ? s.value.indexOf(x) : -1;
    w === -1 || w === c.value || (c.value = w, d.value = 1);
  }, clearSearch() {
    e.disabled || r.value !== 1 && u.value !== "" && (u.value = "");
  }, registerOption(y, g) {
    let x = f((w) => [...w, { id: y, dataRef: g }]);
    s.value = x.options, c.value = x.activeOptionIndex;
  }, unregisterOption(y) {
    let g = f((x) => {
      let w = x.findIndex(($) => $.id === y);
      return w !== -1 && x.splice(w, 1), x;
    });
    s.value = g.options, c.value = g.activeOptionIndex, d.value = 1;
  }, select(y) {
    e.disabled || m(J(v.value, { [0]: () => y, [1]: () => {
      let g = ee(h.value.value).slice(), x = ee(y), w = g.findIndex(($) => h.compare(x, ee($)));
      return w === -1 ? g.push(x) : g.splice(w, 1), g;
    } }));
  } };
  Ot([o, i], (y, g) => {
    var x;
    h.closeListbox(), Tt(g, St.Loose) || (y.preventDefault(), (x = T(o)) == null || x.focus());
  }, S(() => r.value === 0)), fe(Za, h), gt(S(() => J(r.value, { [0]: ne.Open, [1]: ne.Closed })));
  let b = S(() => {
    var y;
    return (y = T(o)) == null ? void 0 : y.closest("form");
  });
  return X(() => {
    se([b], () => {
      if (!b.value || e.defaultValue === void 0)
        return;
      function y() {
        h.select(e.defaultValue);
      }
      return b.value.addEventListener("reset", y), () => {
        var g;
        (g = b.value) == null || g.removeEventListener("reset", y);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: y, modelValue: g, disabled: x, ...w } = e, $ = { open: r.value === 0, disabled: x, value: p.value };
    return Y(pe, [...y != null && p.value != null ? nr({ [y]: p.value }).map(([E, O]) => Y(Ve, er({ features: ke.Hidden, key: E, as: "input", type: "hidden", hidden: !0, readOnly: !0, name: E, value: O }))) : [], q({ ourProps: {}, theirProps: { ...n, ...nt(w, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: $, slots: t, attrs: n, name: "Listbox" })]);
  };
} }), Xa = D({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: () => `headlessui-listbox-label-${ae()}` } }, setup(e, { attrs: t, slots: n }) {
  let l = At("ListboxLabel");
  function r() {
    var a;
    (a = T(l.buttonRef)) == null || a.focus({ preventScroll: !0 });
  }
  return () => {
    let a = { open: l.listboxState.value === 0, disabled: l.disabled.value }, { id: o, ...i } = e, s = { id: o, ref: l.labelRef, onClick: r };
    return q({ ourProps: s, theirProps: i, slot: a, attrs: t, slots: n, name: "ListboxLabel" });
  };
} }), el = D({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-listbox-button-${ae()}` } }, setup(e, { attrs: t, slots: n, expose: l }) {
  let r = At("ListboxButton");
  l({ el: r.buttonRef, $el: r.buttonRef });
  function a(u) {
    switch (u.key) {
      case B.Space:
      case B.Enter:
      case B.ArrowDown:
        u.preventDefault(), r.openListbox(), ie(() => {
          var c;
          (c = T(r.optionsRef)) == null || c.focus({ preventScroll: !0 }), r.value.value || r.goToOption(W.First);
        });
        break;
      case B.ArrowUp:
        u.preventDefault(), r.openListbox(), ie(() => {
          var c;
          (c = T(r.optionsRef)) == null || c.focus({ preventScroll: !0 }), r.value.value || r.goToOption(W.Last);
        });
        break;
    }
  }
  function o(u) {
    switch (u.key) {
      case B.Space:
        u.preventDefault();
        break;
    }
  }
  function i(u) {
    r.disabled.value || (r.listboxState.value === 0 ? (r.closeListbox(), ie(() => {
      var c;
      return (c = T(r.buttonRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
    })) : (u.preventDefault(), r.openListbox(), wi(() => {
      var c;
      return (c = T(r.optionsRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
    })));
  }
  let s = wt(S(() => ({ as: e.as, type: t.type })), r.buttonRef);
  return () => {
    var u, c;
    let d = { open: r.listboxState.value === 0, disabled: r.disabled.value, value: r.value.value }, { id: f, ...v } = e, p = { ref: r.buttonRef, id: f, type: s.value, "aria-haspopup": "listbox", "aria-controls": (u = T(r.optionsRef)) == null ? void 0 : u.id, "aria-expanded": r.disabled.value ? void 0 : r.listboxState.value === 0, "aria-labelledby": r.labelRef.value ? [(c = T(r.labelRef)) == null ? void 0 : c.id, f].join(" ") : void 0, disabled: r.disabled.value === !0 ? !0 : void 0, onKeydown: a, onKeyup: o, onClick: i };
    return q({ ourProps: p, theirProps: v, slot: d, attrs: t, slots: n, name: "ListboxButton" });
  };
} }), tl = D({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: () => `headlessui-listbox-options-${ae()}` } }, setup(e, { attrs: t, slots: n, expose: l }) {
  let r = At("ListboxOptions"), a = C(null);
  l({ el: r.optionsRef, $el: r.optionsRef });
  function o(u) {
    switch (a.value && clearTimeout(a.value), u.key) {
      case B.Space:
        if (r.searchQuery.value !== "")
          return u.preventDefault(), u.stopPropagation(), r.search(u.key);
      case B.Enter:
        if (u.preventDefault(), u.stopPropagation(), r.activeOptionIndex.value !== null) {
          let c = r.options.value[r.activeOptionIndex.value];
          r.select(c.dataRef.value);
        }
        r.mode.value === 0 && (r.closeListbox(), ie(() => {
          var c;
          return (c = T(r.buttonRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
        }));
        break;
      case J(r.orientation.value, { vertical: B.ArrowDown, horizontal: B.ArrowRight }):
        return u.preventDefault(), u.stopPropagation(), r.goToOption(W.Next);
      case J(r.orientation.value, { vertical: B.ArrowUp, horizontal: B.ArrowLeft }):
        return u.preventDefault(), u.stopPropagation(), r.goToOption(W.Previous);
      case B.Home:
      case B.PageUp:
        return u.preventDefault(), u.stopPropagation(), r.goToOption(W.First);
      case B.End:
      case B.PageDown:
        return u.preventDefault(), u.stopPropagation(), r.goToOption(W.Last);
      case B.Escape:
        u.preventDefault(), u.stopPropagation(), r.closeListbox(), ie(() => {
          var c;
          return (c = T(r.buttonRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
        });
        break;
      case B.Tab:
        u.preventDefault(), u.stopPropagation();
        break;
      default:
        u.key.length === 1 && (r.search(u.key), a.value = setTimeout(() => r.clearSearch(), 350));
        break;
    }
  }
  let i = ze(), s = S(() => i !== null ? (i.value & ne.Open) === ne.Open : r.listboxState.value === 0);
  return () => {
    var u, c, d, f;
    let v = { open: r.listboxState.value === 0 }, { id: p, ...m } = e, h = { "aria-activedescendant": r.activeOptionIndex.value === null || (u = r.options.value[r.activeOptionIndex.value]) == null ? void 0 : u.id, "aria-multiselectable": r.mode.value === 1 ? !0 : void 0, "aria-labelledby": (f = (c = T(r.labelRef)) == null ? void 0 : c.id) != null ? f : (d = T(r.buttonRef)) == null ? void 0 : d.id, "aria-orientation": r.orientation.value, id: p, onKeydown: o, role: "listbox", tabIndex: 0, ref: r.optionsRef };
    return q({ ourProps: h, theirProps: m, slot: v, attrs: t, slots: n, features: we.RenderStrategy | we.Static, visible: s.value, name: "ListboxOptions" });
  };
} }), nl = D({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-listbox.option-${ae()}` } }, setup(e, { slots: t, attrs: n, expose: l }) {
  let r = At("ListboxOption"), a = C(null);
  l({ el: a, $el: a });
  let o = S(() => r.activeOptionIndex.value !== null ? r.options.value[r.activeOptionIndex.value].id === e.id : !1), i = S(() => J(r.mode.value, { [0]: () => r.compare(ee(r.value.value), ee(e.value)), [1]: () => ee(r.value.value).some((h) => r.compare(ee(h), ee(e.value))) })), s = S(() => J(r.mode.value, { [1]: () => {
    var h;
    let b = ee(r.value.value);
    return ((h = r.options.value.find((y) => b.some((g) => r.compare(ee(g), ee(y.dataRef.value))))) == null ? void 0 : h.id) === e.id;
  }, [0]: () => i.value })), u = S(() => ({ disabled: e.disabled, value: e.value, textValue: "", domRef: a }));
  X(() => {
    var h, b;
    let y = (b = (h = T(a)) == null ? void 0 : h.textContent) == null ? void 0 : b.toLowerCase().trim();
    y !== void 0 && (u.value.textValue = y);
  }), X(() => r.registerOption(e.id, u)), xe(() => r.unregisterOption(e.id)), X(() => {
    se([r.listboxState, i], () => {
      r.listboxState.value === 0 && i.value && J(r.mode.value, { [1]: () => {
        s.value && r.goToOption(W.Specific, e.id);
      }, [0]: () => {
        r.goToOption(W.Specific, e.id);
      } });
    }, { immediate: !0 });
  }), ce(() => {
    r.listboxState.value === 0 && o.value && r.activationTrigger.value !== 0 && ie(() => {
      var h, b;
      return (b = (h = T(a)) == null ? void 0 : h.scrollIntoView) == null ? void 0 : b.call(h, { block: "nearest" });
    });
  });
  function c(h) {
    if (e.disabled)
      return h.preventDefault();
    r.select(e.value), r.mode.value === 0 && (r.closeListbox(), ie(() => {
      var b;
      return (b = T(r.buttonRef)) == null ? void 0 : b.focus({ preventScroll: !0 });
    }));
  }
  function d() {
    if (e.disabled)
      return r.goToOption(W.Nothing);
    r.goToOption(W.Specific, e.id);
  }
  let f = ar();
  function v(h) {
    f.update(h);
  }
  function p(h) {
    f.wasMoved(h) && (e.disabled || o.value || r.goToOption(W.Specific, e.id, 0));
  }
  function m(h) {
    f.wasMoved(h) && (e.disabled || o.value && r.goToOption(W.Nothing));
  }
  return () => {
    let { disabled: h } = e, b = { active: o.value, selected: i.value, disabled: h }, { id: y, value: g, disabled: x, ...w } = e, $ = { id: y, ref: a, role: "option", tabIndex: h === !0 ? void 0 : -1, "aria-disabled": h === !0 ? !0 : void 0, "aria-selected": i.value, disabled: void 0, onClick: c, onFocus: d, onPointerenter: v, onMouseenter: v, onPointermove: p, onMousemove: p, onPointerleave: m, onMouseleave: m };
    return q({ ourProps: $, theirProps: w, slot: b, attrs: n, slots: t, name: "ListboxOption" });
  };
} });
var xi = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(xi || {}), $i = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))($i || {});
function Si(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let rl = Symbol("MenuContext");
function Qt(e) {
  let t = me(rl, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Qt), n;
  }
  return t;
}
let Ti = D({ name: "Menu", props: { as: { type: [Object, String], default: "template" } }, setup(e, { slots: t, attrs: n }) {
  let l = C(1), r = C(null), a = C(null), o = C([]), i = C(""), s = C(null), u = C(1);
  function c(f = (v) => v) {
    let v = s.value !== null ? o.value[s.value] : null, p = Jt(f(o.value.slice()), (h) => T(h.dataRef.domRef)), m = v ? p.indexOf(v) : null;
    return m === -1 && (m = null), { items: p, activeItemIndex: m };
  }
  let d = { menuState: l, buttonRef: r, itemsRef: a, items: o, searchQuery: i, activeItemIndex: s, activationTrigger: u, closeMenu: () => {
    l.value = 1, s.value = null;
  }, openMenu: () => l.value = 0, goToItem(f, v, p) {
    let m = c(), h = tr(f === W.Specific ? { focus: W.Specific, id: v } : { focus: f }, { resolveItems: () => m.items, resolveActiveIndex: () => m.activeItemIndex, resolveId: (b) => b.id, resolveDisabled: (b) => b.dataRef.disabled });
    i.value = "", s.value = h, u.value = p ?? 1, o.value = m.items;
  }, search(f) {
    let v = i.value !== "" ? 0 : 1;
    i.value += f.toLowerCase();
    let p = (s.value !== null ? o.value.slice(s.value + v).concat(o.value.slice(0, s.value + v)) : o.value).find((h) => h.dataRef.textValue.startsWith(i.value) && !h.dataRef.disabled), m = p ? o.value.indexOf(p) : -1;
    m === -1 || m === s.value || (s.value = m, u.value = 1);
  }, clearSearch() {
    i.value = "";
  }, registerItem(f, v) {
    let p = c((m) => [...m, { id: f, dataRef: v }]);
    o.value = p.items, s.value = p.activeItemIndex, u.value = 1;
  }, unregisterItem(f) {
    let v = c((p) => {
      let m = p.findIndex((h) => h.id === f);
      return m !== -1 && p.splice(m, 1), p;
    });
    o.value = v.items, s.value = v.activeItemIndex, u.value = 1;
  } };
  return Ot([r, a], (f, v) => {
    var p;
    d.closeMenu(), Tt(v, St.Loose) || (f.preventDefault(), (p = T(r)) == null || p.focus());
  }, S(() => l.value === 0)), fe(rl, d), gt(S(() => J(l.value, { [0]: ne.Open, [1]: ne.Closed }))), () => {
    let f = { open: l.value === 0, close: d.closeMenu };
    return q({ ourProps: {}, theirProps: e, slot: f, slots: t, attrs: n, name: "Menu" });
  };
} }), Oi = D({ name: "MenuButton", props: { disabled: { type: Boolean, default: !1 }, as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-menu-button-${ae()}` } }, setup(e, { attrs: t, slots: n, expose: l }) {
  let r = Qt("MenuButton");
  l({ el: r.buttonRef, $el: r.buttonRef });
  function a(u) {
    switch (u.key) {
      case B.Space:
      case B.Enter:
      case B.ArrowDown:
        u.preventDefault(), u.stopPropagation(), r.openMenu(), ie(() => {
          var c;
          (c = T(r.itemsRef)) == null || c.focus({ preventScroll: !0 }), r.goToItem(W.First);
        });
        break;
      case B.ArrowUp:
        u.preventDefault(), u.stopPropagation(), r.openMenu(), ie(() => {
          var c;
          (c = T(r.itemsRef)) == null || c.focus({ preventScroll: !0 }), r.goToItem(W.Last);
        });
        break;
    }
  }
  function o(u) {
    switch (u.key) {
      case B.Space:
        u.preventDefault();
        break;
    }
  }
  function i(u) {
    e.disabled || (r.menuState.value === 0 ? (r.closeMenu(), ie(() => {
      var c;
      return (c = T(r.buttonRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
    })) : (u.preventDefault(), r.openMenu(), Si(() => {
      var c;
      return (c = T(r.itemsRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
    })));
  }
  let s = wt(S(() => ({ as: e.as, type: t.type })), r.buttonRef);
  return () => {
    var u;
    let c = { open: r.menuState.value === 0 }, { id: d, ...f } = e, v = { ref: r.buttonRef, id: d, type: s.value, "aria-haspopup": "menu", "aria-controls": (u = T(r.itemsRef)) == null ? void 0 : u.id, "aria-expanded": e.disabled ? void 0 : r.menuState.value === 0, onKeydown: a, onKeyup: o, onClick: i };
    return q({ ourProps: v, theirProps: f, slot: c, attrs: t, slots: n, name: "MenuButton" });
  };
} }), Ci = D({ name: "MenuItems", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: () => `headlessui-menu-items-${ae()}` } }, setup(e, { attrs: t, slots: n, expose: l }) {
  let r = Qt("MenuItems"), a = C(null);
  l({ el: r.itemsRef, $el: r.itemsRef }), Ia({ container: S(() => T(r.itemsRef)), enabled: S(() => r.menuState.value === 0), accept(c) {
    return c.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : c.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(c) {
    c.setAttribute("role", "none");
  } });
  function o(c) {
    var d;
    switch (a.value && clearTimeout(a.value), c.key) {
      case B.Space:
        if (r.searchQuery.value !== "")
          return c.preventDefault(), c.stopPropagation(), r.search(c.key);
      case B.Enter:
        if (c.preventDefault(), c.stopPropagation(), r.activeItemIndex.value !== null) {
          let f = r.items.value[r.activeItemIndex.value];
          (d = T(f.dataRef.domRef)) == null || d.click();
        }
        r.closeMenu(), _a(T(r.buttonRef));
        break;
      case B.ArrowDown:
        return c.preventDefault(), c.stopPropagation(), r.goToItem(W.Next);
      case B.ArrowUp:
        return c.preventDefault(), c.stopPropagation(), r.goToItem(W.Previous);
      case B.Home:
      case B.PageUp:
        return c.preventDefault(), c.stopPropagation(), r.goToItem(W.First);
      case B.End:
      case B.PageDown:
        return c.preventDefault(), c.stopPropagation(), r.goToItem(W.Last);
      case B.Escape:
        c.preventDefault(), c.stopPropagation(), r.closeMenu(), ie(() => {
          var f;
          return (f = T(r.buttonRef)) == null ? void 0 : f.focus({ preventScroll: !0 });
        });
        break;
      case B.Tab:
        c.preventDefault(), c.stopPropagation(), r.closeMenu(), ie(() => Bo(T(r.buttonRef), c.shiftKey ? he.Previous : he.Next));
        break;
      default:
        c.key.length === 1 && (r.search(c.key), a.value = setTimeout(() => r.clearSearch(), 350));
        break;
    }
  }
  function i(c) {
    switch (c.key) {
      case B.Space:
        c.preventDefault();
        break;
    }
  }
  let s = ze(), u = S(() => s !== null ? (s.value & ne.Open) === ne.Open : r.menuState.value === 0);
  return () => {
    var c, d;
    let f = { open: r.menuState.value === 0 }, { id: v, ...p } = e, m = { "aria-activedescendant": r.activeItemIndex.value === null || (c = r.items.value[r.activeItemIndex.value]) == null ? void 0 : c.id, "aria-labelledby": (d = T(r.buttonRef)) == null ? void 0 : d.id, id: v, onKeydown: o, onKeyup: i, role: "menu", tabIndex: 0, ref: r.itemsRef };
    return q({ ourProps: m, theirProps: p, slot: f, attrs: t, slots: n, features: we.RenderStrategy | we.Static, visible: u.value, name: "MenuItems" });
  };
} }), Ai = D({ name: "MenuItem", inheritAttrs: !1, props: { as: { type: [Object, String], default: "template" }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-menu-item-${ae()}` } }, setup(e, { slots: t, attrs: n, expose: l }) {
  let r = Qt("MenuItem"), a = C(null);
  l({ el: a, $el: a });
  let o = S(() => r.activeItemIndex.value !== null ? r.items.value[r.activeItemIndex.value].id === e.id : !1), i = S(() => ({ disabled: e.disabled, textValue: "", domRef: a }));
  X(() => {
    var p, m;
    let h = (m = (p = T(a)) == null ? void 0 : p.textContent) == null ? void 0 : m.toLowerCase().trim();
    h !== void 0 && (i.value.textValue = h);
  }), X(() => r.registerItem(e.id, i)), xe(() => r.unregisterItem(e.id)), ce(() => {
    r.menuState.value === 0 && o.value && r.activationTrigger.value !== 0 && ie(() => {
      var p, m;
      return (m = (p = T(a)) == null ? void 0 : p.scrollIntoView) == null ? void 0 : m.call(p, { block: "nearest" });
    });
  });
  function s(p) {
    if (e.disabled)
      return p.preventDefault();
    r.closeMenu(), _a(T(r.buttonRef));
  }
  function u() {
    if (e.disabled)
      return r.goToItem(W.Nothing);
    r.goToItem(W.Specific, e.id);
  }
  let c = ar();
  function d(p) {
    c.update(p);
  }
  function f(p) {
    c.wasMoved(p) && (e.disabled || o.value || r.goToItem(W.Specific, e.id, 0));
  }
  function v(p) {
    c.wasMoved(p) && (e.disabled || o.value && r.goToItem(W.Nothing));
  }
  return () => {
    let { disabled: p } = e, m = { active: o.value, disabled: p, close: r.closeMenu }, { id: h, ...b } = e;
    return q({ ourProps: { id: h, ref: a, role: "menuitem", tabIndex: p === !0 ? void 0 : -1, "aria-disabled": p === !0 ? !0 : void 0, disabled: void 0, onClick: s, onFocus: u, onPointerenter: d, onMouseenter: d, onPointermove: f, onMousemove: f, onPointerleave: v, onMouseleave: v }, theirProps: { ...n, ...b }, slot: m, attrs: n, slots: t, name: "MenuItem" });
  };
} });
var Ei = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Ei || {});
let al = Symbol("PopoverContext");
function Xt(e) {
  let t = me(al, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <${ul.name} /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Xt), n;
  }
  return t;
}
let ll = Symbol("PopoverGroupContext");
function ol() {
  return me(ll, null);
}
let il = Symbol("PopoverPanelContext");
function Pi() {
  return me(il, null);
}
let ul = D({ name: "Popover", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: n, expose: l }) {
  var r;
  let a = C(null);
  l({ el: a, $el: a });
  let o = C(1), i = C(null), s = C(null), u = C(null), c = C(null), d = S(() => Pe(a)), f = S(() => {
    var y, g;
    if (!T(i) || !T(c))
      return !1;
    for (let I of document.querySelectorAll("body > *"))
      if (Number(I == null ? void 0 : I.contains(T(i))) ^ Number(I == null ? void 0 : I.contains(T(c))))
        return !0;
    let x = $t(), w = x.indexOf(T(i)), $ = (w + x.length - 1) % x.length, E = (w + 1) % x.length, O = x[$], P = x[E];
    return !((y = T(c)) != null && y.contains(O)) && !((g = T(c)) != null && g.contains(P));
  }), v = { popoverState: o, buttonId: C(null), panelId: C(null), panel: c, button: i, isPortalled: f, beforePanelSentinel: s, afterPanelSentinel: u, togglePopover() {
    o.value = J(o.value, { [0]: 1, [1]: 0 });
  }, closePopover() {
    o.value !== 1 && (o.value = 1);
  }, close(y) {
    v.closePopover();
    let g = (() => y ? y instanceof HTMLElement ? y : y.value instanceof HTMLElement ? T(y) : T(v.button) : T(v.button))();
    g == null || g.focus();
  } };
  fe(al, v), gt(S(() => J(o.value, { [0]: ne.Open, [1]: ne.Closed })));
  let p = { buttonId: v.buttonId, panelId: v.panelId, close() {
    v.closePopover();
  } }, m = ol(), h = m == null ? void 0 : m.registerPopover;
  function b() {
    var y, g, x, w;
    return (w = m == null ? void 0 : m.isFocusWithinPopoverGroup()) != null ? w : ((y = d.value) == null ? void 0 : y.activeElement) && (((g = T(i)) == null ? void 0 : g.contains(d.value.activeElement)) || ((x = T(c)) == null ? void 0 : x.contains(d.value.activeElement)));
  }
  return ce(() => h == null ? void 0 : h(p)), or((r = d.value) == null ? void 0 : r.defaultView, "focus", (y) => {
    var g, x;
    o.value === 0 && (b() || i && c && y.target !== window && ((g = T(v.beforePanelSentinel)) != null && g.contains(y.target) || (x = T(v.afterPanelSentinel)) != null && x.contains(y.target) || v.closePopover()));
  }, !0), Ot([i, c], (y, g) => {
    var x;
    v.closePopover(), Tt(g, St.Loose) || (y.preventDefault(), (x = T(i)) == null || x.focus());
  }, S(() => o.value === 0)), () => {
    let y = { open: o.value === 0, close: v.close };
    return q({ theirProps: e, ourProps: { ref: a }, slot: y, slots: t, attrs: n, name: "Popover" });
  };
} }), Fi = D({ name: "PopoverButton", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: () => `headlessui-popover-button-${ae()}` } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: l }) {
  let r = Xt("PopoverButton"), a = S(() => Pe(r.button));
  l({ el: r.button, $el: r.button }), X(() => {
    r.buttonId.value = e.id;
  }), xe(() => {
    r.buttonId.value = null;
  });
  let o = ol(), i = o == null ? void 0 : o.closeOthers, s = Pi(), u = S(() => s === null ? !1 : s.value === r.panelId.value), c = C(null), d = `headlessui-focus-sentinel-${ae()}`;
  u.value || ce(() => {
    r.button.value = c.value;
  });
  let f = wt(S(() => ({ as: e.as, type: t.type })), c);
  function v(b) {
    var y, g, x, w, $;
    if (u.value) {
      if (r.popoverState.value === 1)
        return;
      switch (b.key) {
        case B.Space:
        case B.Enter:
          b.preventDefault(), (g = (y = b.target).click) == null || g.call(y), r.closePopover(), (x = T(r.button)) == null || x.focus();
          break;
      }
    } else
      switch (b.key) {
        case B.Space:
        case B.Enter:
          b.preventDefault(), b.stopPropagation(), r.popoverState.value === 1 && (i == null || i(r.buttonId.value)), r.togglePopover();
          break;
        case B.Escape:
          if (r.popoverState.value !== 0)
            return i == null ? void 0 : i(r.buttonId.value);
          if (!T(r.button) || (w = a.value) != null && w.activeElement && !(($ = T(r.button)) != null && $.contains(a.value.activeElement)))
            return;
          b.preventDefault(), b.stopPropagation(), r.closePopover();
          break;
      }
  }
  function p(b) {
    u.value || b.key === B.Space && b.preventDefault();
  }
  function m(b) {
    var y, g;
    e.disabled || (u.value ? (r.closePopover(), (y = T(r.button)) == null || y.focus()) : (b.preventDefault(), b.stopPropagation(), r.popoverState.value === 1 && (i == null || i(r.buttonId.value)), r.togglePopover(), (g = T(r.button)) == null || g.focus()));
  }
  function h(b) {
    b.preventDefault(), b.stopPropagation();
  }
  return () => {
    let b = r.popoverState.value === 0, y = { open: b }, { id: g, ...x } = e, w = u.value ? { ref: c, type: f.value, onKeydown: v, onClick: m } : { ref: c, id: g, type: f.value, "aria-expanded": e.disabled ? void 0 : r.popoverState.value === 0, "aria-controls": T(r.panel) ? r.panelId.value : void 0, disabled: e.disabled ? !0 : void 0, onKeydown: v, onKeyup: p, onClick: m, onMousedown: h }, $ = lr();
    function E() {
      let O = T(r.panel);
      if (!O)
        return;
      function P() {
        J($.value, { [Se.Forwards]: () => Oe(O, he.First), [Se.Backwards]: () => Oe(O, he.Last) }) === mt.Error && Oe($t().filter((I) => I.dataset.headlessuiFocusGuard !== "true"), J($.value, { [Se.Forwards]: he.Next, [Se.Backwards]: he.Previous }), { relativeTo: T(r.button) });
      }
      P();
    }
    return Y(pe, [q({ ourProps: w, theirProps: { ...t, ...x }, slot: y, attrs: t, slots: n, name: "PopoverButton" }), b && !u.value && r.isPortalled.value && Y(Ve, { id: d, features: ke.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: E })]);
  };
} });
D({ name: "PopoverOverlay", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 } }, setup(e, { attrs: t, slots: n }) {
  let l = Xt("PopoverOverlay"), r = `headlessui-popover-overlay-${ae()}`, a = ze(), o = S(() => a !== null ? (a.value & ne.Open) === ne.Open : l.popoverState.value === 0);
  function i() {
    l.closePopover();
  }
  return () => {
    let s = { open: l.popoverState.value === 0 };
    return q({ ourProps: { id: r, "aria-hidden": !0, onClick: i }, theirProps: e, slot: s, attrs: t, slots: n, features: we.RenderStrategy | we.Static, visible: o.value, name: "PopoverOverlay" });
  };
} });
let Ii = D({ name: "PopoverPanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, focus: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-popover-panel-${ae()}` } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: l }) {
  let { focus: r } = e, a = Xt("PopoverPanel"), o = S(() => Pe(a.panel)), i = `headlessui-focus-sentinel-before-${ae()}`, s = `headlessui-focus-sentinel-after-${ae()}`;
  l({ el: a.panel, $el: a.panel }), X(() => {
    a.panelId.value = e.id;
  }), xe(() => {
    a.panelId.value = null;
  }), fe(il, a.panelId), ce(() => {
    var h, b;
    if (!r || a.popoverState.value !== 0 || !a.panel)
      return;
    let y = (h = o.value) == null ? void 0 : h.activeElement;
    (b = T(a.panel)) != null && b.contains(y) || Oe(T(a.panel), he.First);
  });
  let u = ze(), c = S(() => u !== null ? (u.value & ne.Open) === ne.Open : a.popoverState.value === 0);
  function d(h) {
    var b, y;
    switch (h.key) {
      case B.Escape:
        if (a.popoverState.value !== 0 || !T(a.panel) || o.value && !((b = T(a.panel)) != null && b.contains(o.value.activeElement)))
          return;
        h.preventDefault(), h.stopPropagation(), a.closePopover(), (y = T(a.button)) == null || y.focus();
        break;
    }
  }
  function f(h) {
    var b, y, g, x, w;
    let $ = h.relatedTarget;
    $ && T(a.panel) && ((b = T(a.panel)) != null && b.contains($) || (a.closePopover(), ((g = (y = T(a.beforePanelSentinel)) == null ? void 0 : y.contains) != null && g.call(y, $) || (w = (x = T(a.afterPanelSentinel)) == null ? void 0 : x.contains) != null && w.call(x, $)) && $.focus({ preventScroll: !0 })));
  }
  let v = lr();
  function p() {
    let h = T(a.panel);
    if (!h)
      return;
    function b() {
      J(v.value, { [Se.Forwards]: () => {
        var y;
        Oe(h, he.First) === mt.Error && ((y = T(a.afterPanelSentinel)) == null || y.focus());
      }, [Se.Backwards]: () => {
        var y;
        (y = T(a.button)) == null || y.focus({ preventScroll: !0 });
      } });
    }
    b();
  }
  function m() {
    let h = T(a.panel);
    if (!h)
      return;
    function b() {
      J(v.value, { [Se.Forwards]: () => {
        let y = T(a.button), g = T(a.panel);
        if (!y)
          return;
        let x = $t(), w = x.indexOf(y), $ = x.slice(0, w + 1), E = [...x.slice(w + 1), ...$];
        for (let O of E.slice())
          if (O.dataset.headlessuiFocusGuard === "true" || g != null && g.contains(O)) {
            let P = E.indexOf(O);
            P !== -1 && E.splice(P, 1);
          }
        Oe(E, he.First, { sorted: !1 });
      }, [Se.Backwards]: () => {
        var y;
        Oe(h, he.Previous) === mt.Error && ((y = T(a.button)) == null || y.focus());
      } });
    }
    b();
  }
  return () => {
    let h = { open: a.popoverState.value === 0, close: a.close }, { id: b, focus: y, ...g } = e, x = { ref: a.panel, id: b, onKeydown: d, onFocusout: r && a.popoverState.value === 0 ? f : void 0, tabIndex: -1 };
    return q({ ourProps: x, theirProps: { ...t, ...g }, attrs: t, slot: h, slots: { ...n, default: (...w) => {
      var $;
      return [Y(pe, [c.value && a.isPortalled.value && Y(Ve, { id: i, ref: a.beforePanelSentinel, features: ke.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: p }), ($ = n.default) == null ? void 0 : $.call(n, ...w), c.value && a.isPortalled.value && Y(Ve, { id: s, ref: a.afterPanelSentinel, features: ke.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: m })])];
    } }, features: we.RenderStrategy | we.Static, visible: c.value, name: "PopoverPanel" });
  };
} });
D({ name: "PopoverGroup", props: { as: { type: [Object, String], default: "div" } }, setup(e, { attrs: t, slots: n, expose: l }) {
  let r = C(null), a = Kt([]), o = S(() => Pe(r));
  l({ el: r, $el: r });
  function i(d) {
    let f = a.value.indexOf(d);
    f !== -1 && a.value.splice(f, 1);
  }
  function s(d) {
    return a.value.push(d), () => {
      i(d);
    };
  }
  function u() {
    var d;
    let f = o.value;
    if (!f)
      return !1;
    let v = f.activeElement;
    return (d = T(r)) != null && d.contains(v) ? !0 : a.value.some((p) => {
      var m, h;
      return ((m = f.getElementById(p.buttonId.value)) == null ? void 0 : m.contains(v)) || ((h = f.getElementById(p.panelId.value)) == null ? void 0 : h.contains(v));
    });
  }
  function c(d) {
    for (let f of a.value)
      f.buttonId.value !== d && f.close();
  }
  return fe(ll, { registerPopover: s, unregisterPopover: i, isFocusWithinPopoverGroup: u, closeOthers: c }), () => q({ ourProps: { ref: r }, theirProps: e, slot: {}, attrs: t, slots: n, name: "PopoverGroup" });
} });
let sl = Symbol("LabelContext");
function cl() {
  let e = me(sl, null);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, cl), t;
  }
  return e;
}
function _i({ slot: e = {}, name: t = "Label", props: n = {} } = {}) {
  let l = C([]);
  function r(a) {
    return l.value.push(a), () => {
      let o = l.value.indexOf(a);
      o !== -1 && l.value.splice(o, 1);
    };
  }
  return fe(sl, { register: r, slot: e, name: t, props: n }), S(() => l.value.length > 0 ? l.value.join(" ") : void 0);
}
D({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: () => `headlessui-label-${ae()}` } }, setup(e, { slots: t, attrs: n }) {
  let l = cl();
  return X(() => xe(l.register(e.id))), () => {
    let { name: r = "Label", slot: a = {}, props: o = {} } = l, { id: i, passive: s, ...u } = e, c = { ...Object.entries(o).reduce((d, [f, v]) => Object.assign(d, { [f]: F(v) }), {}), id: i };
    return s && (delete c.onClick, delete c.htmlFor, delete u.onClick), q({ ourProps: c, theirProps: u, slot: a, attrs: n, slots: t, name: r });
  };
} });
let dl = Symbol("GroupContext");
D({ name: "SwitchGroup", props: { as: { type: [Object, String], default: "template" } }, setup(e, { slots: t, attrs: n }) {
  let l = C(null), r = _i({ name: "SwitchLabel", props: { htmlFor: S(() => {
    var o;
    return (o = l.value) == null ? void 0 : o.id;
  }), onClick(o) {
    l.value && (o.currentTarget.tagName === "LABEL" && o.preventDefault(), l.value.click(), l.value.focus({ preventScroll: !0 }));
  } } }), a = Ja({ name: "SwitchDescription" });
  return fe(dl, { switchRef: l, labelledby: r, describedby: a }), () => q({ theirProps: e, ourProps: {}, slot: {}, slots: t, attrs: n, name: "SwitchGroup" });
} });
let Li = D({ name: "Switch", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "button" }, modelValue: { type: Boolean, default: void 0 }, defaultChecked: { type: Boolean, optional: !0 }, name: { type: String, optional: !0 }, value: { type: String, optional: !0 }, id: { type: String, default: () => `headlessui-switch-${ae()}` } }, inheritAttrs: !1, setup(e, { emit: t, attrs: n, slots: l, expose: r }) {
  let a = me(dl, null), [o, i] = rr(S(() => e.modelValue), (h) => t("update:modelValue", h), S(() => e.defaultChecked));
  function s() {
    i(!o.value);
  }
  let u = C(null), c = a === null ? u : a.switchRef, d = wt(S(() => ({ as: e.as, type: n.type })), c);
  r({ el: c, $el: c });
  function f(h) {
    h.preventDefault(), s();
  }
  function v(h) {
    h.key === B.Space ? (h.preventDefault(), s()) : h.key === B.Enter && No(h.currentTarget);
  }
  function p(h) {
    h.preventDefault();
  }
  let m = S(() => {
    var h, b;
    return (b = (h = T(c)) == null ? void 0 : h.closest) == null ? void 0 : b.call(h, "form");
  });
  return X(() => {
    se([m], () => {
      if (!m.value || e.defaultChecked === void 0)
        return;
      function h() {
        i(e.defaultChecked);
      }
      return m.value.addEventListener("reset", h), () => {
        var b;
        (b = m.value) == null || b.removeEventListener("reset", h);
      };
    }, { immediate: !0 });
  }), () => {
    let { id: h, name: b, value: y, ...g } = e, x = { checked: o.value }, w = { id: h, ref: c, role: "switch", type: d.value, tabIndex: 0, "aria-checked": o.value, "aria-labelledby": a == null ? void 0 : a.labelledby.value, "aria-describedby": a == null ? void 0 : a.describedby.value, onClick: f, onKeyup: v, onKeypress: p };
    return Y(pe, [b != null && o.value != null ? Y(Ve, er({ features: ke.Hidden, as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: o.value, name: b, value: y })) : null, q({ ourProps: w, theirProps: { ...n, ...nt(g, ["modelValue", "defaultChecked"]) }, slot: x, attrs: n, slots: l, name: "Switch" })]);
  };
} });
function ki(e) {
  let t = { called: !1 };
  return (...n) => {
    if (!t.called)
      return t.called = !0, e(...n);
  };
}
function $n(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function _t(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
var Vn = ((e) => (e.Finished = "finished", e.Cancelled = "cancelled", e))(Vn || {});
function Di(e, t) {
  let n = Zt();
  if (!e)
    return n.dispose;
  let { transitionDuration: l, transitionDelay: r } = getComputedStyle(e), [a, o] = [l, r].map((i) => {
    let [s = 0] = i.split(",").filter(Boolean).map((u) => u.includes("ms") ? parseFloat(u) : parseFloat(u) * 1e3).sort((u, c) => c - u);
    return s;
  });
  return a !== 0 ? n.setTimeout(() => t("finished"), a + o) : t("finished"), n.add(() => t("cancelled")), n.dispose;
}
function Er(e, t, n, l, r, a) {
  let o = Zt(), i = a !== void 0 ? ki(a) : () => {
  };
  return _t(e, ...r), $n(e, ...t, ...n), o.nextFrame(() => {
    _t(e, ...n), $n(e, ...l), o.add(Di(e, (s) => (_t(e, ...l, ...t), $n(e, ...r), i(s))));
  }), o.add(() => _t(e, ...t, ...n, ...l, ...r)), o.add(() => i("cancelled")), o.dispose;
}
function Ue(e = "") {
  return e.split(" ").filter((t) => t.trim().length > 1);
}
let ur = Symbol("TransitionContext");
var Ri = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(Ri || {});
function Vi() {
  return me(ur, null) !== null;
}
function Mi() {
  let e = me(ur, null);
  if (e === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
function ji() {
  let e = me(sr, null);
  if (e === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
let sr = Symbol("NestingContext");
function en(e) {
  return "children" in e ? en(e.children) : e.value.filter(({ state: t }) => t === "visible").length > 0;
}
function fl(e) {
  let t = C([]), n = C(!1);
  X(() => n.value = !0), xe(() => n.value = !1);
  function l(a, o = Me.Hidden) {
    let i = t.value.findIndex(({ id: s }) => s === a);
    i !== -1 && (J(o, { [Me.Unmount]() {
      t.value.splice(i, 1);
    }, [Me.Hidden]() {
      t.value[i].state = "hidden";
    } }), !en(t) && n.value && (e == null || e()));
  }
  function r(a) {
    let o = t.value.find(({ id: i }) => i === a);
    return o ? o.state !== "visible" && (o.state = "visible") : t.value.push({ id: a, state: "visible" }), () => l(a, Me.Unmount);
  }
  return { children: t, register: r, unregister: l };
}
let vl = we.RenderStrategy, Bt = D({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: n, slots: l, expose: r }) {
  let a = C(0);
  function o() {
    a.value |= ne.Opening, t("beforeEnter");
  }
  function i() {
    a.value &= ~ne.Opening, t("afterEnter");
  }
  function s() {
    a.value |= ne.Closing, t("beforeLeave");
  }
  function u() {
    a.value &= ~ne.Closing, t("afterLeave");
  }
  if (!Vi() && Lo())
    return () => Y(pl, { ...e, onBeforeEnter: o, onAfterEnter: i, onBeforeLeave: s, onAfterLeave: u }, l);
  let c = C(null), d = C("visible"), f = S(() => e.unmount ? Me.Unmount : Me.Hidden);
  r({ el: c, $el: c });
  let { show: v, appear: p } = Mi(), { register: m, unregister: h } = ji(), b = { value: !0 }, y = ae(), g = { value: !1 }, x = fl(() => {
    !g.value && d.value !== "hidden" && (d.value = "hidden", h(y), u());
  });
  X(() => {
    let j = m(y);
    xe(j);
  }), ce(() => {
    if (f.value === Me.Hidden && y) {
      if (v && d.value !== "visible") {
        d.value = "visible";
        return;
      }
      J(d.value, { hidden: () => h(y), visible: () => m(y) });
    }
  });
  let w = Ue(e.enter), $ = Ue(e.enterFrom), E = Ue(e.enterTo), O = Ue(e.entered), P = Ue(e.leave), I = Ue(e.leaveFrom), L = Ue(e.leaveTo);
  X(() => {
    ce(() => {
      if (d.value === "visible") {
        let j = T(c);
        if (j instanceof Comment && j.data === "")
          throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function M(j) {
    let k = b.value && !p.value, U = T(c);
    !U || !(U instanceof HTMLElement) || k || (g.value = !0, v.value && o(), v.value || s(), j(v.value ? Er(U, w, $, E, O, (G) => {
      g.value = !1, G === Vn.Finished && i();
    }) : Er(U, P, I, L, O, (G) => {
      g.value = !1, G === Vn.Finished && (en(x) || (d.value = "hidden", h(y), u()));
    })));
  }
  return X(() => {
    se([v], (j, k, U) => {
      M(U), b.value = !1;
    }, { immediate: !0 });
  }), fe(sr, x), gt(S(() => J(d.value, { visible: ne.Open, hidden: ne.Closed }) | a.value)), () => {
    let { appear: j, show: k, enter: U, enterFrom: G, enterTo: te, entered: $e, leave: ve, leaveFrom: mn, leaveTo: bn, ...Ft } = e, yn = { ref: c }, po = { ...Ft, ...p && v && xt.isServer ? { class: Z([n.class, Ft.class, ...w, ...$]) } : {} };
    return q({ theirProps: po, ourProps: yn, slot: {}, slots: l, attrs: n, features: vl, visible: d.value === "visible", name: "TransitionChild" });
  };
} }), Bi = Bt, pl = D({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: n, slots: l }) {
  let r = ze(), a = S(() => e.show === null && r !== null ? (r.value & ne.Open) === ne.Open : e.show);
  ce(() => {
    if (![!0, !1].includes(a.value))
      throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let o = C(a.value ? "visible" : "hidden"), i = fl(() => {
    o.value = "hidden";
  }), s = C(!0), u = { show: a, appear: S(() => e.appear || !s.value) };
  return X(() => {
    ce(() => {
      s.value = !1, a.value ? o.value = "visible" : en(i) || (o.value = "hidden");
    });
  }), fe(sr, i), fe(ur, u), () => {
    let c = nt(e, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), d = { unmount: e.unmount };
    return q({ ourProps: { ...d, as: "template" }, theirProps: {}, slot: {}, slots: { ...l, default: () => [Y(Bi, { onBeforeEnter: () => t("beforeEnter"), onAfterEnter: () => t("afterEnter"), onBeforeLeave: () => t("beforeLeave"), onAfterLeave: () => t("afterLeave"), ...n, ...d, ...c }, l.default)] }, attrs: {}, features: vl, visible: o.value === "visible", name: "Transition" });
  };
} });
var ue = function() {
  return ue = Object.assign || function(t) {
    for (var n, l = 1, r = arguments.length; l < r; l++) {
      n = arguments[l];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, ue.apply(this, arguments);
};
function Ni(e, t, n, l) {
  function r(a) {
    return a instanceof n ? a : new n(function(o) {
      o(a);
    });
  }
  return new (n || (n = Promise))(function(a, o) {
    function i(c) {
      try {
        u(l.next(c));
      } catch (d) {
        o(d);
      }
    }
    function s(c) {
      try {
        u(l.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function u(c) {
      c.done ? a(c.value) : r(c.value).then(i, s);
    }
    u((l = l.apply(e, t || [])).next());
  });
}
function zi(e, t) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, l, r, a, o;
  return o = { next: i(0), throw: i(1), return: i(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function i(u) {
    return function(c) {
      return s([u, c]);
    };
  }
  function s(u) {
    if (l)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, u[0] && (n = 0)), n; )
      try {
        if (l = 1, r && (a = u[0] & 2 ? r.return : u[0] ? r.throw || ((a = r.return) && a.call(r), 0) : r.next) && !(a = a.call(r, u[1])).done)
          return a;
        switch (r = 0, a && (u = [u[0] & 2, a.value]), u[0]) {
          case 0:
          case 1:
            a = u;
            break;
          case 4:
            return n.label++, { value: u[1], done: !1 };
          case 5:
            n.label++, r = u[1], u = [0];
            continue;
          case 7:
            u = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              n = 0;
              continue;
            }
            if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
              n.label = u[1];
              break;
            }
            if (u[0] === 6 && n.label < a[1]) {
              n.label = a[1], a = u;
              break;
            }
            if (a && n.label < a[2]) {
              n.label = a[2], n.ops.push(u);
              break;
            }
            a[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        u = t.call(e, n);
      } catch (c) {
        u = [6, c], r = 0;
      } finally {
        l = a = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function K(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], l = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && l >= e.length && (e = void 0), { value: e && e[l++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function de(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var l = n.call(e), r, a = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = l.next()).done; )
      a.push(r.value);
  } catch (i) {
    o = { error: i };
  } finally {
    try {
      r && !r.done && (n = l.return) && n.call(l);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return a;
}
var Ui = "ENTRIES", hl = "KEYS", ml = "VALUES", be = "", Sn = (
  /** @class */
  function() {
    function e(t, n) {
      var l = t._tree, r = Array.from(l.keys());
      this.set = t, this._type = n, this._path = r.length > 0 ? [{ node: l, keys: r }] : [];
    }
    return e.prototype.next = function() {
      var t = this.dive();
      return this.backtrack(), t;
    }, e.prototype.dive = function() {
      if (this._path.length === 0)
        return { done: !0, value: void 0 };
      var t = Qe(this._path), n = t.node, l = t.keys;
      if (Qe(l) === be)
        return { done: !1, value: this.result() };
      var r = n.get(Qe(l));
      return this._path.push({ node: r, keys: Array.from(r.keys()) }), this.dive();
    }, e.prototype.backtrack = function() {
      if (this._path.length !== 0) {
        var t = Qe(this._path).keys;
        t.pop(), !(t.length > 0) && (this._path.pop(), this.backtrack());
      }
    }, e.prototype.key = function() {
      return this.set._prefix + this._path.map(function(t) {
        var n = t.keys;
        return Qe(n);
      }).filter(function(t) {
        return t !== be;
      }).join("");
    }, e.prototype.value = function() {
      return Qe(this._path).node.get(be);
    }, e.prototype.result = function() {
      switch (this._type) {
        case ml:
          return this.value();
        case hl:
          return this.key();
        default:
          return [this.key(), this.value()];
      }
    }, e.prototype[Symbol.iterator] = function() {
      return this;
    }, e;
  }()
), Qe = function(e) {
  return e[e.length - 1];
}, Hi = function(e, t, n) {
  var l = /* @__PURE__ */ new Map();
  if (t === void 0)
    return l;
  for (var r = t.length + 1, a = r + n, o = new Uint8Array(a * r).fill(n + 1), i = 0; i < r; ++i)
    o[i] = i;
  for (var s = 1; s < a; ++s)
    o[s * r] = s;
  return bl(e, t, n, l, o, 1, r, ""), l;
}, bl = function(e, t, n, l, r, a, o, i) {
  var s, u, c = a * o;
  try {
    e:
      for (var d = K(e.keys()), f = d.next(); !f.done; f = d.next()) {
        var v = f.value;
        if (v === be) {
          var p = r[c - 1];
          p <= n && l.set(i, [e.get(v), p]);
        } else {
          for (var m = a, h = 0; h < v.length; ++h, ++m) {
            for (var b = v[h], y = o * m, g = y - o, x = r[y], w = Math.max(0, m - n - 1), $ = Math.min(o - 1, m + n), E = w; E < $; ++E) {
              var O = b !== t[E], P = r[g + E] + +O, I = r[g + E + 1] + 1, L = r[y + E] + 1, M = r[y + E + 1] = Math.min(P, I, L);
              M < x && (x = M);
            }
            if (x > n)
              continue e;
          }
          bl(e.get(v), t, n, l, r, m, o, i + v);
        }
      }
  } catch (j) {
    s = { error: j };
  } finally {
    try {
      f && !f.done && (u = d.return) && u.call(d);
    } finally {
      if (s)
        throw s.error;
    }
  }
}, Tn = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = /* @__PURE__ */ new Map()), n === void 0 && (n = ""), this._size = void 0, this._tree = t, this._prefix = n;
    }
    return e.prototype.atPrefix = function(t) {
      var n, l;
      if (!t.startsWith(this._prefix))
        throw new Error("Mismatched prefix");
      var r = de(Nt(this._tree, t.slice(this._prefix.length)), 2), a = r[0], o = r[1];
      if (a === void 0) {
        var i = de(cr(o), 2), s = i[0], u = i[1];
        try {
          for (var c = K(s.keys()), d = c.next(); !d.done; d = c.next()) {
            var f = d.value;
            if (f !== be && f.startsWith(u)) {
              var v = /* @__PURE__ */ new Map();
              return v.set(f.slice(u.length), s.get(f)), new e(v, t);
            }
          }
        } catch (p) {
          n = { error: p };
        } finally {
          try {
            d && !d.done && (l = c.return) && l.call(c);
          } finally {
            if (n)
              throw n.error;
          }
        }
      }
      return new e(a, t);
    }, e.prototype.clear = function() {
      this._size = void 0, this._tree.clear();
    }, e.prototype.delete = function(t) {
      return this._size = void 0, Gi(this._tree, t);
    }, e.prototype.entries = function() {
      return new Sn(this, Ui);
    }, e.prototype.forEach = function(t) {
      var n, l;
      try {
        for (var r = K(this), a = r.next(); !a.done; a = r.next()) {
          var o = de(a.value, 2), i = o[0], s = o[1];
          t(i, s, this);
        }
      } catch (u) {
        n = { error: u };
      } finally {
        try {
          a && !a.done && (l = r.return) && l.call(r);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }, e.prototype.fuzzyGet = function(t, n) {
      return Hi(this._tree, t, n);
    }, e.prototype.get = function(t) {
      var n = Mn(this._tree, t);
      return n !== void 0 ? n.get(be) : void 0;
    }, e.prototype.has = function(t) {
      var n = Mn(this._tree, t);
      return n !== void 0 && n.has(be);
    }, e.prototype.keys = function() {
      return new Sn(this, hl);
    }, e.prototype.set = function(t, n) {
      if (typeof t != "string")
        throw new Error("key must be a string");
      this._size = void 0;
      var l = On(this._tree, t);
      return l.set(be, n), this;
    }, Object.defineProperty(e.prototype, "size", {
      /**
       * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map/size
       */
      get: function() {
        if (this._size)
          return this._size;
        this._size = 0;
        for (var t = this.entries(); !t.next().done; )
          this._size += 1;
        return this._size;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.update = function(t, n) {
      if (typeof t != "string")
        throw new Error("key must be a string");
      this._size = void 0;
      var l = On(this._tree, t);
      return l.set(be, n(l.get(be))), this;
    }, e.prototype.fetch = function(t, n) {
      if (typeof t != "string")
        throw new Error("key must be a string");
      this._size = void 0;
      var l = On(this._tree, t), r = l.get(be);
      return r === void 0 && l.set(be, r = n()), r;
    }, e.prototype.values = function() {
      return new Sn(this, ml);
    }, e.prototype[Symbol.iterator] = function() {
      return this.entries();
    }, e.from = function(t) {
      var n, l, r = new e();
      try {
        for (var a = K(t), o = a.next(); !o.done; o = a.next()) {
          var i = de(o.value, 2), s = i[0], u = i[1];
          r.set(s, u);
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          o && !o.done && (l = a.return) && l.call(a);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return r;
    }, e.fromObject = function(t) {
      return e.from(Object.entries(t));
    }, e;
  }()
), Nt = function(e, t, n) {
  var l, r;
  if (n === void 0 && (n = []), t.length === 0 || e == null)
    return [e, n];
  try {
    for (var a = K(e.keys()), o = a.next(); !o.done; o = a.next()) {
      var i = o.value;
      if (i !== be && t.startsWith(i))
        return n.push([e, i]), Nt(e.get(i), t.slice(i.length), n);
    }
  } catch (s) {
    l = { error: s };
  } finally {
    try {
      o && !o.done && (r = a.return) && r.call(a);
    } finally {
      if (l)
        throw l.error;
    }
  }
  return n.push([e, t]), Nt(void 0, "", n);
}, Mn = function(e, t) {
  var n, l;
  if (t.length === 0 || e == null)
    return e;
  try {
    for (var r = K(e.keys()), a = r.next(); !a.done; a = r.next()) {
      var o = a.value;
      if (o !== be && t.startsWith(o))
        return Mn(e.get(o), t.slice(o.length));
    }
  } catch (i) {
    n = { error: i };
  } finally {
    try {
      a && !a.done && (l = r.return) && l.call(r);
    } finally {
      if (n)
        throw n.error;
    }
  }
}, On = function(e, t) {
  var n, l, r = t.length;
  e:
    for (var a = 0; e && a < r; ) {
      try {
        for (var o = (n = void 0, K(e.keys())), i = o.next(); !i.done; i = o.next()) {
          var s = i.value;
          if (s !== be && t[a] === s[0]) {
            for (var u = Math.min(r - a, s.length), c = 1; c < u && t[a + c] === s[c]; )
              ++c;
            var d = e.get(s);
            if (c === s.length)
              e = d;
            else {
              var f = /* @__PURE__ */ new Map();
              f.set(s.slice(c), d), e.set(t.slice(a, a + c), f), e.delete(s), e = f;
            }
            a += c;
            continue e;
          }
        }
      } catch (p) {
        n = { error: p };
      } finally {
        try {
          i && !i.done && (l = o.return) && l.call(o);
        } finally {
          if (n)
            throw n.error;
        }
      }
      var v = /* @__PURE__ */ new Map();
      return e.set(t.slice(a), v), v;
    }
  return e;
}, Gi = function(e, t) {
  var n = de(Nt(e, t), 2), l = n[0], r = n[1];
  if (l !== void 0) {
    if (l.delete(be), l.size === 0)
      yl(r);
    else if (l.size === 1) {
      var a = de(l.entries().next().value, 2), o = a[0], i = a[1];
      gl(r, o, i);
    }
  }
}, yl = function(e) {
  if (e.length !== 0) {
    var t = de(cr(e), 2), n = t[0], l = t[1];
    if (n.delete(l), n.size === 0)
      yl(e.slice(0, -1));
    else if (n.size === 1) {
      var r = de(n.entries().next().value, 2), a = r[0], o = r[1];
      a !== be && gl(e.slice(0, -1), a, o);
    }
  }
}, gl = function(e, t, n) {
  if (e.length !== 0) {
    var l = de(cr(e), 2), r = l[0], a = l[1];
    r.set(a + t, n), r.delete(a);
  }
}, cr = function(e) {
  return e[e.length - 1];
}, ft, dr = "or", wl = "and", Wi = "and_not", xl = (
  /** @class */
  function() {
    function e(t) {
      if ((t == null ? void 0 : t.fields) == null)
        throw new Error('MiniSearch: option "fields" must be provided');
      var n = t.autoVacuum == null || t.autoVacuum === !0 ? En : t.autoVacuum;
      this._options = ue(ue(ue({}, An), t), { autoVacuum: n, searchOptions: ue(ue({}, Pr), t.searchOptions || {}), autoSuggestOptions: ue(ue({}, Zi), t.autoSuggestOptions || {}) }), this._index = new Tn(), this._documentCount = 0, this._documentIds = /* @__PURE__ */ new Map(), this._idToShortId = /* @__PURE__ */ new Map(), this._fieldIds = {}, this._fieldLength = /* @__PURE__ */ new Map(), this._avgFieldLength = [], this._nextId = 0, this._storedFields = /* @__PURE__ */ new Map(), this._dirtCount = 0, this._currentVacuum = null, this._enqueuedVacuum = null, this._enqueuedVacuumConditions = Bn, this.addFields(this._options.fields);
    }
    return e.prototype.add = function(t) {
      var n, l, r, a, o, i, s = this._options, u = s.extractField, c = s.tokenize, d = s.processTerm, f = s.fields, v = s.idField, p = u(t, v);
      if (p == null)
        throw new Error('MiniSearch: document does not have ID field "'.concat(v, '"'));
      if (this._idToShortId.has(p))
        throw new Error("MiniSearch: duplicate ID ".concat(p));
      var m = this.addDocumentId(p);
      this.saveStoredFields(m, t);
      try {
        for (var h = K(f), b = h.next(); !b.done; b = h.next()) {
          var y = b.value, g = u(t, y);
          if (g != null) {
            var x = c(g.toString(), y), w = this._fieldIds[y], $ = new Set(x).size;
            this.addFieldLength(m, w, this._documentCount - 1, $);
            try {
              for (var E = (r = void 0, K(x)), O = E.next(); !O.done; O = E.next()) {
                var P = O.value, I = d(P, y);
                if (Array.isArray(I))
                  try {
                    for (var L = (o = void 0, K(I)), M = L.next(); !M.done; M = L.next()) {
                      var j = M.value;
                      this.addTerm(w, m, j);
                    }
                  } catch (k) {
                    o = { error: k };
                  } finally {
                    try {
                      M && !M.done && (i = L.return) && i.call(L);
                    } finally {
                      if (o)
                        throw o.error;
                    }
                  }
                else
                  I && this.addTerm(w, m, I);
              }
            } catch (k) {
              r = { error: k };
            } finally {
              try {
                O && !O.done && (a = E.return) && a.call(E);
              } finally {
                if (r)
                  throw r.error;
              }
            }
          }
        }
      } catch (k) {
        n = { error: k };
      } finally {
        try {
          b && !b.done && (l = h.return) && l.call(h);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }, e.prototype.addAll = function(t) {
      var n, l;
      try {
        for (var r = K(t), a = r.next(); !a.done; a = r.next()) {
          var o = a.value;
          this.add(o);
        }
      } catch (i) {
        n = { error: i };
      } finally {
        try {
          a && !a.done && (l = r.return) && l.call(r);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }, e.prototype.addAllAsync = function(t, n) {
      var l = this;
      n === void 0 && (n = {});
      var r = n.chunkSize, a = r === void 0 ? 10 : r, o = { chunk: [], promise: Promise.resolve() }, i = t.reduce(function(c, d, f) {
        var v = c.chunk, p = c.promise;
        return v.push(d), (f + 1) % a === 0 ? {
          chunk: [],
          promise: p.then(function() {
            return new Promise(function(m) {
              return setTimeout(m, 0);
            });
          }).then(function() {
            return l.addAll(v);
          })
        } : { chunk: v, promise: p };
      }, o), s = i.chunk, u = i.promise;
      return u.then(function() {
        return l.addAll(s);
      });
    }, e.prototype.remove = function(t) {
      var n, l, r, a, o, i, s = this._options, u = s.tokenize, c = s.processTerm, d = s.extractField, f = s.fields, v = s.idField, p = d(t, v);
      if (p == null)
        throw new Error('MiniSearch: document does not have ID field "'.concat(v, '"'));
      var m = this._idToShortId.get(p);
      if (m == null)
        throw new Error("MiniSearch: cannot remove document with ID ".concat(p, ": it is not in the index"));
      try {
        for (var h = K(f), b = h.next(); !b.done; b = h.next()) {
          var y = b.value, g = d(t, y);
          if (g != null) {
            var x = u(g.toString(), y), w = this._fieldIds[y], $ = new Set(x).size;
            this.removeFieldLength(m, w, this._documentCount, $);
            try {
              for (var E = (r = void 0, K(x)), O = E.next(); !O.done; O = E.next()) {
                var P = O.value, I = c(P, y);
                if (Array.isArray(I))
                  try {
                    for (var L = (o = void 0, K(I)), M = L.next(); !M.done; M = L.next()) {
                      var j = M.value;
                      this.removeTerm(w, m, j);
                    }
                  } catch (k) {
                    o = { error: k };
                  } finally {
                    try {
                      M && !M.done && (i = L.return) && i.call(L);
                    } finally {
                      if (o)
                        throw o.error;
                    }
                  }
                else
                  I && this.removeTerm(w, m, I);
              }
            } catch (k) {
              r = { error: k };
            } finally {
              try {
                O && !O.done && (a = E.return) && a.call(E);
              } finally {
                if (r)
                  throw r.error;
              }
            }
          }
        }
      } catch (k) {
        n = { error: k };
      } finally {
        try {
          b && !b.done && (l = h.return) && l.call(h);
        } finally {
          if (n)
            throw n.error;
        }
      }
      this._storedFields.delete(m), this._documentIds.delete(m), this._idToShortId.delete(p), this._fieldLength.delete(m), this._documentCount -= 1;
    }, e.prototype.removeAll = function(t) {
      var n, l;
      if (t)
        try {
          for (var r = K(t), a = r.next(); !a.done; a = r.next()) {
            var o = a.value;
            this.remove(o);
          }
        } catch (i) {
          n = { error: i };
        } finally {
          try {
            a && !a.done && (l = r.return) && l.call(r);
          } finally {
            if (n)
              throw n.error;
          }
        }
      else {
        if (arguments.length > 0)
          throw new Error("Expected documents to be present. Omit the argument to remove all documents.");
        this._index = new Tn(), this._documentCount = 0, this._documentIds = /* @__PURE__ */ new Map(), this._idToShortId = /* @__PURE__ */ new Map(), this._fieldLength = /* @__PURE__ */ new Map(), this._avgFieldLength = [], this._storedFields = /* @__PURE__ */ new Map(), this._nextId = 0;
      }
    }, e.prototype.discard = function(t) {
      var n = this, l = this._idToShortId.get(t);
      if (l == null)
        throw new Error("MiniSearch: cannot discard document with ID ".concat(t, ": it is not in the index"));
      this._idToShortId.delete(t), this._documentIds.delete(l), this._storedFields.delete(l), (this._fieldLength.get(l) || []).forEach(function(r, a) {
        n.removeFieldLength(l, a, n._documentCount, r);
      }), this._fieldLength.delete(l), this._documentCount -= 1, this._dirtCount += 1, this.maybeAutoVacuum();
    }, e.prototype.maybeAutoVacuum = function() {
      if (this._options.autoVacuum !== !1) {
        var t = this._options.autoVacuum, n = t.minDirtFactor, l = t.minDirtCount, r = t.batchSize, a = t.batchWait;
        this.conditionalVacuum({ batchSize: r, batchWait: a }, { minDirtCount: l, minDirtFactor: n });
      }
    }, e.prototype.discardAll = function(t) {
      var n, l, r = this._options.autoVacuum;
      try {
        this._options.autoVacuum = !1;
        try {
          for (var a = K(t), o = a.next(); !o.done; o = a.next()) {
            var i = o.value;
            this.discard(i);
          }
        } catch (s) {
          n = { error: s };
        } finally {
          try {
            o && !o.done && (l = a.return) && l.call(a);
          } finally {
            if (n)
              throw n.error;
          }
        }
      } finally {
        this._options.autoVacuum = r;
      }
      this.maybeAutoVacuum();
    }, e.prototype.replace = function(t) {
      var n = this._options, l = n.idField, r = n.extractField, a = r(t, l);
      this.discard(a), this.add(t);
    }, e.prototype.vacuum = function(t) {
      return t === void 0 && (t = {}), this.conditionalVacuum(t);
    }, e.prototype.conditionalVacuum = function(t, n) {
      var l = this;
      return this._currentVacuum ? (this._enqueuedVacuumConditions = this._enqueuedVacuumConditions && n, this._enqueuedVacuum != null ? this._enqueuedVacuum : (this._enqueuedVacuum = this._currentVacuum.then(function() {
        var r = l._enqueuedVacuumConditions;
        return l._enqueuedVacuumConditions = Bn, l.performVacuuming(t, r);
      }), this._enqueuedVacuum)) : this.vacuumConditionsMet(n) === !1 ? Promise.resolve() : (this._currentVacuum = this.performVacuuming(t), this._currentVacuum);
    }, e.prototype.performVacuuming = function(t, n) {
      return Ni(this, void 0, void 0, function() {
        var l, r, a, o, i, s, u, c, d, f, v, p, m, h, b, y, g, x, w, $, E, O, P, I, L;
        return zi(this, function(M) {
          switch (M.label) {
            case 0:
              if (l = this._dirtCount, !this.vacuumConditionsMet(n))
                return [3, 10];
              r = t.batchSize || jn.batchSize, a = t.batchWait || jn.batchWait, o = 1, M.label = 1;
            case 1:
              M.trys.push([1, 7, 8, 9]), i = K(this._index), s = i.next(), M.label = 2;
            case 2:
              if (s.done)
                return [3, 6];
              u = de(s.value, 2), c = u[0], d = u[1];
              try {
                for (f = (O = void 0, K(d)), v = f.next(); !v.done; v = f.next()) {
                  p = de(v.value, 2), m = p[0], h = p[1];
                  try {
                    for (b = (I = void 0, K(h)), y = b.next(); !y.done; y = b.next())
                      g = de(y.value, 1), x = g[0], !this._documentIds.has(x) && (h.size <= 1 ? d.delete(m) : h.delete(x));
                  } catch (j) {
                    I = { error: j };
                  } finally {
                    try {
                      y && !y.done && (L = b.return) && L.call(b);
                    } finally {
                      if (I)
                        throw I.error;
                    }
                  }
                }
              } catch (j) {
                O = { error: j };
              } finally {
                try {
                  v && !v.done && (P = f.return) && P.call(f);
                } finally {
                  if (O)
                    throw O.error;
                }
              }
              return this._index.get(c).size === 0 && this._index.delete(c), o % r !== 0 ? [3, 4] : [4, new Promise(function(j) {
                return setTimeout(j, a);
              })];
            case 3:
              M.sent(), M.label = 4;
            case 4:
              o += 1, M.label = 5;
            case 5:
              return s = i.next(), [3, 2];
            case 6:
              return [3, 9];
            case 7:
              return w = M.sent(), $ = { error: w }, [3, 9];
            case 8:
              try {
                s && !s.done && (E = i.return) && E.call(i);
              } finally {
                if ($)
                  throw $.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 9:
              this._dirtCount -= l, M.label = 10;
            case 10:
              return [4, null];
            case 11:
              return M.sent(), this._currentVacuum = this._enqueuedVacuum, this._enqueuedVacuum = null, [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.vacuumConditionsMet = function(t) {
      if (t == null)
        return !0;
      var n = t.minDirtCount, l = t.minDirtFactor;
      return n = n || En.minDirtCount, l = l || En.minDirtFactor, this.dirtCount >= n && this.dirtFactor >= l;
    }, Object.defineProperty(e.prototype, "isVacuuming", {
      /**
       * Is `true` if a vacuuming operation is ongoing, `false` otherwise
       */
      get: function() {
        return this._currentVacuum != null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "dirtCount", {
      /**
       * The number of documents discarded since the most recent vacuuming
       */
      get: function() {
        return this._dirtCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "dirtFactor", {
      /**
       * A number between 0 and 1 giving an indication about the proportion of
       * documents that are discarded, and can therefore be cleaned up by vacuuming.
       * A value close to 0 means that the index is relatively clean, while a higher
       * value means that the index is relatively dirty, and vacuuming could release
       * memory.
       */
      get: function() {
        return this._dirtCount / (1 + this._documentCount + this._dirtCount);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.has = function(t) {
      return this._idToShortId.has(t);
    }, e.prototype.search = function(t, n) {
      var l, r;
      n === void 0 && (n = {});
      var a = this.executeQuery(t, n), o = [];
      try {
        for (var i = K(a), s = i.next(); !s.done; s = i.next()) {
          var u = de(s.value, 2), c = u[0], d = u[1], f = d.score, v = d.terms, p = d.match, m = v.length, h = {
            id: this._documentIds.get(c),
            score: f * m,
            terms: Object.keys(p),
            match: p
          };
          Object.assign(h, this._storedFields.get(c)), (n.filter == null || n.filter(h)) && o.push(h);
        }
      } catch (b) {
        l = { error: b };
      } finally {
        try {
          s && !s.done && (r = i.return) && r.call(i);
        } finally {
          if (l)
            throw l.error;
        }
      }
      return o.sort(Ir), o;
    }, e.prototype.autoSuggest = function(t, n) {
      var l, r, a, o;
      n === void 0 && (n = {}), n = ue(ue({}, this._options.autoSuggestOptions), n);
      var i = /* @__PURE__ */ new Map();
      try {
        for (var s = K(this.search(t, n)), u = s.next(); !u.done; u = s.next()) {
          var c = u.value, d = c.score, f = c.terms, v = f.join(" "), p = i.get(v);
          p != null ? (p.score += d, p.count += 1) : i.set(v, { score: d, terms: f, count: 1 });
        }
      } catch (w) {
        l = { error: w };
      } finally {
        try {
          u && !u.done && (r = s.return) && r.call(s);
        } finally {
          if (l)
            throw l.error;
        }
      }
      var m = [];
      try {
        for (var h = K(i), b = h.next(); !b.done; b = h.next()) {
          var y = de(b.value, 2), p = y[0], g = y[1], d = g.score, f = g.terms, x = g.count;
          m.push({ suggestion: p, terms: f, score: d / x });
        }
      } catch (w) {
        a = { error: w };
      } finally {
        try {
          b && !b.done && (o = h.return) && o.call(h);
        } finally {
          if (a)
            throw a.error;
        }
      }
      return m.sort(Ir), m;
    }, Object.defineProperty(e.prototype, "documentCount", {
      /**
       * Total number of documents available to search
       */
      get: function() {
        return this._documentCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "termCount", {
      /**
       * Number of terms in the index
       */
      get: function() {
        return this._index.size;
      },
      enumerable: !1,
      configurable: !0
    }), e.loadJSON = function(t, n) {
      if (n == null)
        throw new Error("MiniSearch: loadJSON should be given the same options used when serializing the index");
      return this.loadJS(JSON.parse(t), n);
    }, e.getDefault = function(t) {
      if (An.hasOwnProperty(t))
        return Cn(An, t);
      throw new Error('MiniSearch: unknown option "'.concat(t, '"'));
    }, e.loadJS = function(t, n) {
      var l, r, a, o, i, s, u = t.index, c = t.documentCount, d = t.nextId, f = t.documentIds, v = t.fieldIds, p = t.fieldLength, m = t.averageFieldLength, h = t.storedFields, b = t.dirtCount, y = t.serializationVersion;
      if (y !== 1 && y !== 2)
        throw new Error("MiniSearch: cannot deserialize an index created with an incompatible version");
      var g = new e(n);
      g._documentCount = c, g._nextId = d, g._documentIds = Lt(f), g._idToShortId = /* @__PURE__ */ new Map(), g._fieldIds = v, g._fieldLength = Lt(p), g._avgFieldLength = m, g._storedFields = Lt(h), g._dirtCount = b || 0, g._index = new Tn();
      try {
        for (var x = K(g._documentIds), w = x.next(); !w.done; w = x.next()) {
          var $ = de(w.value, 2), E = $[0], O = $[1];
          g._idToShortId.set(O, E);
        }
      } catch (ve) {
        l = { error: ve };
      } finally {
        try {
          w && !w.done && (r = x.return) && r.call(x);
        } finally {
          if (l)
            throw l.error;
        }
      }
      try {
        for (var P = K(u), I = P.next(); !I.done; I = P.next()) {
          var L = de(I.value, 2), M = L[0], j = L[1], k = /* @__PURE__ */ new Map();
          try {
            for (var U = (i = void 0, K(Object.keys(j))), G = U.next(); !G.done; G = U.next()) {
              var te = G.value, $e = j[te];
              y === 1 && ($e = $e.ds), k.set(parseInt(te, 10), Lt($e));
            }
          } catch (ve) {
            i = { error: ve };
          } finally {
            try {
              G && !G.done && (s = U.return) && s.call(U);
            } finally {
              if (i)
                throw i.error;
            }
          }
          g._index.set(M, k);
        }
      } catch (ve) {
        a = { error: ve };
      } finally {
        try {
          I && !I.done && (o = P.return) && o.call(P);
        } finally {
          if (a)
            throw a.error;
        }
      }
      return g;
    }, e.prototype.executeQuery = function(t, n) {
      var l = this;
      if (n === void 0 && (n = {}), typeof t != "string") {
        var r = ue(ue(ue({}, n), t), { queries: void 0 }), a = t.queries.map(function(h) {
          return l.executeQuery(h, r);
        });
        return this.combineResults(a, r.combineWith);
      }
      var o = this._options, i = o.tokenize, s = o.processTerm, u = o.searchOptions, c = ue(ue({ tokenize: i, processTerm: s }, u), n), d = c.tokenize, f = c.processTerm, v = d(t).flatMap(function(h) {
        return f(h);
      }).filter(function(h) {
        return !!h;
      }), p = v.map(Ji(c)), m = p.map(function(h) {
        return l.executeQuerySpec(h, c);
      });
      return this.combineResults(m, c.combineWith);
    }, e.prototype.executeQuerySpec = function(t, n) {
      var l, r, a, o, i = ue(ue({}, this._options.searchOptions), n), s = (i.fields || this._options.fields).reduce(function(te, $e) {
        var ve;
        return ue(ue({}, te), (ve = {}, ve[$e] = Cn(i.boost, $e) || 1, ve));
      }, {}), u = i.boostDocument, c = i.weights, d = i.maxFuzzy, f = i.bm25, v = ue(ue({}, Pr.weights), c), p = v.fuzzy, m = v.prefix, h = this._index.get(t.term), b = this.termResults(t.term, t.term, 1, h, s, u, f), y, g;
      if (t.prefix && (y = this._index.atPrefix(t.term)), t.fuzzy) {
        var x = t.fuzzy === !0 ? 0.2 : t.fuzzy, w = x < 1 ? Math.min(d, Math.round(t.term.length * x)) : x;
        w && (g = this._index.fuzzyGet(t.term, w));
      }
      if (y)
        try {
          for (var $ = K(y), E = $.next(); !E.done; E = $.next()) {
            var O = de(E.value, 2), P = O[0], I = O[1], L = P.length - t.term.length;
            if (L) {
              g == null || g.delete(P);
              var M = m * P.length / (P.length + 0.3 * L);
              this.termResults(t.term, P, M, I, s, u, f, b);
            }
          }
        } catch (te) {
          l = { error: te };
        } finally {
          try {
            E && !E.done && (r = $.return) && r.call($);
          } finally {
            if (l)
              throw l.error;
          }
        }
      if (g)
        try {
          for (var j = K(g.keys()), k = j.next(); !k.done; k = j.next()) {
            var P = k.value, U = de(g.get(P), 2), G = U[0], L = U[1];
            if (L) {
              var M = p * P.length / (P.length + L);
              this.termResults(t.term, P, M, G, s, u, f, b);
            }
          }
        } catch (te) {
          a = { error: te };
        } finally {
          try {
            k && !k.done && (o = j.return) && o.call(j);
          } finally {
            if (a)
              throw a.error;
          }
        }
      return b;
    }, e.prototype.combineResults = function(t, n) {
      if (n === void 0 && (n = dr), t.length === 0)
        return /* @__PURE__ */ new Map();
      var l = n.toLowerCase();
      return t.reduce(Ki[l]) || /* @__PURE__ */ new Map();
    }, e.prototype.toJSON = function() {
      var t, n, l, r, a = [];
      try {
        for (var o = K(this._index), i = o.next(); !i.done; i = o.next()) {
          var s = de(i.value, 2), u = s[0], c = s[1], d = {};
          try {
            for (var f = (l = void 0, K(c)), v = f.next(); !v.done; v = f.next()) {
              var p = de(v.value, 2), m = p[0], h = p[1];
              d[m] = Object.fromEntries(h);
            }
          } catch (b) {
            l = { error: b };
          } finally {
            try {
              v && !v.done && (r = f.return) && r.call(f);
            } finally {
              if (l)
                throw l.error;
            }
          }
          a.push([u, d]);
        }
      } catch (b) {
        t = { error: b };
      } finally {
        try {
          i && !i.done && (n = o.return) && n.call(o);
        } finally {
          if (t)
            throw t.error;
        }
      }
      return {
        documentCount: this._documentCount,
        nextId: this._nextId,
        documentIds: Object.fromEntries(this._documentIds),
        fieldIds: this._fieldIds,
        fieldLength: Object.fromEntries(this._fieldLength),
        averageFieldLength: this._avgFieldLength,
        storedFields: Object.fromEntries(this._storedFields),
        dirtCount: this._dirtCount,
        index: a,
        serializationVersion: 2
      };
    }, e.prototype.termResults = function(t, n, l, r, a, o, i, s) {
      var u, c, d, f, v;
      if (s === void 0 && (s = /* @__PURE__ */ new Map()), r == null)
        return s;
      try {
        for (var p = K(Object.keys(a)), m = p.next(); !m.done; m = p.next()) {
          var h = m.value, b = a[h], y = this._fieldIds[h], g = r.get(y);
          if (g != null) {
            var x = g.size, w = this._avgFieldLength[y];
            try {
              for (var $ = (d = void 0, K(g.keys())), E = $.next(); !E.done; E = $.next()) {
                var O = E.value;
                if (!this._documentIds.has(O)) {
                  this.removeTerm(y, O, n), x -= 1;
                  continue;
                }
                var P = o ? o(this._documentIds.get(O), n) : 1;
                if (P) {
                  var I = g.get(O), L = this._fieldLength.get(O)[y], M = Yi(I, x, this._documentCount, L, w, i), j = l * b * P * M, k = s.get(O);
                  if (k) {
                    k.score += j, Qi(k.terms, t);
                    var U = Cn(k.match, n);
                    U ? U.push(h) : k.match[n] = [h];
                  } else
                    s.set(O, {
                      score: j,
                      terms: [t],
                      match: (v = {}, v[n] = [h], v)
                    });
                }
              }
            } catch (G) {
              d = { error: G };
            } finally {
              try {
                E && !E.done && (f = $.return) && f.call($);
              } finally {
                if (d)
                  throw d.error;
              }
            }
          }
        }
      } catch (G) {
        u = { error: G };
      } finally {
        try {
          m && !m.done && (c = p.return) && c.call(p);
        } finally {
          if (u)
            throw u.error;
        }
      }
      return s;
    }, e.prototype.addTerm = function(t, n, l) {
      var r = this._index.fetch(l, _r), a = r.get(t);
      if (a == null)
        a = /* @__PURE__ */ new Map(), a.set(n, 1), r.set(t, a);
      else {
        var o = a.get(n);
        a.set(n, (o || 0) + 1);
      }
    }, e.prototype.removeTerm = function(t, n, l) {
      if (!this._index.has(l)) {
        this.warnDocumentChanged(n, t, l);
        return;
      }
      var r = this._index.fetch(l, _r), a = r.get(t);
      a == null || a.get(n) == null ? this.warnDocumentChanged(n, t, l) : a.get(n) <= 1 ? a.size <= 1 ? r.delete(t) : a.delete(n) : a.set(n, a.get(n) - 1), this._index.get(l).size === 0 && this._index.delete(l);
    }, e.prototype.warnDocumentChanged = function(t, n, l) {
      var r, a;
      try {
        for (var o = K(Object.keys(this._fieldIds)), i = o.next(); !i.done; i = o.next()) {
          var s = i.value;
          if (this._fieldIds[s] === n) {
            this._options.logger("warn", "MiniSearch: document with ID ".concat(this._documentIds.get(t), ' has changed before removal: term "').concat(l, '" was not present in field "').concat(s, '". Removing a document after it has changed can corrupt the index!'), "version_conflict");
            return;
          }
        }
      } catch (u) {
        r = { error: u };
      } finally {
        try {
          i && !i.done && (a = o.return) && a.call(o);
        } finally {
          if (r)
            throw r.error;
        }
      }
    }, e.prototype.addDocumentId = function(t) {
      var n = this._nextId;
      return this._idToShortId.set(t, n), this._documentIds.set(n, t), this._documentCount += 1, this._nextId += 1, n;
    }, e.prototype.addFields = function(t) {
      for (var n = 0; n < t.length; n++)
        this._fieldIds[t[n]] = n;
    }, e.prototype.addFieldLength = function(t, n, l, r) {
      var a = this._fieldLength.get(t);
      a == null && this._fieldLength.set(t, a = []), a[n] = r;
      var o = this._avgFieldLength[n] || 0, i = o * l + r;
      this._avgFieldLength[n] = i / (l + 1);
    }, e.prototype.removeFieldLength = function(t, n, l, r) {
      if (l === 1) {
        this._avgFieldLength[n] = 0;
        return;
      }
      var a = this._avgFieldLength[n] * l - r;
      this._avgFieldLength[n] = a / (l - 1);
    }, e.prototype.saveStoredFields = function(t, n) {
      var l, r, a = this._options, o = a.storeFields, i = a.extractField;
      if (!(o == null || o.length === 0)) {
        var s = this._storedFields.get(t);
        s == null && this._storedFields.set(t, s = {});
        try {
          for (var u = K(o), c = u.next(); !c.done; c = u.next()) {
            var d = c.value, f = i(n, d);
            f !== void 0 && (s[d] = f);
          }
        } catch (v) {
          l = { error: v };
        } finally {
          try {
            c && !c.done && (r = u.return) && r.call(u);
          } finally {
            if (l)
              throw l.error;
          }
        }
      }
    }, e;
  }()
), Cn = function(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
}, Ki = (ft = {}, ft[dr] = function(e, t) {
  var n, l;
  try {
    for (var r = K(t.keys()), a = r.next(); !a.done; a = r.next()) {
      var o = a.value, i = e.get(o);
      if (i == null)
        e.set(o, t.get(o));
      else {
        var s = t.get(o), u = s.score, c = s.terms, d = s.match;
        i.score = i.score + u, i.match = Object.assign(i.match, d), Fr(i.terms, c);
      }
    }
  } catch (f) {
    n = { error: f };
  } finally {
    try {
      a && !a.done && (l = r.return) && l.call(r);
    } finally {
      if (n)
        throw n.error;
    }
  }
  return e;
}, ft[wl] = function(e, t) {
  var n, l, r = /* @__PURE__ */ new Map();
  try {
    for (var a = K(t.keys()), o = a.next(); !o.done; o = a.next()) {
      var i = o.value, s = e.get(i);
      if (s != null) {
        var u = t.get(i), c = u.score, d = u.terms, f = u.match;
        Fr(s.terms, d), r.set(i, {
          score: s.score + c,
          terms: s.terms,
          match: Object.assign(s.match, f)
        });
      }
    }
  } catch (v) {
    n = { error: v };
  } finally {
    try {
      o && !o.done && (l = a.return) && l.call(a);
    } finally {
      if (n)
        throw n.error;
    }
  }
  return r;
}, ft[Wi] = function(e, t) {
  var n, l;
  try {
    for (var r = K(t.keys()), a = r.next(); !a.done; a = r.next()) {
      var o = a.value;
      e.delete(o);
    }
  } catch (i) {
    n = { error: i };
  } finally {
    try {
      a && !a.done && (l = r.return) && l.call(r);
    } finally {
      if (n)
        throw n.error;
    }
  }
  return e;
}, ft), qi = { k: 1.2, b: 0.7, d: 0.5 }, Yi = function(e, t, n, l, r, a) {
  var o = a.k, i = a.b, s = a.d, u = Math.log(1 + (n - t + 0.5) / (t + 0.5));
  return u * (s + e * (o + 1) / (e + o * (1 - i + i * l / r)));
}, Ji = function(e) {
  return function(t, n, l) {
    var r = typeof e.fuzzy == "function" ? e.fuzzy(t, n, l) : e.fuzzy || !1, a = typeof e.prefix == "function" ? e.prefix(t, n, l) : e.prefix === !0;
    return { term: t, fuzzy: r, prefix: a };
  };
}, An = {
  idField: "id",
  extractField: function(e, t) {
    return e[t];
  },
  tokenize: function(e, t) {
    return e.split(Xi);
  },
  processTerm: function(e, t) {
    return e.toLowerCase();
  },
  fields: void 0,
  searchOptions: void 0,
  storeFields: [],
  logger: function(e, t, n) {
    return console != null && console.warn != null && console[e](t);
  },
  autoVacuum: !0
}, Pr = {
  combineWith: dr,
  prefix: !1,
  fuzzy: !1,
  maxFuzzy: 6,
  boost: {},
  weights: { fuzzy: 0.45, prefix: 0.375 },
  bm25: qi
}, Zi = {
  combineWith: wl,
  prefix: function(e, t, n) {
    return t === n.length - 1;
  }
}, jn = { batchSize: 1e3, batchWait: 10 }, Bn = { minDirtFactor: 0.1, minDirtCount: 20 }, En = ue(ue({}, jn), Bn), Qi = function(e, t) {
  e.includes(t) || e.push(t);
}, Fr = function(e, t) {
  var n, l;
  try {
    for (var r = K(t), a = r.next(); !a.done; a = r.next()) {
      var o = a.value;
      e.includes(o) || e.push(o);
    }
  } catch (i) {
    n = { error: i };
  } finally {
    try {
      a && !a.done && (l = r.return) && l.call(r);
    } finally {
      if (n)
        throw n.error;
    }
  }
}, Ir = function(e, t) {
  var n = e.score, l = t.score;
  return l - n;
}, _r = function() {
  return /* @__PURE__ */ new Map();
}, Lt = function(e) {
  var t, n, l = /* @__PURE__ */ new Map();
  try {
    for (var r = K(Object.keys(e)), a = r.next(); !a.done; a = r.next()) {
      var o = a.value;
      l.set(parseInt(o, 10), e[o]);
    }
  } catch (i) {
    t = { error: i };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (t)
        throw t.error;
    }
  }
  return l;
}, Xi = /[\n\r -#%-*,-/:;?@[-\]_{}\u00A0\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u1680\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2000-\u200A\u2010-\u2029\u202F-\u2043\u2045-\u2051\u2053-\u205F\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u3000-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]+/u;
const eu = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
}, tu = /* @__PURE__ */ R("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0c1.172 1.025 1.172 2.687 0 3.712c-.203.179-.43.326-.67.442c-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
}, null, -1), nu = [
  tu
];
function ru(e, t) {
  return A(), V("svg", eu, nu);
}
const au = { name: "heroicons-question-mark-circle", render: ru }, lu = {
  key: 0,
  class: "tune-icon-hint"
}, ou = /* @__PURE__ */ D({
  __name: "TuneIconHint",
  props: {
    hint: null
  },
  setup(e) {
    return (t, n) => {
      const l = Qn("tippy");
      return e.hint ? qt((A(), V("span", lu, [
        z(F(au))
      ])), [
        [l, { content: e.hint }]
      ]) : Q("", !0);
    };
  }
}), iu = { class: "tune-label-container flex flex-col" }, uu = { class: "tune-label flex items-center gap-1" }, su = {
  key: 0,
  class: "tune-sublabel"
}, Ce = /* @__PURE__ */ D({
  __name: "TuneLabelInput",
  props: {
    hint: null,
    sublabel: null
  },
  setup(e) {
    return (t, n) => (A(), V("div", iu, [
      R("div", uu, [
        ye(t.$slots, "default"),
        z(ou, { hint: e.hint }, null, 8, ["hint"])
      ]),
      e.sublabel ? (A(), V("div", su, re(e.sublabel), 1)) : Q("", !0)
    ]));
  }
}), cu = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
}, du = /* @__PURE__ */ R("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m19.5 8.25l-7.5 7.5l-7.5-7.5"
}, null, -1), fu = [
  du
];
function vu(e, t) {
  return A(), V("svg", cu, fu);
}
const Ye = { name: "heroicons-chevron-down", render: vu }, pu = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
}, hu = /* @__PURE__ */ R("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m4.5 12.75l6 6l9-13.5"
}, null, -1), mu = [
  hu
];
function bu(e, t) {
  return A(), V("svg", pu, mu);
}
const tn = { name: "heroicons-check", render: bu }, yu = { class: "relative" }, gu = { class: "max-h-[180px] overflow-y-auto" }, wu = { key: 1 }, xu = {
  key: 0,
  class: /* @__PURE__ */ Z(["absolute inset-y-0 right-0 flex items-center pr-3"])
}, Ay = /* @__PURE__ */ D({
  __name: "TuneCombobox",
  props: {
    modelValue: null,
    items: null,
    label: null,
    hint: null,
    disabled: { type: Boolean },
    definition: null
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e;
    let l = new xl({
      fields: ["id", "name"],
      storeFields: ["id"],
      searchOptions: {
        boost: { name: 2 },
        fuzzy: 0.6
      }
    });
    l.addAll(n.items);
    const r = C(""), a = S({
      get: () => n.items.find((i) => i.id === n.modelValue) || n.items[0],
      set: (i) => t("update:modelValue", i.id)
    }), o = S(() => {
      var d;
      if (r.value === "")
        return n.items;
      const i = l.search(r.value).map((f) => f.id), s = (d = n.items) == null ? void 0 : d.filter((f) => f.name.toLowerCase().includes(r.value.toLowerCase())).map((f) => f.id), u = [...i, ...s];
      return n.items.filter((f) => u.includes(f.id));
    });
    return (i, s) => (A(), H(F(Va), {
      modelValue: F(a),
      "onUpdate:modelValue": s[1] || (s[1] = (u) => Ke(a) ? a.value = u : null),
      disabled: e.disabled,
      as: "div",
      class: "w-full"
    }, {
      default: N(() => {
        var u;
        return [
          e.label || (u = e.definition) != null && u.title ? (A(), H(F(Ma), {
            key: 0,
            class: "block"
          }, {
            default: N(() => {
              var c;
              return [
                z(Ce, {
                  hint: e.hint || ((c = e.definition) == null ? void 0 : c.examples[0])
                }, {
                  default: N(() => [
                    ge(re(e.label || e.definition.title), 1)
                  ]),
                  _: 1
                }, 8, ["hint"])
              ];
            }),
            _: 1
          })) : Q("", !0),
          R("div", yu, [
            z(F(jt), { class: "w-full" }, {
              default: N(() => [
                z(F(ja), {
                  class: Z(["tune-input w-full py-2 !pr-[30px] pl-3 focus:outline-none", { "cursor-not-allowed": e.disabled }]),
                  spellcheck: "false",
                  "display-value": (c) => c.name,
                  disabled: e.disabled,
                  onChange: s[0] || (s[0] = (c) => r.value = c.target.value)
                }, null, 8, ["display-value", "class", "disabled"])
              ]),
              _: 1
            }),
            z(F(jt), {
              class: Z(["absolute inset-y-0 right-1 flex items-center px-2 focus:outline-none", { "cursor-not-allowed": e.disabled }])
            }, {
              default: N(() => [
                z(F(Ye), { class: "text-sm" })
              ]),
              _: 1
            }, 8, ["class"]),
            F(o).length > 0 ? (A(), H(F(Ba), {
              key: 0,
              class: "tune-listbox-options absolute z-40 mt-1 w-full overflow-hidden focus:outline-none"
            }, {
              default: N(() => [
                R("div", gu, [
                  (A(!0), V(pe, null, Le(F(o), (c) => (A(), H(F(Na), {
                    key: c.id,
                    as: "template",
                    value: c
                  }, {
                    default: N(({ active: d, selected: f, disabled: v }) => [
                      R("li", {
                        class: Z([
                          { active: d },
                          "tune-listbox-item relative cursor-default select-none truncate py-2 pl-3 pr-[50px]"
                        ])
                      }, [
                        R("span", {
                          class: Z([
                            f ? "selected" : "font-normal",
                            { disabled: v },
                            "tune-listbox-item block truncate"
                          ])
                        }, [
                          i.$slots.item ? ye(i.$slots, "item", {
                            key: 0,
                            item: c
                          }) : (A(), V("span", wu, re(c.name), 1))
                        ], 2),
                        f ? (A(), V("span", xu, [
                          z(F(tn), { class: "text-sm" })
                        ])) : Q("", !0)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value"]))), 128))
                ])
              ]),
              _: 3
            })) : Q("", !0)
          ])
        ];
      }),
      _: 3
    }, 8, ["modelValue", "disabled"]));
  }
}), $u = { class: "tune-tag" }, $l = /* @__PURE__ */ D({
  __name: "TuneTag",
  props: {
    label: null
  },
  setup(e) {
    return (t, n) => (A(), V("span", $u, re(e.label), 1));
  }
}), Su = { class: "relative" }, Tu = { class: "no-scrollbar flex items-center overflow-x-auto" }, Ou = {
  key: 0,
  class: "whitespace-nowrap py-2 pl-2"
}, Cu = { class: "max-h-[180px] overflow-y-auto" }, Au = { key: 1 }, Eu = {
  key: 0,
  class: /* @__PURE__ */ Z(["absolute inset-y-0 right-0 flex items-center pr-3"])
}, Ey = /* @__PURE__ */ D({
  __name: "TuneComboboxMultiple",
  props: {
    modelValue: null,
    items: null,
    label: null,
    hint: null,
    disabled: { type: Boolean },
    definition: null
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e;
    let l = new xl({
      fields: ["id", "name"],
      storeFields: ["id"],
      searchOptions: {
        boost: { name: 2 },
        fuzzy: 0.4
      }
    });
    l.addAll(n.items);
    const r = C(""), a = S({
      get: () => n.items.filter((i) => n.modelValue.includes(i.id)),
      set: (i) => t(
        "update:modelValue",
        i.map((s) => s.id)
      )
    }), o = S(() => {
      var d;
      if (r.value === "")
        return n.items;
      const i = l.search(r.value).map((f) => f.id), s = (d = n.items) == null ? void 0 : d.filter((f) => f.name.toLowerCase().includes(r.value.toLowerCase())).map((f) => f.id), u = [...i, ...s];
      return n.items.filter((f) => u.includes(f.id));
    });
    return (i, s) => (A(), H(F(Va), {
      modelValue: F(a),
      "onUpdate:modelValue": s[2] || (s[2] = (u) => Ke(a) ? a.value = u : null),
      multiple: "",
      disabled: e.disabled,
      as: "div",
      class: "w-full"
    }, {
      default: N(() => {
        var u;
        return [
          e.label || (u = e.definition) != null && u.title ? (A(), H(F(Ma), {
            key: 0,
            class: "block"
          }, {
            default: N(() => {
              var c;
              return [
                z(Ce, {
                  hint: e.hint || ((c = e.definition) == null ? void 0 : c.examples[0])
                }, {
                  default: N(() => [
                    ge(re(e.label || e.definition.title), 1)
                  ]),
                  _: 1
                }, 8, ["hint"])
              ];
            }),
            _: 1
          })) : Q("", !0),
          R("div", Su, [
            z(F(jt), { class: "tune-listbox-button w-full" }, {
              default: N(() => [
                R("div", Tu, [
                  F(a).length ? (A(), V("div", Ou, [
                    (A(!0), V(pe, null, Le(F(a), (c) => (A(), V("span", {
                      key: c.id,
                      class: "mr-1 inline-block"
                    }, [
                      z($l, {
                        label: c.name
                      }, null, 8, ["label"])
                    ]))), 128))
                  ])) : Q("", !0),
                  z(F(ja), {
                    class: Z(["mr-1 w-full min-w-[200px] py-2 !pr-[30px] pl-2 focus:outline-none", { "cursor-not-allowed": e.disabled }]),
                    spellcheck: "false",
                    disabled: e.disabled,
                    onBlur: s[0] || (s[0] = (c) => r.value = ""),
                    onChange: s[1] || (s[1] = (c) => r.value = c.target.value)
                  }, null, 8, ["class", "disabled"])
                ])
              ]),
              _: 1
            }),
            z(F(jt), {
              class: Z(["absolute inset-y-0 right-1 flex items-center px-2 focus:outline-none", { "cursor-not-allowed": e.disabled }])
            }, {
              default: N(() => [
                z(F(Ye), { class: "text-sm" })
              ]),
              _: 1
            }, 8, ["class"]),
            F(o).length > 0 ? (A(), H(F(Ba), {
              key: 0,
              class: "tune-listbox-options absolute z-40 mt-1 w-full overflow-hidden focus:outline-none"
            }, {
              default: N(() => [
                R("div", Cu, [
                  (A(!0), V(pe, null, Le(F(o), (c) => (A(), H(F(Na), {
                    key: c.id,
                    as: "template",
                    value: c
                  }, {
                    default: N(({ active: d, selected: f, disabled: v }) => [
                      R("li", {
                        class: Z([
                          { active: d },
                          "tune-listbox-item relative cursor-default select-none truncate py-2 pl-3 pr-[50px]"
                        ])
                      }, [
                        R("span", {
                          class: Z([
                            f ? "selected" : "font-normal",
                            { disabled: v },
                            "tune-listbox-item block truncate"
                          ])
                        }, [
                          i.$slots.item ? ye(i.$slots, "item", {
                            key: 0,
                            item: c
                          }) : (A(), V("span", Au, re(c.name), 1))
                        ], 2),
                        f ? (A(), V("span", Eu, [
                          z(F(tn), { class: "text-sm" })
                        ])) : Q("", !0)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value"]))), 128))
                ])
              ]),
              _: 3
            })) : Q("", !0)
          ])
        ];
      }),
      _: 3
    }, 8, ["modelValue", "disabled"]));
  }
}), Pu = {
  class: /* @__PURE__ */ Z(["tune-error-text mt-[2px]"])
}, nn = /* @__PURE__ */ D({
  __name: "TuneErrorInput",
  props: {
    error: null
  },
  setup(e) {
    return (t, n) => (A(), V("div", Pu, re(e.error), 1));
  }
}), Fu = { class: "flex" }, Iu = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
}, _u = ["type", "value", "placeholder", "readonly", "disabled", "maxlength"], Lu = {
  key: 1,
  class: "tune-input-loading absolute inset-y-0 right-0 top-[1px] mr-1 flex h-[40px] items-center overflow-hidden pl-2 pr-2"
}, ku = {
  key: 2,
  class: "absolute inset-y-0 right-0 flex items-center pr-4"
}, Du = {
  inheritAttrs: !1
}, rn = /* @__PURE__ */ D({
  ...Du,
  __name: "TuneInput",
  props: {
    label: { default: "" },
    hint: { default: "" },
    loading: { type: Boolean, default: !1 },
    error: { default: "" },
    block: { type: Boolean, default: !0 },
    type: { default: "text" },
    modelValue: { default: "" },
    autofocus: { type: Boolean, default: !1 },
    placeholder: { default: "" },
    maxLength: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    definition: { default: {} }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const n = e, l = C(), r = C(!1);
    function a() {
      r.value = !0;
    }
    return t({
      forceShowError: a
    }), X(() => {
      var o;
      n.autofocus && ((o = l == null ? void 0 : l.value) == null || o.focus());
    }), (o, i) => {
      var s, u, c, d, f;
      return A(), V("div", {
        class: Z({ "w-full": e.block })
      }, [
        e.label || (s = e.definition) != null && s.title ? (A(), H(Ce, {
          key: 0,
          hint: e.hint || ((u = e.definition) == null ? void 0 : u.description)
        }, {
          default: N(() => [
            ge(re(e.label || e.definition.title), 1)
          ]),
          _: 1
        }, 8, ["hint"])) : Q("", !0),
        R("div", Fu, [
          R("div", {
            class: Z(["group relative z-10 flex", { "w-full": e.block }])
          }, [
            o.$slots.before ? (A(), V("div", Iu, [
              ye(o.$slots, "before")
            ])) : Q("", !0),
            R("input", Ie(o.$attrs, {
              ref_key: "inputRef",
              ref: l,
              type: e.type,
              value: e.modelValue,
              class: [
                "tune-input px-3 py-2",
                { "tune-error-border": e.error && r.value },
                { "cursor-not-allowed": e.disabled },
                { "w-full": e.block }
              ],
              placeholder: e.placeholder || ((d = (c = e.definition) == null ? void 0 : c.examples) == null ? void 0 : d[0]) || "",
              readonly: e.readonly,
              disabled: e.disabled,
              maxlength: e.maxLength || ((f = e.definition) == null ? void 0 : f.maxLength),
              onBlur: i[0] || (i[0] = (v) => e.error ? r.value = !0 : null),
              onFocus: i[1] || (i[1] = (v) => e.error ? null : r.value = !1),
              onInput: i[2] || (i[2] = (v) => o.$emit("update:modelValue", v.target.value))
            }), null, 16, _u),
            e.loading || e.error && r.value ? (A(), V("div", Lu, [
              e.loading ? (A(), H(Aa, { key: 0 })) : Q("", !0)
            ])) : o.$slots.after ? (A(), V("div", ku, [
              ye(o.$slots, "after")
            ])) : Q("", !0)
          ], 2)
        ]),
        e.error && r.value ? (A(), H(nn, {
          key: 1,
          error: e.error
        }, null, 8, ["error"])) : Q("", !0)
      ], 2);
    };
  }
}), Ru = ["placeholder", "disabled", "maxlength"], Vu = {
  inheritAttrs: !1
}, fr = /* @__PURE__ */ D({
  ...Vu,
  __name: "TuneTextarea",
  props: {
    modelValue: null,
    definition: null,
    label: { default: "" },
    hint: { default: "" },
    placeholder: { default: "" },
    error: { default: "" },
    autosize: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    maxLength: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const l = e, r = S({
      get: () => {
        var d;
        return l.modelValue || ((d = l.definition) == null ? void 0 : d.default) || "";
      },
      set: (d) => n("update:modelValue", d)
    }), a = C(), o = C(!1), i = C("auto"), s = S(() => l.autosize ? `resize: none; height: ${i.value};` : "");
    function u() {
      o.value = !0;
    }
    function c() {
      i.value = "auto", ie(() => {
        if (!a.value)
          return;
        let d = a.value.scrollHeight + 1;
        i.value = `${d}px`;
      });
    }
    return t({
      forceShowError: u
    }), se(r, (d) => {
      ie(c), d && c();
    }), X(() => c()), (d, f) => {
      var v, p, m, h;
      return A(), V("div", null, [
        z(Ce, {
          hint: e.hint || ((v = e.definition) == null ? void 0 : v.description)
        }, {
          default: N(() => {
            var b;
            return [
              ge(re(e.label || ((b = e.definition) == null ? void 0 : b.title)), 1)
            ];
          }),
          _: 1
        }, 8, ["hint"]),
        qt(R("textarea", Ie(d.$attrs, {
          ref_key: "textareaRef",
          ref: a,
          "onUpdate:modelValue": f[0] || (f[0] = (b) => Ke(r) ? r.value = b : null),
          class: [
            "tune-textarea w-full",
            {
              "tune-error-border": !!e.error && o.value
            },
            { disabled: e.disabled }
          ],
          style: F(s),
          placeholder: e.placeholder || ((m = (p = e.definition) == null ? void 0 : p.examples) == null ? void 0 : m[0]),
          disabled: e.disabled,
          maxlength: e.maxLength || ((h = e.definition) == null ? void 0 : h.maxLength),
          onBlur: f[1] || (f[1] = (b) => e.error ? o.value = !0 : null),
          onFocus: f[2] || (f[2] = (b) => e.error ? null : o.value = !1)
        }), null, 16, Ru), [
          [bo, F(r)]
        ]),
        e.error && o.value ? (A(), H(nn, {
          key: 0,
          class: "!-mt-1",
          error: e.error
        }, null, 8, ["error"])) : Q("", !0)
      ]);
    };
  }
});
var kt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Mu() {
  this.__data__ = [], this.size = 0;
}
var ju = Mu;
function Bu(e, t) {
  return e === t || e !== e && t !== t;
}
var vr = Bu, Nu = vr;
function zu(e, t) {
  for (var n = e.length; n--; )
    if (Nu(e[n][0], t))
      return n;
  return -1;
}
var an = zu, Uu = an, Hu = Array.prototype, Gu = Hu.splice;
function Wu(e) {
  var t = this.__data__, n = Uu(t, e);
  if (n < 0)
    return !1;
  var l = t.length - 1;
  return n == l ? t.pop() : Gu.call(t, n, 1), --this.size, !0;
}
var Ku = Wu, qu = an;
function Yu(e) {
  var t = this.__data__, n = qu(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var Ju = Yu, Zu = an;
function Qu(e) {
  return Zu(this.__data__, e) > -1;
}
var Xu = Qu, es = an;
function ts(e, t) {
  var n = this.__data__, l = es(n, e);
  return l < 0 ? (++this.size, n.push([e, t])) : n[l][1] = t, this;
}
var ns = ts, rs = ju, as = Ku, ls = Ju, os = Xu, is = ns;
function at(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var l = e[t];
    this.set(l[0], l[1]);
  }
}
at.prototype.clear = rs;
at.prototype.delete = as;
at.prototype.get = ls;
at.prototype.has = os;
at.prototype.set = is;
var ln = at, us = ln;
function ss() {
  this.__data__ = new us(), this.size = 0;
}
var cs = ss;
function ds(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var fs = ds;
function vs(e) {
  return this.__data__.get(e);
}
var ps = vs;
function hs(e) {
  return this.__data__.has(e);
}
var ms = hs, bs = typeof kt == "object" && kt && kt.Object === Object && kt, Sl = bs, ys = Sl, gs = typeof self == "object" && self && self.Object === Object && self, ws = ys || gs || Function("return this")(), De = ws, xs = De, $s = xs.Symbol, on = $s, Lr = on, Tl = Object.prototype, Ss = Tl.hasOwnProperty, Ts = Tl.toString, vt = Lr ? Lr.toStringTag : void 0;
function Os(e) {
  var t = Ss.call(e, vt), n = e[vt];
  try {
    e[vt] = void 0;
    var l = !0;
  } catch {
  }
  var r = Ts.call(e);
  return l && (t ? e[vt] = n : delete e[vt]), r;
}
var Cs = Os, As = Object.prototype, Es = As.toString;
function Ps(e) {
  return Es.call(e);
}
var Fs = Ps, kr = on, Is = Cs, _s = Fs, Ls = "[object Null]", ks = "[object Undefined]", Dr = kr ? kr.toStringTag : void 0;
function Ds(e) {
  return e == null ? e === void 0 ? ks : Ls : Dr && Dr in Object(e) ? Is(e) : _s(e);
}
var un = Ds;
function Rs(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Et = Rs, Vs = un, Ms = Et, js = "[object AsyncFunction]", Bs = "[object Function]", Ns = "[object GeneratorFunction]", zs = "[object Proxy]";
function Us(e) {
  if (!Ms(e))
    return !1;
  var t = Vs(e);
  return t == Bs || t == Ns || t == js || t == zs;
}
var Ol = Us, Hs = De, Gs = Hs["__core-js_shared__"], Ws = Gs, Pn = Ws, Rr = function() {
  var e = /[^.]+$/.exec(Pn && Pn.keys && Pn.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Ks(e) {
  return !!Rr && Rr in e;
}
var qs = Ks, Ys = Function.prototype, Js = Ys.toString;
function Zs(e) {
  if (e != null) {
    try {
      return Js.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Cl = Zs, Qs = Ol, Xs = qs, ec = Et, tc = Cl, nc = /[\\^$.*+?()[\]{}|]/g, rc = /^\[object .+?Constructor\]$/, ac = Function.prototype, lc = Object.prototype, oc = ac.toString, ic = lc.hasOwnProperty, uc = RegExp(
  "^" + oc.call(ic).replace(nc, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function sc(e) {
  if (!ec(e) || Xs(e))
    return !1;
  var t = Qs(e) ? uc : rc;
  return t.test(tc(e));
}
var cc = sc;
function dc(e, t) {
  return e == null ? void 0 : e[t];
}
var fc = dc, vc = cc, pc = fc;
function hc(e, t) {
  var n = pc(e, t);
  return vc(n) ? n : void 0;
}
var Je = hc, mc = Je, bc = De, yc = mc(bc, "Map"), pr = yc, gc = Je, wc = gc(Object, "create"), sn = wc, Vr = sn;
function xc() {
  this.__data__ = Vr ? Vr(null) : {}, this.size = 0;
}
var $c = xc;
function Sc(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Tc = Sc, Oc = sn, Cc = "__lodash_hash_undefined__", Ac = Object.prototype, Ec = Ac.hasOwnProperty;
function Pc(e) {
  var t = this.__data__;
  if (Oc) {
    var n = t[e];
    return n === Cc ? void 0 : n;
  }
  return Ec.call(t, e) ? t[e] : void 0;
}
var Fc = Pc, Ic = sn, _c = Object.prototype, Lc = _c.hasOwnProperty;
function kc(e) {
  var t = this.__data__;
  return Ic ? t[e] !== void 0 : Lc.call(t, e);
}
var Dc = kc, Rc = sn, Vc = "__lodash_hash_undefined__";
function Mc(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Rc && t === void 0 ? Vc : t, this;
}
var jc = Mc, Bc = $c, Nc = Tc, zc = Fc, Uc = Dc, Hc = jc;
function lt(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var l = e[t];
    this.set(l[0], l[1]);
  }
}
lt.prototype.clear = Bc;
lt.prototype.delete = Nc;
lt.prototype.get = zc;
lt.prototype.has = Uc;
lt.prototype.set = Hc;
var Gc = lt, Mr = Gc, Wc = ln, Kc = pr;
function qc() {
  this.size = 0, this.__data__ = {
    hash: new Mr(),
    map: new (Kc || Wc)(),
    string: new Mr()
  };
}
var Yc = qc;
function Jc(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Zc = Jc, Qc = Zc;
function Xc(e, t) {
  var n = e.__data__;
  return Qc(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var cn = Xc, ed = cn;
function td(e) {
  var t = ed(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var nd = td, rd = cn;
function ad(e) {
  return rd(this, e).get(e);
}
var ld = ad, od = cn;
function id(e) {
  return od(this, e).has(e);
}
var ud = id, sd = cn;
function cd(e, t) {
  var n = sd(this, e), l = n.size;
  return n.set(e, t), this.size += n.size == l ? 0 : 1, this;
}
var dd = cd, fd = Yc, vd = nd, pd = ld, hd = ud, md = dd;
function ot(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var l = e[t];
    this.set(l[0], l[1]);
  }
}
ot.prototype.clear = fd;
ot.prototype.delete = vd;
ot.prototype.get = pd;
ot.prototype.has = hd;
ot.prototype.set = md;
var Al = ot, bd = ln, yd = pr, gd = Al, wd = 200;
function xd(e, t) {
  var n = this.__data__;
  if (n instanceof bd) {
    var l = n.__data__;
    if (!yd || l.length < wd - 1)
      return l.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new gd(l);
  }
  return n.set(e, t), this.size = n.size, this;
}
var $d = xd, Sd = ln, Td = cs, Od = fs, Cd = ps, Ad = ms, Ed = $d;
function it(e) {
  var t = this.__data__ = new Sd(e);
  this.size = t.size;
}
it.prototype.clear = Td;
it.prototype.delete = Od;
it.prototype.get = Cd;
it.prototype.has = Ad;
it.prototype.set = Ed;
var El = it, Pd = "__lodash_hash_undefined__";
function Fd(e) {
  return this.__data__.set(e, Pd), this;
}
var Id = Fd;
function _d(e) {
  return this.__data__.has(e);
}
var Ld = _d, kd = Al, Dd = Id, Rd = Ld;
function zt(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new kd(); ++t < n; )
    this.add(e[t]);
}
zt.prototype.add = zt.prototype.push = Dd;
zt.prototype.has = Rd;
var Vd = zt;
function Md(e, t) {
  for (var n = -1, l = e == null ? 0 : e.length; ++n < l; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var jd = Md;
function Bd(e, t) {
  return e.has(t);
}
var Nd = Bd, zd = Vd, Ud = jd, Hd = Nd, Gd = 1, Wd = 2;
function Kd(e, t, n, l, r, a) {
  var o = n & Gd, i = e.length, s = t.length;
  if (i != s && !(o && s > i))
    return !1;
  var u = a.get(e), c = a.get(t);
  if (u && c)
    return u == t && c == e;
  var d = -1, f = !0, v = n & Wd ? new zd() : void 0;
  for (a.set(e, t), a.set(t, e); ++d < i; ) {
    var p = e[d], m = t[d];
    if (l)
      var h = o ? l(m, p, d, t, e, a) : l(p, m, d, e, t, a);
    if (h !== void 0) {
      if (h)
        continue;
      f = !1;
      break;
    }
    if (v) {
      if (!Ud(t, function(b, y) {
        if (!Hd(v, y) && (p === b || r(p, b, n, l, a)))
          return v.push(y);
      })) {
        f = !1;
        break;
      }
    } else if (!(p === m || r(p, m, n, l, a))) {
      f = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), f;
}
var Pl = Kd, qd = De, Yd = qd.Uint8Array, Fl = Yd;
function Jd(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(l, r) {
    n[++t] = [r, l];
  }), n;
}
var Zd = Jd;
function Qd(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(l) {
    n[++t] = l;
  }), n;
}
var Xd = Qd, jr = on, Br = Fl, ef = vr, tf = Pl, nf = Zd, rf = Xd, af = 1, lf = 2, of = "[object Boolean]", uf = "[object Date]", sf = "[object Error]", cf = "[object Map]", df = "[object Number]", ff = "[object RegExp]", vf = "[object Set]", pf = "[object String]", hf = "[object Symbol]", mf = "[object ArrayBuffer]", bf = "[object DataView]", Nr = jr ? jr.prototype : void 0, Fn = Nr ? Nr.valueOf : void 0;
function yf(e, t, n, l, r, a, o) {
  switch (n) {
    case bf:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case mf:
      return !(e.byteLength != t.byteLength || !a(new Br(e), new Br(t)));
    case of:
    case uf:
    case df:
      return ef(+e, +t);
    case sf:
      return e.name == t.name && e.message == t.message;
    case ff:
    case pf:
      return e == t + "";
    case cf:
      var i = nf;
    case vf:
      var s = l & af;
      if (i || (i = rf), e.size != t.size && !s)
        return !1;
      var u = o.get(e);
      if (u)
        return u == t;
      l |= lf, o.set(e, t);
      var c = tf(i(e), i(t), l, r, a, o);
      return o.delete(e), c;
    case hf:
      if (Fn)
        return Fn.call(e) == Fn.call(t);
  }
  return !1;
}
var gf = yf;
function wf(e, t) {
  for (var n = -1, l = t.length, r = e.length; ++n < l; )
    e[r + n] = t[n];
  return e;
}
var Il = wf, xf = Array.isArray, dn = xf, $f = Il, Sf = dn;
function Tf(e, t, n) {
  var l = t(e);
  return Sf(e) ? l : $f(l, n(e));
}
var _l = Tf;
function Of(e, t) {
  for (var n = -1, l = e == null ? 0 : e.length, r = 0, a = []; ++n < l; ) {
    var o = e[n];
    t(o, n, e) && (a[r++] = o);
  }
  return a;
}
var Cf = Of;
function Af() {
  return [];
}
var Ll = Af, Ef = Cf, Pf = Ll, Ff = Object.prototype, If = Ff.propertyIsEnumerable, zr = Object.getOwnPropertySymbols, _f = zr ? function(e) {
  return e == null ? [] : (e = Object(e), Ef(zr(e), function(t) {
    return If.call(e, t);
  }));
} : Pf, hr = _f;
function Lf(e, t) {
  for (var n = -1, l = Array(e); ++n < e; )
    l[n] = t(n);
  return l;
}
var kf = Lf;
function Df(e) {
  return e != null && typeof e == "object";
}
var ut = Df, Rf = un, Vf = ut, Mf = "[object Arguments]";
function jf(e) {
  return Vf(e) && Rf(e) == Mf;
}
var Bf = jf, Ur = Bf, Nf = ut, kl = Object.prototype, zf = kl.hasOwnProperty, Uf = kl.propertyIsEnumerable, Hf = Ur(function() {
  return arguments;
}()) ? Ur : function(e) {
  return Nf(e) && zf.call(e, "callee") && !Uf.call(e, "callee");
}, Gf = Hf, et = {}, Wf = {
  get exports() {
    return et;
  },
  set exports(e) {
    et = e;
  }
};
function Kf() {
  return !1;
}
var qf = Kf;
(function(e, t) {
  var n = De, l = qf, r = t && !t.nodeType && t, a = r && !0 && e && !e.nodeType && e, o = a && a.exports === r, i = o ? n.Buffer : void 0, s = i ? i.isBuffer : void 0, u = s || l;
  e.exports = u;
})(Wf, et);
var Yf = 9007199254740991, Jf = /^(?:0|[1-9]\d*)$/;
function Zf(e, t) {
  var n = typeof e;
  return t = t ?? Yf, !!t && (n == "number" || n != "symbol" && Jf.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Qf = Zf, Xf = 9007199254740991;
function ev(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Xf;
}
var Dl = ev, tv = un, nv = Dl, rv = ut, av = "[object Arguments]", lv = "[object Array]", ov = "[object Boolean]", iv = "[object Date]", uv = "[object Error]", sv = "[object Function]", cv = "[object Map]", dv = "[object Number]", fv = "[object Object]", vv = "[object RegExp]", pv = "[object Set]", hv = "[object String]", mv = "[object WeakMap]", bv = "[object ArrayBuffer]", yv = "[object DataView]", gv = "[object Float32Array]", wv = "[object Float64Array]", xv = "[object Int8Array]", $v = "[object Int16Array]", Sv = "[object Int32Array]", Tv = "[object Uint8Array]", Ov = "[object Uint8ClampedArray]", Cv = "[object Uint16Array]", Av = "[object Uint32Array]", oe = {};
oe[gv] = oe[wv] = oe[xv] = oe[$v] = oe[Sv] = oe[Tv] = oe[Ov] = oe[Cv] = oe[Av] = !0;
oe[av] = oe[lv] = oe[bv] = oe[ov] = oe[yv] = oe[iv] = oe[uv] = oe[sv] = oe[cv] = oe[dv] = oe[fv] = oe[vv] = oe[pv] = oe[hv] = oe[mv] = !1;
function Ev(e) {
  return rv(e) && nv(e.length) && !!oe[tv(e)];
}
var Pv = Ev;
function Fv(e) {
  return function(t) {
    return e(t);
  };
}
var mr = Fv, tt = {}, Iv = {
  get exports() {
    return tt;
  },
  set exports(e) {
    tt = e;
  }
};
(function(e, t) {
  var n = Sl, l = t && !t.nodeType && t, r = l && !0 && e && !e.nodeType && e, a = r && r.exports === l, o = a && n.process, i = function() {
    try {
      var s = r && r.require && r.require("util").types;
      return s || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = i;
})(Iv, tt);
var _v = Pv, Lv = mr, Hr = tt, Gr = Hr && Hr.isTypedArray, kv = Gr ? Lv(Gr) : _v, Rl = kv, Dv = kf, Rv = Gf, Vv = dn, Mv = et, jv = Qf, Bv = Rl, Nv = Object.prototype, zv = Nv.hasOwnProperty;
function Uv(e, t) {
  var n = Vv(e), l = !n && Rv(e), r = !n && !l && Mv(e), a = !n && !l && !r && Bv(e), o = n || l || r || a, i = o ? Dv(e.length, String) : [], s = i.length;
  for (var u in e)
    (t || zv.call(e, u)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    jv(u, s))) && i.push(u);
  return i;
}
var Vl = Uv, Hv = Object.prototype;
function Gv(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Hv;
  return e === n;
}
var br = Gv;
function Wv(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Ml = Wv, Kv = Ml, qv = Kv(Object.keys, Object), Yv = qv, Jv = br, Zv = Yv, Qv = Object.prototype, Xv = Qv.hasOwnProperty;
function ep(e) {
  if (!Jv(e))
    return Zv(e);
  var t = [];
  for (var n in Object(e))
    Xv.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var tp = ep, np = Ol, rp = Dl;
function ap(e) {
  return e != null && rp(e.length) && !np(e);
}
var jl = ap, lp = Vl, op = tp, ip = jl;
function up(e) {
  return ip(e) ? lp(e) : op(e);
}
var yr = up, sp = _l, cp = hr, dp = yr;
function fp(e) {
  return sp(e, dp, cp);
}
var Bl = fp, Wr = Bl, vp = 1, pp = Object.prototype, hp = pp.hasOwnProperty;
function mp(e, t, n, l, r, a) {
  var o = n & vp, i = Wr(e), s = i.length, u = Wr(t), c = u.length;
  if (s != c && !o)
    return !1;
  for (var d = s; d--; ) {
    var f = i[d];
    if (!(o ? f in t : hp.call(t, f)))
      return !1;
  }
  var v = a.get(e), p = a.get(t);
  if (v && p)
    return v == t && p == e;
  var m = !0;
  a.set(e, t), a.set(t, e);
  for (var h = o; ++d < s; ) {
    f = i[d];
    var b = e[f], y = t[f];
    if (l)
      var g = o ? l(y, b, f, t, e, a) : l(b, y, f, e, t, a);
    if (!(g === void 0 ? b === y || r(b, y, n, l, a) : g)) {
      m = !1;
      break;
    }
    h || (h = f == "constructor");
  }
  if (m && !h) {
    var x = e.constructor, w = t.constructor;
    x != w && "constructor" in e && "constructor" in t && !(typeof x == "function" && x instanceof x && typeof w == "function" && w instanceof w) && (m = !1);
  }
  return a.delete(e), a.delete(t), m;
}
var bp = mp, yp = Je, gp = De, wp = yp(gp, "DataView"), xp = wp, $p = Je, Sp = De, Tp = $p(Sp, "Promise"), Op = Tp, Cp = Je, Ap = De, Ep = Cp(Ap, "Set"), Pp = Ep, Fp = Je, Ip = De, _p = Fp(Ip, "WeakMap"), Lp = _p, Nn = xp, zn = pr, Un = Op, Hn = Pp, Gn = Lp, Nl = un, st = Cl, Kr = "[object Map]", kp = "[object Object]", qr = "[object Promise]", Yr = "[object Set]", Jr = "[object WeakMap]", Zr = "[object DataView]", Dp = st(Nn), Rp = st(zn), Vp = st(Un), Mp = st(Hn), jp = st(Gn), He = Nl;
(Nn && He(new Nn(new ArrayBuffer(1))) != Zr || zn && He(new zn()) != Kr || Un && He(Un.resolve()) != qr || Hn && He(new Hn()) != Yr || Gn && He(new Gn()) != Jr) && (He = function(e) {
  var t = Nl(e), n = t == kp ? e.constructor : void 0, l = n ? st(n) : "";
  if (l)
    switch (l) {
      case Dp:
        return Zr;
      case Rp:
        return Kr;
      case Vp:
        return qr;
      case Mp:
        return Yr;
      case jp:
        return Jr;
    }
  return t;
});
var fn = He, In = El, Bp = Pl, Np = gf, zp = bp, Qr = fn, Xr = dn, ea = et, Up = Rl, Hp = 1, ta = "[object Arguments]", na = "[object Array]", Dt = "[object Object]", Gp = Object.prototype, ra = Gp.hasOwnProperty;
function Wp(e, t, n, l, r, a) {
  var o = Xr(e), i = Xr(t), s = o ? na : Qr(e), u = i ? na : Qr(t);
  s = s == ta ? Dt : s, u = u == ta ? Dt : u;
  var c = s == Dt, d = u == Dt, f = s == u;
  if (f && ea(e)) {
    if (!ea(t))
      return !1;
    o = !0, c = !1;
  }
  if (f && !c)
    return a || (a = new In()), o || Up(e) ? Bp(e, t, n, l, r, a) : Np(e, t, s, n, l, r, a);
  if (!(n & Hp)) {
    var v = c && ra.call(e, "__wrapped__"), p = d && ra.call(t, "__wrapped__");
    if (v || p) {
      var m = v ? e.value() : e, h = p ? t.value() : t;
      return a || (a = new In()), r(m, h, n, l, a);
    }
  }
  return f ? (a || (a = new In()), zp(e, t, n, l, r, a)) : !1;
}
var Kp = Wp, qp = Kp, aa = ut;
function zl(e, t, n, l, r) {
  return e === t ? !0 : e == null || t == null || !aa(e) && !aa(t) ? e !== e && t !== t : qp(e, t, n, l, zl, r);
}
var Yp = zl, Jp = Yp;
function Zp(e, t) {
  return Jp(e, t);
}
var Qp = Zp;
const Xp = { class: "relative" }, eh = { key: 1 }, th = {
  key: 2,
  class: "tune-listbox-placeholder"
}, nh = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-[12px]" }, rh = { class: "max-h-[180px] overflow-y-auto" }, ah = { key: 1 }, lh = {
  key: 0,
  class: /* @__PURE__ */ Z(["absolute inset-y-0 right-0 flex items-center pr-3"])
}, oh = /* @__PURE__ */ D({
  __name: "TuneListbox",
  props: {
    items: null,
    modelValue: null,
    label: null,
    disabled: { type: Boolean },
    definition: null,
    hint: null,
    error: null
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const l = e, r = S({
      get: () => l.items.find((i) => Qp(i.value, l.modelValue)) ?? { value: "" },
      set: (i) => n("update:modelValue", i.value)
    }), a = C(!1);
    function o() {
      a.value = !0;
    }
    return t({
      forceShowError: o
    }), (i, s) => (A(), V("div", null, [
      z(F(Qa), {
        modelValue: F(r),
        "onUpdate:modelValue": s[0] || (s[0] = (u) => Ke(r) ? r.value = u : null),
        as: "div",
        disabled: e.disabled
      }, {
        default: N(() => [
          z(F(Xa), null, {
            default: N(() => {
              var u;
              return [
                z(Ce, {
                  hint: e.hint || ((u = e.definition) == null ? void 0 : u.description)
                }, {
                  default: N(() => {
                    var c;
                    return [
                      ge(re(e.label || ((c = e.definition) == null ? void 0 : c.title)), 1)
                    ];
                  }),
                  _: 1
                }, 8, ["hint"])
              ];
            }),
            _: 1
          }),
          R("div", Xp, [
            z(F(el), {
              class: Z(["tune-listbox-button relative h-[42px] w-full truncate pl-3 pr-[40px] text-left", [
                { "disabled cursor-not-allowed": e.disabled },
                {
                  error: a.value && e.error
                }
              ]])
            }, {
              default: N(() => {
                var u, c, d;
                return [
                  i.$slots.selected ? ye(i.$slots, "selected", {
                    key: 0,
                    selectedItem: F(r)
                  }) : (u = F(r)) != null && u.value ? (A(), V("span", eh, re(((c = F(r)) == null ? void 0 : c.name) || ((d = F(r)) == null ? void 0 : d.value)), 1)) : (A(), V("span", th, " Select ")),
                  R("span", nh, [
                    z(F(Ye), { class: "text-sm" })
                  ])
                ];
              }),
              _: 3
            }, 8, ["class"]),
            z(Xn, {
              "enter-active-class": "transition duration-100 ease-out",
              "enter-from-class": "transform -translate-y-2 scale-95 opacity-0",
              "enter-to-class": "transform scale-100 opacity-100",
              "leave-active-class": "transition duration-75 ease-out",
              "leave-from-class": "transform scale-100 opacity-100",
              "leave-to-class": "transform scale-95 opacity-0"
            }, {
              default: N(() => [
                z(F(tl), { class: "tune-listbox-options absolute z-40 mt-1 w-full overflow-hidden focus:outline-none" }, {
                  default: N(() => [
                    R("div", rh, [
                      (A(!0), V(pe, null, Le(e.items, (u) => (A(), H(F(nl), {
                        key: u.value,
                        as: "template",
                        value: u
                      }, {
                        default: N(({ active: c, selected: d, disabled: f }) => [
                          R("li", {
                            class: Z([
                              { active: c && !f },
                              "tune-listbox-item relative cursor-default select-none py-2 pl-3 pr-[50px]"
                            ])
                          }, [
                            R("span", {
                              class: Z([
                                d ? "selected" : "font-normal",
                                { disabled: f },
                                "tune-listbox-item block truncate"
                              ])
                            }, [
                              i.$slots.item ? ye(i.$slots, "item", {
                                key: 0,
                                item: u
                              }) : (A(), V("span", ah, re((u == null ? void 0 : u.name) || u.value), 1))
                            ], 2),
                            d ? (A(), V("span", lh, [
                              z(F(tn), { class: "text-sm" })
                            ])) : Q("", !0)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["value"]))), 128))
                    ])
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ])
        ]),
        _: 3
      }, 8, ["modelValue", "disabled"]),
      e.error && a.value ? (A(), H(nn, {
        key: 0,
        error: e.error
      }, null, 8, ["error"])) : Q("", !0)
    ]));
  }
}), Ul = /* @__PURE__ */ D({
  __name: "FormString",
  props: {
    modelValue: null,
    definition: null,
    error: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const l = e, r = C();
    function a() {
      var i;
      (i = r == null ? void 0 : r.value) == null || i.forceShowError();
    }
    t({
      forceShowError: a
    });
    const o = S(() => {
      var i, s;
      return (i = l.definition) != null && i.enum ? l.definition.enum.map((u) => ({
        value: u
      })) : (s = l.definition) != null && s.anyOf ? l.definition.anyOf.map((u) => ({
        value: u.const,
        name: u.title
      })) : [];
    });
    return (i, s) => {
      var u, c, d;
      return (u = e.definition) != null && u.enum || (c = e.definition) != null && c.anyOf ? (A(), H(oh, {
        key: 0,
        ref_key: "textInputRef",
        ref: r,
        items: F(o),
        "model-value": e.modelValue,
        definition: e.definition,
        error: e.error,
        "onUpdate:modelValue": s[0] || (s[0] = (f) => n("update:modelValue", f))
      }, null, 8, ["items", "model-value", "definition", "error"])) : ((d = e.definition) == null ? void 0 : d.format) === "long" ? (A(), H(fr, Ie({
        key: 1,
        ref_key: "textInputRef",
        ref: r
      }, l, {
        "onUpdate:modelValue": s[1] || (s[1] = (f) => n("update:modelValue", f))
      }), null, 16)) : (A(), H(rn, Ie({
        key: 2,
        ref_key: "textInputRef",
        ref: r
      }, l, {
        "onUpdate:modelValue": s[2] || (s[2] = (f) => n("update:modelValue", f))
      }), null, 16));
    };
  }
}), Hl = /* @__PURE__ */ D({
  __name: "FormNumber",
  props: {
    modelValue: null,
    definition: null,
    error: { default: "" },
    type: { default: "number" }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const l = e, r = C();
    function a() {
      var o;
      (o = r == null ? void 0 : r.value) == null || o.forceShowError();
    }
    return t({
      forceShowError: a
    }), (o, i) => (A(), H(rn, Ie({
      ref_key: "numberInputRef",
      ref: r
    }, l, {
      "onUpdate:modelValue": i[0] || (i[0] = (s) => n("update:modelValue", Number(s)))
    }), null, 16));
  }
}), ih = {
  key: 0,
  class: "sr-only"
}, uh = /* @__PURE__ */ R("svg", {
  class: "h-[10px] w-[10px]",
  fill: "none",
  viewBox: "0 0 12 12"
}, [
  /* @__PURE__ */ R("path", {
    d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1), sh = [
  uh
], ch = /* @__PURE__ */ R("svg", {
  class: "h-[10px] w-[10px]",
  fill: "currentColor",
  viewBox: "0 0 12 12"
}, [
  /* @__PURE__ */ R("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
], -1), dh = [
  ch
], fh = /* @__PURE__ */ D({
  __name: "TuneSwitch",
  props: {
    modelValue: { type: Boolean },
    label: null,
    sublabel: null,
    hint: null,
    definition: null,
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    return (n, l) => {
      var r, a, o, i;
      return A(), V("div", {
        class: Z(["flex space-x-2 pr-2 pt-1", e.sublabel || (r = e.definition) != null && r.sublabel ? "items-start" : "items-center"])
      }, [
        z(F(Li), {
          "model-value": e.modelValue,
          class: Z([
            "tune-switch relative inline-flex h-[22px] w-[38px] flex-shrink-0 cursor-pointer rounded-full border-2 transition-colors duration-200 ease-in-out",
            e.modelValue ? "switched-on-bg" : "switched-off-bg",
            { "!cursor-not-allowed ": e.disabled }
          ]),
          disabled: e.disabled,
          "onUpdate:modelValue": l[0] || (l[0] = (s) => t("update:modelValue", s))
        }, {
          default: N(() => {
            var s, u;
            return [
              e.label || (s = e.definition) != null && s.title ? (A(), V("span", ih, re(e.label || ((u = e.definition) == null ? void 0 : u.title)), 1)) : Q("", !0),
              R("span", {
                class: Z([
                  e.modelValue ? "translate-x-[16px]" : "translate-x-0",
                  "shadow tune-switch-button pointer-events-none inline-block h-[18px] w-[18px] transform rounded-full transition duration-200 ease-in-out"
                ])
              }, [
                R("span", {
                  class: Z([
                    e.modelValue ? "opacity-0 duration-100 ease-out" : "opacity-100 duration-200 ease-in",
                    "tune-switch switched-off-text absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
                  ]),
                  "aria-hidden": "true"
                }, sh, 2),
                R("span", {
                  class: Z([
                    e.modelValue ? "opacity-100 duration-200 ease-in" : "opacity-0 duration-100 ease-out",
                    "tune-switch switched-on-text absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
                  ]),
                  "aria-hidden": "true"
                }, dh, 2)
              ], 2)
            ];
          }),
          _: 1
        }, 8, ["model-value", "class", "disabled"]),
        e.label || (a = e.definition) != null && a.title ? (A(), H(Ce, {
          key: 0,
          hint: e.hint || ((o = e.definition) == null ? void 0 : o.description),
          sublabel: e.sublabel || ((i = e.definition) == null ? void 0 : i.sublabel)
        }, {
          default: N(() => {
            var s;
            return [
              ge(re(e.label || ((s = e.definition) == null ? void 0 : s.title)), 1)
            ];
          }),
          _: 1
        }, 8, ["hint", "sublabel"])) : Q("", !0)
      ], 2);
    };
  }
}), Gl = /* @__PURE__ */ D({
  __name: "FormBoolean",
  props: {
    modelValue: { type: Boolean },
    definition: null
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e;
    return X(() => {
      var l;
      t("update:modelValue", n.modelValue || ((l = n.definition) == null ? void 0 : l.default) || !1);
    }), (l, r) => (A(), H(fh, Ie(n, {
      "onUpdate:modelValue": r[0] || (r[0] = (a) => t("update:modelValue", a))
    }), null, 16));
  }
});
function vh(e, t) {
  for (var n = -1, l = e == null ? 0 : e.length; ++n < l && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var ph = vh, hh = Je, mh = function() {
  try {
    var e = hh(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), bh = mh, la = bh;
function yh(e, t, n) {
  t == "__proto__" && la ? la(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var Wl = yh, gh = Wl, wh = vr, xh = Object.prototype, $h = xh.hasOwnProperty;
function Sh(e, t, n) {
  var l = e[t];
  (!($h.call(e, t) && wh(l, n)) || n === void 0 && !(t in e)) && gh(e, t, n);
}
var Kl = Sh, Th = Kl, Oh = Wl;
function Ch(e, t, n, l) {
  var r = !n;
  n || (n = {});
  for (var a = -1, o = t.length; ++a < o; ) {
    var i = t[a], s = l ? l(n[i], e[i], i, n, e) : void 0;
    s === void 0 && (s = e[i]), r ? Oh(n, i, s) : Th(n, i, s);
  }
  return n;
}
var vn = Ch, Ah = vn, Eh = yr;
function Ph(e, t) {
  return e && Ah(t, Eh(t), e);
}
var Fh = Ph;
function Ih(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var _h = Ih, Lh = Et, kh = br, Dh = _h, Rh = Object.prototype, Vh = Rh.hasOwnProperty;
function Mh(e) {
  if (!Lh(e))
    return Dh(e);
  var t = kh(e), n = [];
  for (var l in e)
    l == "constructor" && (t || !Vh.call(e, l)) || n.push(l);
  return n;
}
var jh = Mh, Bh = Vl, Nh = jh, zh = jl;
function Uh(e) {
  return zh(e) ? Bh(e, !0) : Nh(e);
}
var gr = Uh, Hh = vn, Gh = gr;
function Wh(e, t) {
  return e && Hh(t, Gh(t), e);
}
var Kh = Wh, Ut = {}, qh = {
  get exports() {
    return Ut;
  },
  set exports(e) {
    Ut = e;
  }
};
(function(e, t) {
  var n = De, l = t && !t.nodeType && t, r = l && !0 && e && !e.nodeType && e, a = r && r.exports === l, o = a ? n.Buffer : void 0, i = o ? o.allocUnsafe : void 0;
  function s(u, c) {
    if (c)
      return u.slice();
    var d = u.length, f = i ? i(d) : new u.constructor(d);
    return u.copy(f), f;
  }
  e.exports = s;
})(qh, Ut);
function Yh(e, t) {
  var n = -1, l = e.length;
  for (t || (t = Array(l)); ++n < l; )
    t[n] = e[n];
  return t;
}
var Jh = Yh, Zh = vn, Qh = hr;
function Xh(e, t) {
  return Zh(e, Qh(e), t);
}
var em = Xh, tm = Ml, nm = tm(Object.getPrototypeOf, Object), ql = nm, rm = Il, am = ql, lm = hr, om = Ll, im = Object.getOwnPropertySymbols, um = im ? function(e) {
  for (var t = []; e; )
    rm(t, lm(e)), e = am(e);
  return t;
} : om, Yl = um, sm = vn, cm = Yl;
function dm(e, t) {
  return sm(e, cm(e), t);
}
var fm = dm, vm = _l, pm = Yl, hm = gr;
function mm(e) {
  return vm(e, hm, pm);
}
var bm = mm, ym = Object.prototype, gm = ym.hasOwnProperty;
function wm(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && gm.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var xm = wm, oa = Fl;
function $m(e) {
  var t = new e.constructor(e.byteLength);
  return new oa(t).set(new oa(e)), t;
}
var wr = $m, Sm = wr;
function Tm(e, t) {
  var n = t ? Sm(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var Om = Tm, Cm = /\w*$/;
function Am(e) {
  var t = new e.constructor(e.source, Cm.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Em = Am, ia = on, ua = ia ? ia.prototype : void 0, sa = ua ? ua.valueOf : void 0;
function Pm(e) {
  return sa ? Object(sa.call(e)) : {};
}
var Fm = Pm, Im = wr;
function _m(e, t) {
  var n = t ? Im(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var Lm = _m, km = wr, Dm = Om, Rm = Em, Vm = Fm, Mm = Lm, jm = "[object Boolean]", Bm = "[object Date]", Nm = "[object Map]", zm = "[object Number]", Um = "[object RegExp]", Hm = "[object Set]", Gm = "[object String]", Wm = "[object Symbol]", Km = "[object ArrayBuffer]", qm = "[object DataView]", Ym = "[object Float32Array]", Jm = "[object Float64Array]", Zm = "[object Int8Array]", Qm = "[object Int16Array]", Xm = "[object Int32Array]", e0 = "[object Uint8Array]", t0 = "[object Uint8ClampedArray]", n0 = "[object Uint16Array]", r0 = "[object Uint32Array]";
function a0(e, t, n) {
  var l = e.constructor;
  switch (t) {
    case Km:
      return km(e);
    case jm:
    case Bm:
      return new l(+e);
    case qm:
      return Dm(e, n);
    case Ym:
    case Jm:
    case Zm:
    case Qm:
    case Xm:
    case e0:
    case t0:
    case n0:
    case r0:
      return Mm(e, n);
    case Nm:
      return new l();
    case zm:
    case Gm:
      return new l(e);
    case Um:
      return Rm(e);
    case Hm:
      return new l();
    case Wm:
      return Vm(e);
  }
}
var l0 = a0, o0 = Et, ca = Object.create, i0 = function() {
  function e() {
  }
  return function(t) {
    if (!o0(t))
      return {};
    if (ca)
      return ca(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), u0 = i0, s0 = u0, c0 = ql, d0 = br;
function f0(e) {
  return typeof e.constructor == "function" && !d0(e) ? s0(c0(e)) : {};
}
var v0 = f0, p0 = fn, h0 = ut, m0 = "[object Map]";
function b0(e) {
  return h0(e) && p0(e) == m0;
}
var y0 = b0, g0 = y0, w0 = mr, da = tt, fa = da && da.isMap, x0 = fa ? w0(fa) : g0, $0 = x0, S0 = fn, T0 = ut, O0 = "[object Set]";
function C0(e) {
  return T0(e) && S0(e) == O0;
}
var A0 = C0, E0 = A0, P0 = mr, va = tt, pa = va && va.isSet, F0 = pa ? P0(pa) : E0, I0 = F0, _0 = El, L0 = ph, k0 = Kl, D0 = Fh, R0 = Kh, V0 = Ut, M0 = Jh, j0 = em, B0 = fm, N0 = Bl, z0 = bm, U0 = fn, H0 = xm, G0 = l0, W0 = v0, K0 = dn, q0 = et, Y0 = $0, J0 = Et, Z0 = I0, Q0 = yr, X0 = gr, eb = 1, tb = 2, nb = 4, Jl = "[object Arguments]", rb = "[object Array]", ab = "[object Boolean]", lb = "[object Date]", ob = "[object Error]", Zl = "[object Function]", ib = "[object GeneratorFunction]", ub = "[object Map]", sb = "[object Number]", Ql = "[object Object]", cb = "[object RegExp]", db = "[object Set]", fb = "[object String]", vb = "[object Symbol]", pb = "[object WeakMap]", hb = "[object ArrayBuffer]", mb = "[object DataView]", bb = "[object Float32Array]", yb = "[object Float64Array]", gb = "[object Int8Array]", wb = "[object Int16Array]", xb = "[object Int32Array]", $b = "[object Uint8Array]", Sb = "[object Uint8ClampedArray]", Tb = "[object Uint16Array]", Ob = "[object Uint32Array]", le = {};
le[Jl] = le[rb] = le[hb] = le[mb] = le[ab] = le[lb] = le[bb] = le[yb] = le[gb] = le[wb] = le[xb] = le[ub] = le[sb] = le[Ql] = le[cb] = le[db] = le[fb] = le[vb] = le[$b] = le[Sb] = le[Tb] = le[Ob] = !0;
le[ob] = le[Zl] = le[pb] = !1;
function Vt(e, t, n, l, r, a) {
  var o, i = t & eb, s = t & tb, u = t & nb;
  if (n && (o = r ? n(e, l, r, a) : n(e)), o !== void 0)
    return o;
  if (!J0(e))
    return e;
  var c = K0(e);
  if (c) {
    if (o = H0(e), !i)
      return M0(e, o);
  } else {
    var d = U0(e), f = d == Zl || d == ib;
    if (q0(e))
      return V0(e, i);
    if (d == Ql || d == Jl || f && !r) {
      if (o = s || f ? {} : W0(e), !i)
        return s ? B0(e, R0(o, e)) : j0(e, D0(o, e));
    } else {
      if (!le[d])
        return r ? e : {};
      o = G0(e, d, i);
    }
  }
  a || (a = new _0());
  var v = a.get(e);
  if (v)
    return v;
  a.set(e, o), Z0(e) ? e.forEach(function(h) {
    o.add(Vt(h, t, n, h, e, a));
  }) : Y0(e) && e.forEach(function(h, b) {
    o.set(b, Vt(h, t, n, b, e, a));
  });
  var p = u ? s ? z0 : N0 : s ? X0 : Q0, m = c ? void 0 : p(e);
  return L0(m || e, function(h, b) {
    m && (b = h, h = e[b]), k0(o, b, Vt(h, t, n, b, e, a));
  }), o;
}
var Cb = Vt, Ab = Cb, Eb = 1, Pb = 4;
function Fb(e) {
  return Ab(e, Eb | Pb);
}
var _n = Fb;
const Ib = /* @__PURE__ */ D({
  __name: "TuneTextareaArray",
  props: {
    modelValue: null,
    definition: null,
    label: null,
    placeholder: null,
    error: null
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    function l(o) {
      const i = o.replace(/\n/g, " ").replace(/,/g, " ").replace(/;/g, " ").split(" ").map((s) => s.trim()).filter((s) => !!s).filter((s, u, c) => c.indexOf(s) === u);
      n("update:modelValue", i);
    }
    const r = C();
    function a() {
      var o;
      (o = r == null ? void 0 : r.value) == null || o.forceShowError();
    }
    return t({
      forceShowError: a
    }), (o, i) => {
      var s, u, c;
      return A(), H(fr, {
        ref_key: "textareaRef",
        ref: r,
        "model-value": (s = e.modelValue) == null ? void 0 : s.join(`
`),
        definition: e.definition,
        label: e.label,
        placeholder: e.placeholder || ((c = (u = e.definition) == null ? void 0 : u.examples) == null ? void 0 : c.join(`
`)) || "",
        error: e.error,
        "onUpdate:modelValue": i[0] || (i[0] = (d) => l(d))
      }, null, 8, ["model-value", "definition", "label", "placeholder", "error"]);
    };
  }
}), _b = { class: "relative" }, Lb = {
  key: 0,
  class: "tune-listbox-placeholder"
}, kb = { key: 2 }, Db = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-[12px]" }, Rb = { class: "max-h-[180px] overflow-y-auto" }, Vb = { key: 1 }, Mb = {
  key: 0,
  class: /* @__PURE__ */ Z(["absolute inset-y-0 right-0 flex items-center pr-3"])
}, jb = /* @__PURE__ */ D({
  __name: "TuneListboxMultiple",
  props: {
    modelValue: null,
    items: null,
    definition: null,
    label: null,
    placeholder: null,
    limit: null,
    disabled: { type: Boolean },
    hint: null,
    error: null
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const l = e, r = S({
      get: () => l.items.filter((s) => {
        var u;
        return (u = l.modelValue) == null ? void 0 : u.includes(s.value);
      }) || [],
      set: (s) => n(
        "update:modelValue",
        s.map((u) => u.value)
      )
    });
    function a(s) {
      return !l.limit || r.value.length < l.limit ? !1 : !r.value.some((u) => u.value === s);
    }
    const o = C(!1);
    function i() {
      o.value = !0;
    }
    return t({
      forceShowError: i
    }), (s, u) => {
      const c = Qn("tippy");
      return A(), V("div", null, [
        z(F(Qa), {
          modelValue: F(r),
          "onUpdate:modelValue": u[0] || (u[0] = (d) => Ke(r) ? r.value = d : null),
          as: "div",
          disabled: e.disabled,
          multiple: ""
        }, {
          default: N(() => [
            z(F(Xa), null, {
              default: N(() => {
                var d;
                return [
                  z(Ce, {
                    hint: e.hint || ((d = e.definition) == null ? void 0 : d.description)
                  }, {
                    default: N(() => {
                      var f;
                      return [
                        ge(re(e.label || ((f = e.definition) == null ? void 0 : f.title)), 1)
                      ];
                    }),
                    _: 1
                  }, 8, ["hint"])
                ];
              }),
              _: 1
            }),
            R("div", _b, [
              qt((A(), H(F(el), {
                class: Z([
                  "tune-listbox-button relative h-[42px] w-full truncate pl-3 pr-[40px] text-left",
                  { "disabled cursor-not-allowed": e.disabled },
                  {
                    error: o.value && e.error
                  }
                ])
              }, {
                default: N(() => {
                  var d, f;
                  return [
                    F(r).length < 1 ? (A(), V("span", Lb, re(e.placeholder || ((f = (d = e.definition) == null ? void 0 : d.examples) == null ? void 0 : f[0])), 1)) : s.$slots.selected ? ye(s.$slots, "selected", {
                      key: 1,
                      selectedItems: F(r)
                    }) : (A(), V("span", kb, re(F(r).map((v) => (v == null ? void 0 : v.name) || v.value).join(", ")), 1)),
                    R("span", Db, [
                      z(F(Ye), { class: "text-sm" })
                    ])
                  ];
                }),
                _: 3
              }, 8, ["class"])), [
                [c, {
                  content: F(r).map((d) => (d == null ? void 0 : d.name) || d.value).join(", ")
                }]
              ]),
              z(Xn, {
                "enter-active-class": "transition duration-100 ease-out",
                "enter-from-class": "transform -translate-y-2 scale-95 opacity-0",
                "enter-to-class": "transform scale-100 opacity-100",
                "leave-active-class": "transition duration-75 ease-out",
                "leave-from-class": "transform scale-100 opacity-100",
                "leave-to-class": "transform scale-95 opacity-0"
              }, {
                default: N(() => [
                  z(F(tl), { class: "tune-listbox-options absolute z-40 mt-1 w-full overflow-hidden focus:outline-none" }, {
                    default: N(() => [
                      R("div", Rb, [
                        (A(!0), V(pe, null, Le(e.items, (d, f) => (A(), H(F(nl), {
                          key: f,
                          as: "template",
                          value: d,
                          disabled: a(d.value)
                        }, {
                          default: N(({ active: v, selected: p, disabled: m }) => [
                            R("li", {
                              class: Z([
                                { active: v },
                                "tune-listbox-item relative cursor-default select-none py-2 pl-3 pr-[50px]"
                              ])
                            }, [
                              R("span", {
                                class: Z([
                                  p ? "selected" : "font-normal",
                                  { disabled: m },
                                  "tune-listbox-item block truncate"
                                ])
                              }, [
                                s.$slots.item ? ye(s.$slots, "item", {
                                  key: 0,
                                  item: d
                                }) : (A(), V("span", Vb, re((d == null ? void 0 : d.name) || d.value), 1))
                              ], 2),
                              p ? (A(), V("span", Mb, [
                                z(F(tn), { class: "text-sm" })
                              ])) : Q("", !0)
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["value", "disabled"]))), 128))
                      ])
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })
            ])
          ]),
          _: 3
        }, 8, ["modelValue", "disabled"]),
        e.error && o.value ? (A(), H(nn, {
          key: 0,
          error: e.error
        }, null, 8, ["error"])) : Q("", !0)
      ]);
    };
  }
}), Bb = { key: 0 }, Nb = {
  key: 3,
  class: "space-y-2"
}, zb = { class: "mb-2" }, Ub = /* @__PURE__ */ D({
  __name: "FormArray",
  props: {
    modelValue: null,
    definition: null,
    error: null
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const l = e, r = S({
      get: () => l.modelValue,
      set: (u) => n("update:modelValue", u)
    }), a = (u) => {
      switch (u) {
        case "object":
          return Xl;
        case "string":
          return Ul;
        case "number":
          return Hl;
        case "boolean":
          return Gl;
        default:
          return null;
      }
    };
    function o() {
      var c, d;
      const u = _n(r.value);
      u.push(_n((d = (c = l.definition) == null ? void 0 : c.items) == null ? void 0 : d.default) || ""), r.value = u;
    }
    const i = C();
    function s() {
      var u, c, d;
      (u = i == null ? void 0 : i.value) != null && u.forceShowError ? (c = i == null ? void 0 : i.value) == null || c.forceShowError() : (d = i == null ? void 0 : i.value) == null || d.forEach((f) => {
        f != null && f.forceShowError && (f == null || f.forceShowError());
      });
    }
    return t({
      forceShowError: s
    }), X(() => {
      var u, c, d;
      ((u = l.definition) == null ? void 0 : u.title) !== "Strategies" && (l.modelValue || (r.value = _n([(d = (c = l.definition) == null ? void 0 : c.items) == null ? void 0 : d.default])));
    }), (u, c) => {
      var d, f, v, p, m, h, b, y, g, x;
      return ((d = e.definition) == null ? void 0 : d.title) === "Strategies" ? (A(), V("div", Bb)) : (v = (f = e.definition) == null ? void 0 : f.items) != null && v.anyOf && ((m = (p = e.definition) == null ? void 0 : p.items) == null ? void 0 : m.type) === "string" ? (A(), H(jb, {
        key: 1,
        ref_key: "componentRefs",
        ref: i,
        modelValue: F(r),
        "onUpdate:modelValue": c[0] || (c[0] = (w) => Ke(r) ? r.value = w : null),
        items: e.definition.items.anyOf.map((w) => ({
          value: w.const,
          name: w.title
        })),
        definition: e.definition,
        error: e.error
      }, null, 8, ["modelValue", "items", "definition", "error"])) : ((b = (h = e.definition) == null ? void 0 : h.items) == null ? void 0 : b.type) === "string" ? (A(), H(Ib, {
        key: 2,
        modelValue: F(r),
        "onUpdate:modelValue": c[1] || (c[1] = (w) => Ke(r) ? r.value = w : null),
        definition: e.definition,
        error: e.error
      }, null, 8, ["modelValue", "definition", "error"])) : (y = e.definition) != null && y.items ? (A(), V("div", Nb, [
        (g = e.definition) != null && g.title ? (A(), H(Ce, {
          key: 0,
          hint: (x = e.definition) == null ? void 0 : x.description
        }, {
          default: N(() => {
            var w;
            return [
              ge(re((w = e.definition) == null ? void 0 : w.title), 1)
            ];
          }),
          _: 1
        }, 8, ["hint"])) : Q("", !0),
        (A(!0), V(pe, null, Le(F(r), (w, $) => {
          var E, O;
          return A(), V("div", {
            key: $,
            class: Z({
              "tune-form-array-objects": ((O = (E = e.definition) == null ? void 0 : E.items) == null ? void 0 : O.type) === "object"
            })
          }, [
            R("div", zb, [
              z($l, {
                label: $ + 1
              }, null, 8, ["label"])
            ]),
            (A(), H(Ca(a(e.definition.items.type)), {
              ref_for: !0,
              ref_key: "componentRefs",
              ref: i,
              modelValue: F(r)[$],
              "onUpdate:modelValue": (P) => F(r)[$] = P,
              definition: e.definition.items,
              error: e.error
            }, null, 8, ["modelValue", "onUpdate:modelValue", "definition", "error"]))
          ], 2);
        }), 128)),
        z(Yt, {
          class: "w-full",
          onClick: o
        }, {
          default: N(() => [
            ge(" Add ")
          ]),
          _: 1
        })
      ])) : Q("", !0);
    };
  }
}), Hb = { class: "space-y-2" }, Xl = /* @__PURE__ */ D({
  __name: "TuneForm",
  props: {
    modelValue: null,
    definition: null,
    error: null
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const l = e, r = S({
      get: () => {
        var s;
        return l.modelValue || ((s = l.definition) == null ? void 0 : s.default) || {};
      },
      set: (s) => n("update:modelValue", s)
    }), a = (s) => {
      switch (s) {
        case "object":
          return Xl;
        case "string":
          return Ul;
        case "number":
          return Hl;
        case "boolean":
          return Gl;
        case "array":
          return Ub;
        default:
          return null;
      }
    }, o = C();
    function i() {
      var s;
      (s = o == null ? void 0 : o.value) == null || s.forEach((u) => {
        u != null && u.forceShowError && (u == null || u.forceShowError());
      });
    }
    return t({
      forceShowError: i
    }), (s, u) => (A(), V("div", Hb, [
      (A(!0), V(pe, null, Le(e.definition.properties, (c, d) => (A(), H(Ca(a(c.type)), {
        ref_for: !0,
        ref_key: "componentRefs",
        ref: o,
        key: d,
        modelValue: F(r)[d],
        "onUpdate:modelValue": (f) => F(r)[d] = f,
        definition: c,
        error: e.error[d] || ""
      }, null, 8, ["modelValue", "onUpdate:modelValue", "definition", "error"]))), 128))
    ]));
  }
}), Py = /* @__PURE__ */ D({
  __name: "TuneTextareaJson",
  props: {
    modelValue: null,
    definition: null,
    label: null,
    placeholder: null,
    error: null
  },
  emits: ["update:modelValue", "update:isValid"],
  setup(e, { expose: t, emit: n }) {
    const l = e, r = C(""), a = C("");
    function o() {
      try {
        n("update:modelValue", JSON.parse(r.value)), n("update:isValid", !0), a.value = "";
      } catch (u) {
        n("update:isValid", !1), a.value = u == null ? void 0 : u.message;
      }
    }
    se(r, () => o()), l.modelValue && (r.value = JSON.stringify(l.modelValue, null, 2));
    const i = C();
    function s() {
      var u;
      (u = i == null ? void 0 : i.value) == null || u.forceShowError();
    }
    return t({
      forceShowError: s
    }), (u, c) => (A(), H(fr, {
      ref_key: "textareaRef",
      ref: i,
      modelValue: r.value,
      "onUpdate:modelValue": c[0] || (c[0] = (d) => r.value = d),
      definition: e.definition,
      label: e.label,
      placeholder: e.placeholder,
      error: a.value || e.error,
      class: "tune-textarea-json font-mono"
    }, null, 8, ["modelValue", "definition", "label", "placeholder", "error"]));
  }
});
function Fe(e) {
  return e.split("-")[1];
}
function xr(e) {
  return e === "y" ? "height" : "width";
}
function Re(e) {
  return e.split("-")[0];
}
function Pt(e) {
  return ["top", "bottom"].includes(Re(e)) ? "x" : "y";
}
function ha(e, t, n) {
  let { reference: l, floating: r } = e;
  const a = l.x + l.width / 2 - r.width / 2, o = l.y + l.height / 2 - r.height / 2, i = Pt(t), s = xr(i), u = l[s] / 2 - r[s] / 2, c = i === "x";
  let d;
  switch (Re(t)) {
    case "top":
      d = { x: a, y: l.y - r.height };
      break;
    case "bottom":
      d = { x: a, y: l.y + l.height };
      break;
    case "right":
      d = { x: l.x + l.width, y: o };
      break;
    case "left":
      d = { x: l.x - r.width, y: o };
      break;
    default:
      d = { x: l.x, y: l.y };
  }
  switch (Fe(t)) {
    case "start":
      d[i] -= u * (n && c ? -1 : 1);
      break;
    case "end":
      d[i] += u * (n && c ? -1 : 1);
  }
  return d;
}
const Gb = async (e, t, n) => {
  const { placement: l = "bottom", strategy: r = "absolute", middleware: a = [], platform: o } = n, i = a.filter(Boolean), s = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({ reference: e, floating: t, strategy: r }), { x: c, y: d } = ha(u, l, s), f = l, v = {}, p = 0;
  for (let m = 0; m < i.length; m++) {
    const { name: h, fn: b } = i[m], { x: y, y: g, data: x, reset: w } = await b({ x: c, y: d, initialPlacement: l, placement: f, strategy: r, middlewareData: v, rects: u, platform: o, elements: { reference: e, floating: t } });
    c = y ?? c, d = g ?? d, v = { ...v, [h]: { ...v[h], ...x } }, w && p <= 50 && (p++, typeof w == "object" && (w.placement && (f = w.placement), w.rects && (u = w.rects === !0 ? await o.getElementRects({ reference: e, floating: t, strategy: r }) : w.rects), { x: c, y: d } = ha(u, f, s)), m = -1);
  }
  return { x: c, y: d, placement: f, strategy: r, middlewareData: v };
};
function eo(e) {
  return typeof e != "number" ? function(t) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...t };
  }(e) : { top: e, right: e, bottom: e, left: e };
}
function Ht(e) {
  return { ...e, top: e.y, left: e.x, right: e.x + e.width, bottom: e.y + e.height };
}
async function bt(e, t) {
  var n;
  t === void 0 && (t = {});
  const { x: l, y: r, platform: a, rects: o, elements: i, strategy: s } = e, { boundary: u = "clippingAncestors", rootBoundary: c = "viewport", elementContext: d = "floating", altBoundary: f = !1, padding: v = 0 } = t, p = eo(v), m = i[f ? d === "floating" ? "reference" : "floating" : d], h = Ht(await a.getClippingRect({ element: (n = await (a.isElement == null ? void 0 : a.isElement(m))) == null || n ? m : m.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(i.floating)), boundary: u, rootBoundary: c, strategy: s })), b = d === "floating" ? { ...o.floating, x: l, y: r } : o.reference, y = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(i.floating)), g = await (a.isElement == null ? void 0 : a.isElement(y)) && await (a.getScale == null ? void 0 : a.getScale(y)) || { x: 1, y: 1 }, x = Ht(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: b, offsetParent: y, strategy: s }) : b);
  return { top: (h.top - x.top + p.top) / g.y, bottom: (x.bottom - h.bottom + p.bottom) / g.y, left: (h.left - x.left + p.left) / g.x, right: (x.right - h.right + p.right) / g.x };
}
const Wb = Math.min, Kb = Math.max;
function Wn(e, t, n) {
  return Kb(e, Wb(t, n));
}
const qb = (e) => ({ name: "arrow", options: e, async fn(t) {
  const { element: n, padding: l = 0 } = e || {}, { x: r, y: a, placement: o, rects: i, platform: s, elements: u } = t;
  if (n == null)
    return {};
  const c = eo(l), d = { x: r, y: a }, f = Pt(o), v = xr(f), p = await s.getDimensions(n), m = f === "y", h = m ? "top" : "left", b = m ? "bottom" : "right", y = m ? "clientHeight" : "clientWidth", g = i.reference[v] + i.reference[f] - d[f] - i.floating[v], x = d[f] - i.reference[f], w = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(n));
  let $ = w ? w[y] : 0;
  $ && await (s.isElement == null ? void 0 : s.isElement(w)) || ($ = u.floating[y] || i.floating[v]);
  const E = g / 2 - x / 2, O = c[h], P = $ - p[v] - c[b], I = $ / 2 - p[v] / 2 + E, L = Wn(O, I, P), M = Fe(o) != null && I != L && i.reference[v] / 2 - (I < O ? c[h] : c[b]) - p[v] / 2 < 0;
  return { [f]: d[f] - (M ? I < O ? O - I : P - I : 0), data: { [f]: L, centerOffset: I - L } };
} }), to = ["top", "right", "bottom", "left"], ma = to.reduce((e, t) => e.concat(t, t + "-start", t + "-end"), []), Yb = { left: "right", right: "left", bottom: "top", top: "bottom" };
function Gt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Yb[t]);
}
function no(e, t, n) {
  n === void 0 && (n = !1);
  const l = Fe(e), r = Pt(e), a = xr(r);
  let o = r === "x" ? l === (n ? "end" : "start") ? "right" : "left" : l === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (o = Gt(o)), { main: o, cross: Gt(o) };
}
const Jb = { start: "end", end: "start" };
function Mt(e) {
  return e.replace(/start|end/g, (t) => Jb[t]);
}
const Zb = function(e) {
  return e === void 0 && (e = {}), { name: "autoPlacement", options: e, async fn(t) {
    var n, l, r;
    const { rects: a, middlewareData: o, placement: i, platform: s, elements: u } = t, { crossAxis: c = !1, alignment: d, allowedPlacements: f = ma, autoAlignment: v = !0, ...p } = e, m = d !== void 0 || f === ma ? function(I, L, M) {
      return (I ? [...M.filter((j) => Fe(j) === I), ...M.filter((j) => Fe(j) !== I)] : M.filter((j) => Re(j) === j)).filter((j) => !I || Fe(j) === I || !!L && Mt(j) !== j);
    }(d || null, v, f) : f, h = await bt(t, p), b = ((n = o.autoPlacement) == null ? void 0 : n.index) || 0, y = m[b];
    if (y == null)
      return {};
    const { main: g, cross: x } = no(y, a, await (s.isRTL == null ? void 0 : s.isRTL(u.floating)));
    if (i !== y)
      return { reset: { placement: m[0] } };
    const w = [h[Re(y)], h[g], h[x]], $ = [...((l = o.autoPlacement) == null ? void 0 : l.overflows) || [], { placement: y, overflows: w }], E = m[b + 1];
    if (E)
      return { data: { index: b + 1, overflows: $ }, reset: { placement: E } };
    const O = $.map((I) => {
      const L = Fe(I.placement);
      return [I.placement, L && c ? I.overflows.slice(0, 2).reduce((M, j) => M + j, 0) : I.overflows[0], I.overflows];
    }).sort((I, L) => I[1] - L[1]), P = ((r = O.filter((I) => I[2].slice(0, Fe(I[0]) ? 2 : 3).every((L) => L <= 0))[0]) == null ? void 0 : r[0]) || O[0][0];
    return P !== i ? { data: { index: b + 1, overflows: $ }, reset: { placement: P } } : {};
  } };
}, Qb = function(e) {
  return e === void 0 && (e = {}), { name: "flip", options: e, async fn(t) {
    var n;
    const { placement: l, middlewareData: r, rects: a, initialPlacement: o, platform: i, elements: s } = t, { mainAxis: u = !0, crossAxis: c = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: v = "none", flipAlignment: p = !0, ...m } = e, h = Re(l), b = Re(o) === o, y = await (i.isRTL == null ? void 0 : i.isRTL(s.floating)), g = d || (b || !p ? [Gt(o)] : function(L) {
      const M = Gt(L);
      return [Mt(L), M, Mt(M)];
    }(o));
    d || v === "none" || g.push(...function(L, M, j, k) {
      const U = Fe(L);
      let G = function(te, $e, ve) {
        const mn = ["left", "right"], bn = ["right", "left"], Ft = ["top", "bottom"], yn = ["bottom", "top"];
        switch (te) {
          case "top":
          case "bottom":
            return ve ? $e ? bn : mn : $e ? mn : bn;
          case "left":
          case "right":
            return $e ? Ft : yn;
          default:
            return [];
        }
      }(Re(L), j === "start", k);
      return U && (G = G.map((te) => te + "-" + U), M && (G = G.concat(G.map(Mt)))), G;
    }(o, p, v, y));
    const x = [o, ...g], w = await bt(t, m), $ = [];
    let E = ((n = r.flip) == null ? void 0 : n.overflows) || [];
    if (u && $.push(w[h]), c) {
      const { main: L, cross: M } = no(l, a, y);
      $.push(w[L], w[M]);
    }
    if (E = [...E, { placement: l, overflows: $ }], !$.every((L) => L <= 0)) {
      var O, P;
      const L = (((O = r.flip) == null ? void 0 : O.index) || 0) + 1, M = x[L];
      if (M)
        return { data: { index: L, overflows: E }, reset: { placement: M } };
      let j = (P = E.filter((k) => k.overflows[0] <= 0).sort((k, U) => k.overflows[1] - U.overflows[1])[0]) == null ? void 0 : P.placement;
      if (!j)
        switch (f) {
          case "bestFit": {
            var I;
            const k = (I = E.map((U) => [U.placement, U.overflows.filter((G) => G > 0).reduce((G, te) => G + te, 0)]).sort((U, G) => U[1] - G[1])[0]) == null ? void 0 : I[0];
            k && (j = k);
            break;
          }
          case "initialPlacement":
            j = o;
        }
      if (l !== j)
        return { reset: { placement: j } };
    }
    return {};
  } };
};
function ba(e, t) {
  return { top: e.top - t.height, right: e.right - t.width, bottom: e.bottom - t.height, left: e.left - t.width };
}
function ya(e) {
  return to.some((t) => e[t] >= 0);
}
const Xb = function(e) {
  return e === void 0 && (e = {}), { name: "hide", options: e, async fn(t) {
    const { strategy: n = "referenceHidden", ...l } = e, { rects: r } = t;
    switch (n) {
      case "referenceHidden": {
        const a = ba(await bt(t, { ...l, elementContext: "reference" }), r.reference);
        return { data: { referenceHiddenOffsets: a, referenceHidden: ya(a) } };
      }
      case "escaped": {
        const a = ba(await bt(t, { ...l, altBoundary: !0 }), r.floating);
        return { data: { escapedOffsets: a, escaped: ya(a) } };
      }
      default:
        return {};
    }
  } };
}, e1 = function(e) {
  return e === void 0 && (e = 0), { name: "offset", options: e, async fn(t) {
    const { x: n, y: l } = t, r = await async function(a, o) {
      const { placement: i, platform: s, elements: u } = a, c = await (s.isRTL == null ? void 0 : s.isRTL(u.floating)), d = Re(i), f = Fe(i), v = Pt(i) === "x", p = ["left", "top"].includes(d) ? -1 : 1, m = c && v ? -1 : 1, h = typeof o == "function" ? o(a) : o;
      let { mainAxis: b, crossAxis: y, alignmentAxis: g } = typeof h == "number" ? { mainAxis: h, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...h };
      return f && typeof g == "number" && (y = f === "end" ? -1 * g : g), v ? { x: y * m, y: b * p } : { x: b * p, y: y * m };
    }(t, e);
    return { x: n + r.x, y: l + r.y, data: r };
  } };
};
function t1(e) {
  return e === "x" ? "y" : "x";
}
const n1 = function(e) {
  return e === void 0 && (e = {}), { name: "shift", options: e, async fn(t) {
    const { x: n, y: l, placement: r } = t, { mainAxis: a = !0, crossAxis: o = !1, limiter: i = { fn: (h) => {
      let { x: b, y } = h;
      return { x: b, y };
    } }, ...s } = e, u = { x: n, y: l }, c = await bt(t, s), d = Pt(Re(r)), f = t1(d);
    let v = u[d], p = u[f];
    if (a) {
      const h = d === "y" ? "bottom" : "right";
      v = Wn(v + c[d === "y" ? "top" : "left"], v, v - c[h]);
    }
    if (o) {
      const h = f === "y" ? "bottom" : "right";
      p = Wn(p + c[f === "y" ? "top" : "left"], p, p - c[h]);
    }
    const m = i.fn({ ...t, [d]: v, [f]: p });
    return { ...m, data: { x: m.x - n, y: m.y - l } };
  } };
};
function Te(e) {
  var t;
  return ((t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function _e(e) {
  return Te(e).getComputedStyle(e);
}
function ro(e) {
  return e instanceof Te(e).Node;
}
function Ne(e) {
  return ro(e) ? (e.nodeName || "").toLowerCase() : "";
}
let Rt;
function ao() {
  if (Rt)
    return Rt;
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? (Rt = e.brands.map((t) => t.brand + "/" + t.version).join(" "), Rt) : navigator.userAgent;
}
function Ee(e) {
  return e instanceof Te(e).HTMLElement;
}
function Ae(e) {
  return e instanceof Te(e).Element;
}
function ga(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof Te(e).ShadowRoot || e instanceof ShadowRoot;
}
function pn(e) {
  const { overflow: t, overflowX: n, overflowY: l, display: r } = _e(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + l + n) && !["inline", "contents"].includes(r);
}
function r1(e) {
  return ["table", "td", "th"].includes(Ne(e));
}
function Kn(e) {
  const t = /firefox/i.test(ao()), n = _e(e), l = n.backdropFilter || n.WebkitBackdropFilter;
  return n.transform !== "none" || n.perspective !== "none" || !!l && l !== "none" || t && n.willChange === "filter" || t && !!n.filter && n.filter !== "none" || ["transform", "perspective"].some((r) => n.willChange.includes(r)) || ["paint", "layout", "strict", "content"].some((r) => {
    const a = n.contain;
    return a != null && a.includes(r);
  });
}
function qn() {
  return /^((?!chrome|android).)*safari/i.test(ao());
}
function $r(e) {
  return ["html", "body", "#document"].includes(Ne(e));
}
const wa = Math.min, pt = Math.max, Wt = Math.round;
function lo(e) {
  const t = _e(e);
  let n = parseFloat(t.width), l = parseFloat(t.height);
  const r = Ee(e), a = r ? e.offsetWidth : n, o = r ? e.offsetHeight : l, i = Wt(n) !== a || Wt(l) !== o;
  return i && (n = a, l = o), { width: n, height: l, fallback: i };
}
function oo(e) {
  return Ae(e) ? e : e.contextElement;
}
const io = { x: 1, y: 1 };
function Xe(e) {
  const t = oo(e);
  if (!Ee(t))
    return io;
  const n = t.getBoundingClientRect(), { width: l, height: r, fallback: a } = lo(t);
  let o = (a ? Wt(n.width) : n.width) / l, i = (a ? Wt(n.height) : n.height) / r;
  return o && Number.isFinite(o) || (o = 1), i && Number.isFinite(i) || (i = 1), { x: o, y: i };
}
function qe(e, t, n, l) {
  var r, a;
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = oo(e);
  let s = io;
  t && (l ? Ae(l) && (s = Xe(l)) : s = Xe(e));
  const u = i ? Te(i) : window, c = qn() && n;
  let d = (o.left + (c && ((r = u.visualViewport) == null ? void 0 : r.offsetLeft) || 0)) / s.x, f = (o.top + (c && ((a = u.visualViewport) == null ? void 0 : a.offsetTop) || 0)) / s.y, v = o.width / s.x, p = o.height / s.y;
  if (i) {
    const m = Te(i), h = l && Ae(l) ? Te(l) : l;
    let b = m.frameElement;
    for (; b && l && h !== m; ) {
      const y = Xe(b), g = b.getBoundingClientRect(), x = getComputedStyle(b);
      g.x += (b.clientLeft + parseFloat(x.paddingLeft)) * y.x, g.y += (b.clientTop + parseFloat(x.paddingTop)) * y.y, d *= y.x, f *= y.y, v *= y.x, p *= y.y, d += g.x, f += g.y, b = Te(b).frameElement;
    }
  }
  return Ht({ width: v, height: p, x: d, y: f });
}
function Be(e) {
  return ((ro(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function hn(e) {
  return Ae(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function uo(e) {
  return qe(Be(e)).left + hn(e).scrollLeft;
}
function yt(e) {
  if (Ne(e) === "html")
    return e;
  const t = e.assignedSlot || e.parentNode || ga(e) && e.host || Be(e);
  return ga(t) ? t.host : t;
}
function so(e) {
  const t = yt(e);
  return $r(t) ? t.ownerDocument.body : Ee(t) && pn(t) ? t : so(t);
}
function ht(e, t) {
  var n;
  t === void 0 && (t = []);
  const l = so(e), r = l === ((n = e.ownerDocument) == null ? void 0 : n.body), a = Te(l);
  return r ? t.concat(a, a.visualViewport || [], pn(l) ? l : []) : t.concat(l, ht(l));
}
function xa(e, t, n) {
  let l;
  if (t === "viewport")
    l = function(o, i) {
      const s = Te(o), u = Be(o), c = s.visualViewport;
      let d = u.clientWidth, f = u.clientHeight, v = 0, p = 0;
      if (c) {
        d = c.width, f = c.height;
        const m = qn();
        (!m || m && i === "fixed") && (v = c.offsetLeft, p = c.offsetTop);
      }
      return { width: d, height: f, x: v, y: p };
    }(e, n);
  else if (t === "document")
    l = function(o) {
      const i = Be(o), s = hn(o), u = o.ownerDocument.body, c = pt(i.scrollWidth, i.clientWidth, u.scrollWidth, u.clientWidth), d = pt(i.scrollHeight, i.clientHeight, u.scrollHeight, u.clientHeight);
      let f = -s.scrollLeft + uo(o);
      const v = -s.scrollTop;
      return _e(u).direction === "rtl" && (f += pt(i.clientWidth, u.clientWidth) - c), { width: c, height: d, x: f, y: v };
    }(Be(e));
  else if (Ae(t))
    l = function(o, i) {
      const s = qe(o, !0, i === "fixed"), u = s.top + o.clientTop, c = s.left + o.clientLeft, d = Ee(o) ? Xe(o) : { x: 1, y: 1 };
      return { width: o.clientWidth * d.x, height: o.clientHeight * d.y, x: c * d.x, y: u * d.y };
    }(t, n);
  else {
    const o = { ...t };
    if (qn()) {
      var r, a;
      const i = Te(e);
      o.x -= ((r = i.visualViewport) == null ? void 0 : r.offsetLeft) || 0, o.y -= ((a = i.visualViewport) == null ? void 0 : a.offsetTop) || 0;
    }
    l = o;
  }
  return Ht(l);
}
function $a(e, t) {
  return Ee(e) && _e(e).position !== "fixed" ? t ? t(e) : e.offsetParent : null;
}
function Sa(e, t) {
  const n = Te(e);
  if (!Ee(e))
    return n;
  let l = $a(e, t);
  for (; l && r1(l) && _e(l).position === "static"; )
    l = $a(l, t);
  return l && (Ne(l) === "html" || Ne(l) === "body" && _e(l).position === "static" && !Kn(l)) ? n : l || function(r) {
    let a = yt(r);
    for (; Ee(a) && !$r(a); ) {
      if (Kn(a))
        return a;
      a = yt(a);
    }
    return null;
  }(e) || n;
}
function a1(e, t, n) {
  const l = Ee(t), r = Be(t), a = qe(e, !0, n === "fixed", t);
  let o = { scrollLeft: 0, scrollTop: 0 };
  const i = { x: 0, y: 0 };
  if (l || !l && n !== "fixed")
    if ((Ne(t) !== "body" || pn(r)) && (o = hn(t)), Ee(t)) {
      const s = qe(t, !0);
      i.x = s.x + t.clientLeft, i.y = s.y + t.clientTop;
    } else
      r && (i.x = uo(r));
  return { x: a.left + o.scrollLeft - i.x, y: a.top + o.scrollTop - i.y, width: a.width, height: a.height };
}
const l1 = { getClippingRect: function(e) {
  let { element: t, boundary: n, rootBoundary: l, strategy: r } = e;
  const a = n === "clippingAncestors" ? function(u, c) {
    const d = c.get(u);
    if (d)
      return d;
    let f = ht(u).filter((h) => Ae(h) && Ne(h) !== "body"), v = null;
    const p = _e(u).position === "fixed";
    let m = p ? yt(u) : u;
    for (; Ae(m) && !$r(m); ) {
      const h = _e(m), b = Kn(m);
      h.position === "fixed" ? v = null : (p ? b || v : b || h.position !== "static" || !v || !["absolute", "fixed"].includes(v.position)) ? v = h : f = f.filter((y) => y !== m), m = yt(m);
    }
    return c.set(u, f), f;
  }(t, this._c) : [].concat(n), o = [...a, l], i = o[0], s = o.reduce((u, c) => {
    const d = xa(t, c, r);
    return u.top = pt(d.top, u.top), u.right = wa(d.right, u.right), u.bottom = wa(d.bottom, u.bottom), u.left = pt(d.left, u.left), u;
  }, xa(t, i, r));
  return { width: s.right - s.left, height: s.bottom - s.top, x: s.left, y: s.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: t, offsetParent: n, strategy: l } = e;
  const r = Ee(n), a = Be(n);
  if (n === a)
    return t;
  let o = { scrollLeft: 0, scrollTop: 0 }, i = { x: 1, y: 1 };
  const s = { x: 0, y: 0 };
  if ((r || !r && l !== "fixed") && ((Ne(n) !== "body" || pn(a)) && (o = hn(n)), Ee(n))) {
    const u = qe(n);
    i = Xe(n), s.x = u.x + n.clientLeft, s.y = u.y + n.clientTop;
  }
  return { width: t.width * i.x, height: t.height * i.y, x: t.x * i.x - o.scrollLeft * i.x + s.x, y: t.y * i.y - o.scrollTop * i.y + s.y };
}, isElement: Ae, getDimensions: function(e) {
  return lo(e);
}, getOffsetParent: Sa, getDocumentElement: Be, getScale: Xe, async getElementRects(e) {
  let { reference: t, floating: n, strategy: l } = e;
  const r = this.getOffsetParent || Sa, a = this.getDimensions;
  return { reference: a1(t, await r(n), l), floating: { x: 0, y: 0, ...await a(n) } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => _e(e).direction === "rtl" };
function o1(e, t, n, l) {
  l === void 0 && (l = {});
  const { ancestorScroll: r = !0, ancestorResize: a = !0, elementResize: o = !0, animationFrame: i = !1 } = l, s = r && !i, u = s || a ? [...Ae(e) ? ht(e) : e.contextElement ? ht(e.contextElement) : [], ...ht(t)] : [];
  u.forEach((v) => {
    s && v.addEventListener("scroll", n, { passive: !0 }), a && v.addEventListener("resize", n);
  });
  let c, d = null;
  o && (d = new ResizeObserver(() => {
    n();
  }), Ae(e) && !i && d.observe(e), Ae(e) || !e.contextElement || i || d.observe(e.contextElement), d.observe(t));
  let f = i ? qe(e) : null;
  return i && function v() {
    const p = qe(e);
    !f || p.x === f.x && p.y === f.y && p.width === f.width && p.height === f.height || n(), f = p, c = requestAnimationFrame(v);
  }(), n(), () => {
    var v;
    u.forEach((p) => {
      s && p.removeEventListener("scroll", n), a && p.removeEventListener("resize", n);
    }), (v = d) == null || v.disconnect(), d = null, i && cancelAnimationFrame(c);
  };
}
const i1 = (e, t, n) => {
  const l = /* @__PURE__ */ new Map(), r = { platform: l1, ...n }, a = { ...r.platform, _c: l };
  return Gb(e, t, { ...r, platform: a });
};
function Yn(e) {
  var t;
  return (t = e == null ? void 0 : e.$el) != null ? t : e;
}
function u1(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const n = Yn(F(e.element));
      return n == null ? {} : qb({
        element: n,
        padding: e.padding
      }).fn(t);
    }
  };
}
function s1(e, t, n) {
  n === void 0 && (n = {});
  const l = n.whileElementsMounted, r = S(() => {
    var w;
    return (w = F(n.open)) != null ? w : !0;
  }), a = S(() => F(n.middleware)), o = S(() => {
    var w;
    return (w = F(n.placement)) != null ? w : "bottom";
  }), i = S(() => {
    var w;
    return (w = F(n.strategy)) != null ? w : "absolute";
  }), s = S(() => Yn(e.value)), u = S(() => Yn(t.value)), c = C(null), d = C(null), f = C(i.value), v = C(o.value), p = Kt({}), m = C(!1);
  let h;
  function b() {
    s.value == null || u.value == null || i1(s.value, u.value, {
      middleware: a.value,
      placement: o.value,
      strategy: i.value
    }).then((w) => {
      c.value = w.x, d.value = w.y, f.value = w.strategy, v.value = w.placement, p.value = w.middlewareData, m.value = !0;
    });
  }
  function y() {
    typeof h == "function" && (h(), h = void 0);
  }
  function g() {
    if (y(), l === void 0) {
      b();
      return;
    }
    if (s.value != null && u.value != null) {
      h = l(s.value, u.value, b);
      return;
    }
  }
  function x() {
    r.value || (m.value = !1);
  }
  return se([a, o, i], b, {
    flush: "sync"
  }), se([s, u], g, {
    flush: "sync"
  }), se(r, x, {
    flush: "sync"
  }), yo() && go(y), {
    x: Ze(c),
    y: Ze(d),
    strategy: Ze(f),
    placement: Ze(v),
    middlewareData: Ze(p),
    isPositioned: Ze(m),
    update: b
  };
}
var c1 = Object.defineProperty, d1 = (e, t, n) => t in e ? c1(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, f1 = (e, t, n) => (d1(e, typeof t != "symbol" ? t + "" : t, n), n);
function Jn(e) {
  if (e == null || e.value == null)
    return null;
  const t = e.value.$el ?? e.value;
  return t.$el ? Jn(C(t)) : t;
}
class v1 {
  constructor() {
    f1(this, "current", this.detect());
  }
  set(t) {
    this.current !== t && (this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}
const co = new v1();
function fo(e) {
  return e.reduce((t, n) => n.type === pe ? t.concat(fo(n.children)) : t.concat(n), []);
}
function Ta(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
function Oa(e) {
  return e = F(e), e && (e == null ? void 0 : e.nodeType) !== Node.COMMENT_NODE;
}
function p1(e, t, n, l, r) {
  se([
    () => r.offset,
    () => r.flip,
    () => r.shift,
    () => r.autoPlacement,
    () => r.arrow,
    () => r.hide,
    () => r.middleware
  ], () => {
    const a = [];
    (typeof r.offset == "number" || typeof r.offset == "object" || typeof r.offset == "function") && a.push(e1(r.offset)), (r.flip === !0 || typeof r.flip == "number" || typeof r.flip == "object") && a.push(Qb({
      padding: typeof r.flip == "number" ? r.flip : void 0,
      ...typeof r.flip == "object" ? r.flip : {}
    })), (r.shift === !0 || typeof r.shift == "number" || typeof r.shift == "object") && a.push(n1({
      padding: typeof r.shift == "number" ? r.shift : void 0,
      ...typeof r.shift == "object" ? r.shift : {}
    })), (r.autoPlacement === !0 || typeof r.autoPlacement == "object") && a.push(Zb(
      typeof r.autoPlacement == "object" ? r.autoPlacement : void 0
    )), (r.arrow === !0 || typeof r.arrow == "number") && a.push(u1({
      element: l,
      padding: r.arrow === !0 ? 0 : r.arrow
    })), a.push(...typeof r.middleware == "function" ? r.middleware({
      referenceEl: t,
      floatingEl: n
    }) : r.middleware || []), (r.hide === !0 || typeof r.hide == "object") && a.push(Xb(
      typeof r.hide == "object" ? r.hide : void 0
    )), e.value = a;
  }, { immediate: !0 });
}
function h1(e, t, n) {
  let l = () => {
  };
  X(() => {
    if (e && co.isClient && typeof ResizeObserver < "u" && t.value && t.value instanceof Element) {
      const r = new ResizeObserver(([a]) => {
        n.value = a.borderBoxSize.reduce((o, { inlineSize: i }) => o + i, 0);
      });
      r.observe(t.value), l = () => {
        r.disconnect(), n.value = null;
      };
    }
  }), wo(() => {
    l();
  });
}
const m1 = (e) => {
  switch (e) {
    case "top":
      return "origin-bottom";
    case "bottom":
      return "origin-top";
    case "left":
      return "origin-right";
    case "right":
      return "origin-left";
    case "top-start":
    case "right-end":
      return "origin-bottom-left";
    case "top-end":
    case "left-end":
      return "origin-bottom-right";
    case "right-start":
    case "bottom-start":
      return "origin-top-left";
    case "left-start":
    case "bottom-end":
      return "origin-top-right";
    default:
      return "";
  }
};
function b1(e, t) {
  const n = S(() => {
    if (typeof e.originClass == "function")
      return e.originClass(t.value);
    if (typeof e.originClass == "string")
      return e.originClass;
    if (e.tailwindcssOriginClass)
      return m1(t.value);
  }), l = S(
    () => e.enter || n.value ? `${e.enter || ""} ${n.value || ""}` : void 0
  ), r = S(
    () => e.leave || n.value ? `${e.leave || ""} ${n.value || ""}` : void 0
  );
  return { originClassRef: n, enterActiveClassRef: l, leaveActiveClassRef: r };
}
[
  "[contentEditable=true]",
  "[tabindex]",
  "a[href]",
  "area[href]",
  "button:not([disabled])",
  "iframe",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])"
].map(
  // TODO: Remove this once JSDOM fixes the issue where an element that is
  // "hidden" can be the document.activeElement, because this is not possible
  // in real browsers.
  process.env.NODE_ENV === "test" ? (e) => `${e}:not([tabindex='-1']):not([style*='display: none'])` : (e) => `${e}:not([tabindex='-1'])`
).join(",");
const y1 = Symbol("ReferenceContext"), g1 = Symbol("FloatingContext"), w1 = Symbol("ArrowContext"), _ = {
  as: {
    type: [String, Function],
    default: "template"
  },
  floatingAs: {
    type: [String, Function],
    default: "div"
  },
  show: {
    type: Boolean,
    default: null
  },
  placement: {
    type: String,
    default: "bottom-start"
  },
  strategy: {
    type: String,
    default: "absolute"
  },
  offset: [Number, Function, Object],
  shift: {
    type: [Boolean, Number, Object],
    default: !1
  },
  flip: {
    type: [Boolean, Number, Object],
    default: !1
  },
  arrow: {
    type: [Boolean, Number],
    default: !1
  },
  autoPlacement: {
    type: [Boolean, Object],
    default: !1
  },
  hide: {
    type: [Boolean, Object],
    default: !1
  },
  autoUpdate: {
    type: [Boolean, Object],
    default: !0
  },
  zIndex: {
    type: [Number, String],
    default: 9999
  },
  transitionName: String,
  transitionType: String,
  enter: String,
  enterFrom: String,
  enterTo: String,
  leave: String,
  leaveFrom: String,
  leaveTo: String,
  originClass: [String, Function],
  tailwindcssOriginClass: {
    type: Boolean,
    default: !1
  },
  portal: {
    type: Boolean,
    default: !1
  },
  transform: {
    type: Boolean,
    default: !0
  },
  adaptiveWidth: {
    type: Boolean,
    default: !1
  },
  composable: {
    type: Boolean,
    default: !1
  },
  dialog: {
    type: Boolean,
    default: !1
  },
  middleware: {
    type: [Array, Function],
    default: () => []
  }
};
function x1(e, t, n, l) {
  const { referenceRef: r } = l, a = t, o = Ie(n, {
    ref: r
  }), i = Zn(
    e,
    a.as === "template" ? o : {}
  );
  return a.as === "template" ? i : typeof a.as == "string" ? Y(a.as, o, [i]) : Y(a.as, o, () => [i]);
}
function $1(e, t, n, l) {
  const { floatingRef: r, props: a, mounted: o, show: i, x: s, y: u, placement: c, strategy: d, referenceElWidth: f, updateFloating: v } = l, p = Ie(
    a,
    t
  ), { enterActiveClassRef: m, leaveActiveClassRef: h } = t, b = {
    enterActiveClass: m.value,
    enterFromClass: p.enterFrom,
    enterToClass: p.enterTo,
    leaveActiveClass: h.value,
    leaveFromClass: p.leaveFrom,
    leaveToClass: p.leaveTo
  }, y = {
    name: p.transitionName,
    type: p.transitionType,
    appear: !0,
    ...p.transitionName ? {} : b,
    onBeforeEnter() {
      i.value = !0;
    },
    onAfterLeave() {
      i.value = !1;
    }
  }, g = {
    enter: m.value,
    enterFrom: p.enterFrom,
    enterTo: p.enterTo,
    leave: h.value,
    leaveFrom: p.leaveFrom,
    leaveTo: p.leaveTo,
    onBeforeEnter: y.onBeforeEnter,
    onAfterLeave: y.onAfterLeave
  }, x = {
    style: {
      // If enable dialog mode, then set `transform` to false.
      ...!p.dialog && p.transform ? {
        position: d.value,
        zIndex: p.zIndex,
        top: "0px",
        left: "0px",
        right: "auto",
        bottom: "auto",
        transform: `translate(${Math.round(s.value || 0)}px,${Math.round(u.value || 0)}px)`
      } : {
        position: d.value,
        zIndex: p.zIndex,
        top: `${u.value || 0}px`,
        left: `${s.value || 0}px`
      },
      width: p.adaptiveWidth && typeof f.value == "number" ? `${f.value}px` : void 0
    }
  };
  function w(O) {
    return p.portal ? Y(ir, () => O) : O;
  }
  function $(O) {
    const P = Ie(
      x,
      n,
      p.dialog ? {} : { ref: r }
    );
    return p.as === "template" ? O : typeof p.as == "string" ? Y(p.as, P, O) : Y(p.as, P, () => O);
  }
  function E() {
    function O() {
      var P;
      const I = p.as === "template" ? Ie(
        x,
        n,
        p.dialog ? {} : { ref: r }
      ) : null, L = Zn(e, I);
      return ((P = L.props) == null ? void 0 : P.unmount) === !1 ? (v(), L) : typeof p.show != "boolean" || p.show ? L : Q();
    }
    return co.isServer ? o.value && p.show ? O() : Q() : p.transitionChild ? Y(Bt, {
      key: `placement-${c.value}`,
      ...p.dialog ? { ref: r } : {},
      as: "template",
      ...g
    }, O) : Y(Xn, {
      ...p.dialog ? { ref: r } : {},
      ...y
    }, O);
  }
  return w(
    $(
      E()
    )
  );
}
function S1(e, t, n, l, r) {
  const a = C(!1), o = Sr(l, "placement"), i = Sr(l, "strategy"), s = Kt({}), u = C(null), c = C(void 0), d = C(void 0), f = S(() => Jn(t)), v = S(() => Jn(n)), p = S(
    () => Oa(f) && Oa(v)
  ), { x: m, y: h, placement: b, strategy: y, middlewareData: g, update: x } = s1(f, v, {
    placement: o,
    strategy: i,
    middleware: s,
    whileElementsMounted: () => {
    }
  }), w = C(null), { enterActiveClassRef: $, leaveActiveClassRef: E } = b1(l, b);
  X(() => {
    a.value = !0;
  });
  function O() {
    p.value && (x(), r("update"));
  }
  se([o, i, s], O, { flush: "sync" }), p1(
    s,
    f,
    v,
    u,
    l
  ), se(g, () => {
    const j = g.value.arrow;
    c.value = j == null ? void 0 : j.x, d.value = j == null ? void 0 : j.y;
  }), h1(l.adaptiveWidth, f, w), se(e, async (j, k, U) => {
    if (await ie(), e.value && p.value && l.autoUpdate) {
      const G = o1(
        f.value,
        v.value,
        O,
        typeof l.autoUpdate == "object" ? l.autoUpdate : void 0
      );
      r("show"), U(() => {
        G(), r("hide");
      });
    }
  }, { flush: "post", immediate: !0 });
  const P = C(!0);
  se(f, () => {
    !(f.value instanceof Element) && p.value && P.value && (P.value = !1, window.requestAnimationFrame(() => {
      P.value = !0, O();
    }));
  }, { flush: "sync" });
  const I = {
    referenceRef: t,
    placement: b
  }, L = {
    floatingRef: n,
    props: l,
    mounted: a,
    show: e,
    x: m,
    y: h,
    placement: b,
    strategy: y,
    referenceElWidth: w,
    updateFloating: O
  }, M = {
    ref: u,
    placement: b,
    x: c,
    y: d
  };
  return fe(w1, M), { referenceApi: I, floatingApi: L, arrowApi: M, x: m, y: h, placement: b, strategy: y, referenceEl: f, floatingEl: v, middlewareData: g, update: O, enterActiveClassRef: $, leaveActiveClassRef: E };
}
const vo = {
  name: "Float",
  inheritAttrs: !1,
  props: _,
  emits: ["show", "hide", "update"],
  setup(e, { emit: t, slots: n, attrs: l }) {
    const r = C(e.show ?? !1), a = C(null), o = C(null), {
      referenceApi: i,
      floatingApi: s,
      placement: u,
      enterActiveClassRef: c,
      leaveActiveClassRef: d
    } = S1(r, a, o, e, t);
    function f(p) {
      return e.as === "template" ? p : typeof e.as == "string" ? Y(e.as, l, p) : Y(e.as, l, () => p);
    }
    const v = {
      placement: u.value
    };
    return e.composable || e.dialog ? (fe(y1, i), fe(g1, s), () => {
      if (n.default)
        return f(n.default(v));
    }) : () => {
      if (!n.default)
        return;
      const [p, m] = fo(n.default(v)).filter(Ta);
      if (!Ta(p))
        return;
      const h = x1(
        p,
        { as: "template" },
        {},
        i
      ), b = $1(
        m,
        {
          as: e.floatingAs,
          enterActiveClassRef: c,
          leaveActiveClassRef: d
        },
        {},
        s
      );
      return f([
        h,
        b
      ]);
    };
  }
};
_.as;
_.as, _.transitionName, _.transitionType, _.enter, _.enterFrom, _.enterTo, _.leave, _.leaveFrom, _.leaveTo, _.originClass, _.tailwindcssOriginClass;
({
  ..._.as
});
_.as, _.show, _.placement, _.strategy, _.offset, _.shift, _.flip, _.arrow, _.autoPlacement, _.hide, _.autoUpdate, _.zIndex, _.transitionName, _.transitionType, _.enter, _.enterFrom, _.enterTo, _.leave, _.leaveFrom, _.leaveTo, _.originClass, _.tailwindcssOriginClass, _.portal, _.transform, _.middleware;
_.as, _.placement, _.strategy, _.offset, _.shift, {
  ..._.flip
}, _.arrow, _.autoPlacement, _.hide, _.autoUpdate, _.zIndex, _.transitionName, _.transitionType, _.enter, _.enterFrom, _.enterTo, _.leave, _.leaveFrom, _.leaveTo, _.originClass, _.tailwindcssOriginClass, _.transform, _.middleware;
_.as, _.placement, _.strategy, _.offset, _.shift, _.flip, _.arrow, _.autoPlacement, _.hide, _.autoUpdate, _.zIndex, _.transitionName, _.transitionType, _.enter, _.enterFrom, _.enterTo, _.leave, _.leaveFrom, _.leaveTo, _.originClass, _.tailwindcssOriginClass, _.transform, _.middleware;
const T1 = { class: "no-scrollbar max-h-[300px] overflow-auto" }, O1 = ["onClick"], Fy = /* @__PURE__ */ D({
  __name: "TuneMenu",
  props: {
    items: null,
    selected: { default: "" },
    placement: { default: "bottom-start" }
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    return (n, l) => (A(), H(F(Ti), {
      as: "div",
      class: "inline-block h-full text-left"
    }, {
      default: N(() => [
        z(F(vo), {
          enter: "transition ease-out duration-100",
          "enter-from": "transform opacity-0 scale-95",
          "enter-to": "transform opacity-100 scale-100",
          leave: "transition ease-in duration-75",
          "leave-from": "transform opacity-100 scale-100",
          "leave-to": "transform opacity-0 scale-95",
          placement: e.placement,
          offset: 8,
          shift: 16,
          flip: 16,
          "z-index": 50
        }, {
          default: N(() => [
            z(F(Oi), { class: "h-full" }, {
              default: N(() => [
                n.$slots.button ? ye(n.$slots, "button", { key: 0 }) : (A(), H(Yt, {
                  key: 1,
                  class: "flex items-center"
                }, {
                  default: N(() => [
                    ge(re(e.selected) + " ", 1),
                    z(F(Ye), {
                      class: "-mr-1 ml-1 text-sm",
                      "aria-hidden": "true"
                    })
                  ]),
                  _: 1
                }))
              ]),
              _: 3
            }),
            z(F(Ci), { class: "tune-menu-list overflow-hidden outline-none" }, {
              default: N(() => [
                R("div", T1, [
                  (A(!0), V(pe, null, Le(e.items, (r) => (A(), H(F(Ai), {
                    key: r.text
                  }, {
                    default: N(({ active: a }) => [
                      R("div", {
                        class: Z([
                          { active: a },
                          "tune-menu-list-item cursor-pointer whitespace-nowrap px-3 py-2"
                        ]),
                        onClick: (o) => t("select", r.action)
                      }, [
                        ye(n.$slots, "item", {
                          key: r,
                          item: r
                        }, () => [
                          ge(re(r.text), 1)
                        ])
                      ], 10, O1)
                    ]),
                    _: 2
                  }, 1024))), 128))
                ])
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["placement"])
      ]),
      _: 3
    }));
  }
}), C1 = { class: "tune-popover overflow-hidden" }, A1 = { class: "no-scrollbar max-h-[85vh] overflow-y-auto overscroll-contain" }, Iy = /* @__PURE__ */ D({
  __name: "TunePopover",
  props: {
    label: { default: "" },
    placement: { default: "bottom-end" }
  },
  setup(e) {
    return (t, n) => (A(), H(F(ul), null, {
      default: N(() => [
        z(F(vo), {
          enter: "transition ease-out duration-100",
          "enter-from": "transform opacity-0 scale-95",
          "enter-to": "transform opacity-100 scale-100",
          leave: "transition ease-in duration-75",
          "leave-from": "transform opacity-100 scale-100",
          "leave-to": "transform opacity-0 scale-95",
          placement: e.placement,
          offset: 4,
          shift: 16,
          flip: 16,
          "z-index": 50,
          portal: ""
        }, {
          default: N(() => [
            z(F(Fi), { class: "outline-none" }, {
              default: N(() => [
                t.$slots.button ? ye(t.$slots, "button", { key: 0 }) : (A(), H(Yt, {
                  key: 1,
                  class: "flex items-center gap-1"
                }, {
                  default: N(() => [
                    R("span", null, re(e.label), 1),
                    z(F(Ye), {
                      class: "text-sm",
                      "aria-hidden": "true"
                    })
                  ]),
                  _: 1
                }))
              ]),
              _: 3
            }),
            z(F(Ii), { class: "w-screen max-w-xs outline-none sm:max-w-sm" }, {
              default: N(({ close: l }) => [
                R("div", C1, [
                  R("div", A1, [
                    ye(t.$slots, "content", { close: l })
                  ])
                ])
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["placement"])
      ]),
      _: 3
    }));
  }
}), E1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
}, P1 = /* @__PURE__ */ R("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1), F1 = [
  P1
];
function I1(e, t) {
  return A(), V("svg", E1, F1);
}
const _1 = { name: "heroicons-x-mark", render: I1 }, L1 = /* @__PURE__ */ R("div", { class: "tune-modal-backdrop fixed inset-0" }, null, -1), k1 = { class: "fixed inset-0 overflow-y-auto" }, D1 = { class: "flex min-h-full items-center justify-center p-4 text-center" }, R1 = { class: "absolute right-4 top-4" }, V1 = /* @__PURE__ */ R("span", { class: "sr-only" }, "Close", -1), M1 = { class: "mt-4" }, j1 = {
  key: 0,
  class: "mt-4"
}, _y = /* @__PURE__ */ D({
  __name: "TuneModal",
  props: {
    open: { type: Boolean },
    title: null
  },
  emits: ["close"],
  setup(e) {
    return (t, n) => (A(), H(F(pl), {
      appear: "",
      show: e.open,
      as: "template"
    }, {
      default: N(() => [
        z(F(vi), {
          as: "div",
          class: "relative z-10",
          onClose: n[1] || (n[1] = (l) => t.$emit("close"))
        }, {
          default: N(() => [
            z(F(Bt), {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: N(() => [
                L1
              ]),
              _: 1
            }),
            R("div", k1, [
              R("div", D1, [
                z(F(Bt), {
                  as: "template",
                  enter: "duration-300 ease-out",
                  "enter-from": "opacity-0 scale-95",
                  "enter-to": "opacity-100 scale-100",
                  leave: "duration-200 ease-in",
                  "leave-from": "opacity-100 scale-100",
                  "leave-to": "opacity-0 scale-95"
                }, {
                  default: N(() => [
                    z(F(pi), { class: "tune-modal-panel w-full transform overflow-hidden align-middle transition-all" }, {
                      default: N(() => [
                        R("div", R1, [
                          R("button", {
                            onClick: n[0] || (n[0] = (l) => t.$emit("close"))
                          }, [
                            V1,
                            z(F(_1), {
                              class: "text-md",
                              "aria-hidden": "true"
                            })
                          ])
                        ]),
                        z(F(hi), {
                          as: "h3",
                          class: "tune-modal-title"
                        }, {
                          default: N(() => [
                            ge(re(e.title), 1)
                          ]),
                          _: 1
                        }),
                        R("div", M1, [
                          ye(t.$slots, "default")
                        ]),
                        t.$slots.footer ? (A(), V("div", j1, [
                          ye(t.$slots, "footer")
                        ])) : Q("", !0)
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), B1 = ["for"], N1 = { class: "flex items-center gap-[10px]" }, z1 = ["id", "checked", "name"], Ly = /* @__PURE__ */ D({
  __name: "TuneCheckbox",
  props: {
    modelValue: { type: Boolean },
    id: null,
    label: null,
    hint: null,
    definition: null
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    return (n, l) => {
      var r, a;
      return A(), V("div", null, [
        R("label", { for: e.id }, [
          R("div", N1, [
            R("input", {
              id: e.id,
              checked: e.modelValue,
              name: e.label || ((r = e.definition) == null ? void 0 : r.title),
              type: "checkbox",
              class: "tune-input-checkbox",
              onInput: l[0] || (l[0] = (o) => t("update:modelValue", o.target.checked))
            }, null, 40, z1),
            e.hint || (a = e.definition) != null && a.description ? (A(), H(Ce, {
              key: 0,
              class: "!mb-0"
            }, {
              default: N(() => [
                ge(re(e.hint || e.definition.description), 1)
              ]),
              _: 1
            })) : Q("", !0)
          ])
        ], 8, B1)
      ]);
    };
  }
}), U1 = ["for"], H1 = { class: "flex items-center gap-[10px]" }, G1 = ["id", "name", "checked", "value"], ky = /* @__PURE__ */ D({
  __name: "TuneRadio",
  props: {
    modelValue: null,
    value: null,
    id: null,
    label: null,
    hint: null,
    definition: null
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, l = (r) => {
      r.target && r.target.checked && t("update:modelValue", n.value);
    };
    return (r, a) => {
      var o, i;
      return A(), V("div", null, [
        R("label", {
          for: e.id || e.value
        }, [
          R("div", H1, [
            R("input", {
              id: e.id || e.value,
              type: "radio",
              name: e.label || ((o = e.definition) == null ? void 0 : o.title),
              checked: e.modelValue === e.value,
              value: e.value,
              class: "tune-input-radio",
              onInput: l
            }, null, 40, G1),
            e.hint || (i = e.definition) != null && i.description ? (A(), H(Ce, {
              key: 0,
              class: "!mb-0"
            }, {
              default: N(() => [
                ge(re(e.hint || e.definition.description), 1)
              ]),
              _: 1
            })) : Q("", !0)
          ])
        ], 8, U1)
      ]);
    };
  }
}), W1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
}, K1 = /* @__PURE__ */ R("path", {
  fill: "currentColor",
  d: "M21.721 12.752a9.711 9.711 0 0 0-.945-5.003a12.754 12.754 0 0 1-4.339 2.708a18.991 18.991 0 0 1-.214 4.772a17.165 17.165 0 0 0 5.498-2.477Zm-7.087 2.798a17.324 17.324 0 0 0 .332-4.647c-.952.227-1.945.347-2.966.347c-1.021 0-2.014-.12-2.966-.347a17.515 17.515 0 0 0 .332 4.647a17.385 17.385 0 0 0 5.268 0Zm-4.862 1.569a18.963 18.963 0 0 0 4.456 0A17.182 17.182 0 0 1 12 21.724a17.18 17.18 0 0 1-2.228-4.605ZM7.777 15.23a18.87 18.87 0 0 1-.214-4.774a12.753 12.753 0 0 1-4.34-2.708a9.711 9.711 0 0 0-.944 5.004a17.165 17.165 0 0 0 5.498 2.477Zm13.579-.478a9.765 9.765 0 0 1-7.478 6.817a18.64 18.64 0 0 0 1.988-4.718a18.627 18.627 0 0 0 5.49-2.098Zm-18.712 0a18.619 18.619 0 0 0 5.49 2.099a18.64 18.64 0 0 0 1.988 4.718a9.765 9.765 0 0 1-7.478-6.816ZM13.878 2.43a9.755 9.755 0 0 1 6.116 3.986a11.267 11.267 0 0 1-3.746 2.504a18.63 18.63 0 0 0-2.37-6.49ZM12 2.276a17.152 17.152 0 0 1 2.805 7.121a11.281 11.281 0 0 1-5.61 0A17.151 17.151 0 0 1 12 2.276Zm-1.878.154a18.629 18.629 0 0 0-2.37 6.49a11.266 11.266 0 0 1-3.746-2.504a9.754 9.754 0 0 1 6.116-3.985Z"
}, null, -1), q1 = [
  K1
];
function Y1(e, t) {
  return A(), V("svg", W1, q1);
}
const J1 = { name: "heroicons-globe-alt-solid", render: Y1 }, Dy = /* @__PURE__ */ D({
  __name: "TuneInputUrl",
  props: {
    modelValue: null,
    placeholder: null,
    label: null,
    error: null,
    hint: null,
    disabled: { type: Boolean },
    maxLength: null
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const l = C();
    function r() {
      var a;
      (a = l == null ? void 0 : l.value) == null || a.forceShowError();
    }
    return t({
      forceShowError: r
    }), (a, o) => (A(), H(rn, {
      ref_key: "inputRef",
      ref: l,
      label: e.label,
      "model-value": e.modelValue,
      error: e.error,
      hint: e.hint,
      disabled: e.disabled,
      placeholder: e.placeholder,
      "max-length": e.maxLength,
      class: "!pl-[40px]",
      "onUpdate:modelValue": o[0] || (o[0] = (i) => n("update:modelValue", i))
    }, {
      before: N(() => [
        z(F(J1), { class: "text-sm" })
      ]),
      _: 1
    }, 8, ["label", "model-value", "error", "hint", "disabled", "placeholder", "max-length"]));
  }
}), Z1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
}, Q1 = /* @__PURE__ */ R("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5a17.92 17.92 0 0 1-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
}, null, -1), X1 = [
  Q1
];
function ey(e, t) {
  return A(), V("svg", Z1, X1);
}
const ty = { name: "heroicons-globe-alt", render: ey }, ny = {
  width: "1.2em",
  height: "1.2em",
  fill: "currentColor",
  viewBox: "0 0 30 30",
  xmlns: "http://www.w3.org/2000/svg"
}, ry = /* @__PURE__ */ R("path", { d: "M25.2688 9.53141C25.2846 9.76543 25.2846 9.99945 25.2846 10.2356C25.2846 17.432 19.9588 25.7316 10.2203 25.7316V25.7273C7.34353 25.7316 4.52651 24.884 2.10474 23.2857C2.52304 23.3375 2.94345 23.3634 3.3649 23.3645C5.74893 23.3666 8.06482 22.5438 9.94038 21.0286C7.67482 20.9844 5.68812 19.4648 4.99409 17.2465C5.78772 17.404 6.60546 17.3716 7.38441 17.1527C4.91441 16.6394 3.1374 14.407 3.1374 11.8145C3.1374 11.7907 3.1374 11.7681 3.1374 11.7454C3.87337 12.1671 4.6974 12.4011 5.5403 12.427C3.21393 10.8277 2.49683 7.64416 3.90167 5.15514C6.58974 8.55759 10.5558 10.626 14.8133 10.8449C14.3866 8.95337 14.9695 6.97122 16.345 5.64151C18.4774 3.57955 21.8312 3.68524 23.8357 5.87769C25.0214 5.6372 26.1579 5.18965 27.1979 4.55553C26.8026 5.81622 25.9755 6.8871 24.8705 7.56759C25.9199 7.44034 26.9452 7.15132 27.9108 6.71024C27.2 7.80592 26.3047 8.76034 25.2688 9.53141Z" }, null, -1), ay = [
  ry
];
function ly(e, t) {
  return A(), V("svg", ny, ay);
}
const oy = { name: "tune-twitter", render: ly }, iy = {
  width: "1.2em",
  height: "1.2em",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  role: "img",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, uy = /* @__PURE__ */ R("path", {
  "fill-rule": "evenodd",
  d: "M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385c.6.105.825-.255.825-.57c0-.285-.015-1.23-.015-2.235c-3.015.555-3.795-.735-4.035-1.41c-.135-.345-.72-1.41-1.23-1.695c-.42-.225-1.02-.78-.015-.795c.945-.015 1.62.87 1.845 1.23c1.08 1.815 2.805 1.305 3.495.99c.105-.78.42-1.305.765-1.605c-2.67-.3-5.46-1.335-5.46-5.925c0-1.305.465-2.385 1.23-3.225c-.12-.3-.54-1.53.12-3.18c0 0 1.005-.315 3.3 1.23c.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23c.66 1.65.24 2.88.12 3.18c.765.84 1.23 1.905 1.23 3.225c0 4.605-2.805 5.625-5.475 5.925c.435.375.81 1.095.81 2.22c0 1.605-.015 2.895-.015 3.3c0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12Z",
  "clip-rule": "evenodd"
}, null, -1), sy = [
  uy
];
function cy(e, t) {
  return A(), V("svg", iy, sy);
}
const dy = { name: "tune-github", render: cy }, fy = {
  width: "1.2em",
  height: "1.2em",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1080 1080"
}, vy = /* @__PURE__ */ R("path", {
  class: "st0",
  d: `M536.6-1C238.3,0.4-2.3,243.2-1,541.4c1.4,298.2,244.2,538.9,542.4,537.6c298.2-1.4,538.9-244.2,537.6-542.4
				C1077.6,238.3,834.8-2.3,536.6-1z M468.2,512.5c-53.3,0-96.6-43.2-96.6-96.5c0-53.3,43.2-96.5,96.6-96.5
				c53.3,0,96.5,43.2,96.5,96.5C564.7,469.3,521.5,512.5,468.2,512.5z M545.2,616.9l0.5-0.6l0.5-0.6c27.6,17.8,59,24,90.4,25
				c31.5,0.8,63.5-1.5,95.1-7.9c31.5-6.5,62.5-16.2,92.4-28.6c16.8-6.9,33.5-14.5,49.4-23.4c0.1-0.1,0.2-0.1,0.3-0.2
				c9.9-6,19.6-12.2,29.1-18.7c2.1-1.5,4.1-3,6-4.6l0.2,0.3l0.8,1c-24.3,22.1-53.2,38.5-82.6,53c-29.7,14-60.7,25.5-92.7,33.8
				c-31.9,8.2-65.2,14.5-98.9,11.4C602.5,653.7,567.5,642.1,545.2,616.9z M793,512.5c0-11.6,9.3-20.9,20.8-21
				c11.6,0,20.9,9.3,21,20.8c0,11.5-9.3,21-20.8,21C802.5,533.4,793,524.1,793,512.5z M627.6,1030.5
				C606.7,884.3,734.3,741.2,806.3,668c16.3-16.6,41.6-39.5,65.1-63.8c93.4-87.3,112-191.7-79.2-243.9
				c-36.2-10.5-73.8-25.4-111.8-40.4c-1.2-3.5-2.6-6.8-4.1-9.9c-4.4-7.5-12-16.2-23.6-26c-24.9-21.6-71.5-21-111.8-11.5
				c-44.6-10.5-88.5-14.2-130.8-4.1c-184.9,50.9-214.6,141.1-221.8,249.8c-9.8,117.4-15.5,204.9-60,304.9
				C72.8,743,40.1,646,39.7,541.2C38.5,265.5,261,40.9,536.8,39.7c275.8-1.2,500.3,221.3,501.6,497.1
				C1039.4,783.1,862,988.6,627.6,1030.5z`
}, null, -1), py = [
  vy
];
function hy(e, t) {
  return A(), V("svg", fy, py);
}
const my = { name: "tune-coingecko", render: hy }, Ry = /* @__PURE__ */ D({
  __name: "TuneInputSocial",
  props: {
    modelValue: null,
    error: null,
    placeholder: null,
    maxLength: null,
    label: null,
    disabled: { type: Boolean },
    icon: null
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const l = C();
    function r() {
      var a;
      (a = l == null ? void 0 : l.value) == null || a.forceShowError();
    }
    return t({
      forceShowError: r
    }), (a, o) => (A(), H(rn, {
      ref_key: "inputRef",
      ref: l,
      label: e.label,
      "model-value": e.modelValue,
      error: e.error,
      placeholder: e.placeholder,
      "max-length": e.maxLength,
      disabled: e.disabled,
      class: "!pl-[40px]",
      "onUpdate:modelValue": o[0] || (o[0] = (i) => n("update:modelValue", i))
    }, {
      before: N(() => [
        e.icon === "twitter" ? (A(), H(F(oy), {
          key: 0,
          class: "text-[16px]"
        })) : Q("", !0),
        e.icon === "github" ? (A(), H(F(dy), {
          key: 1,
          class: "text-[16px]"
        })) : Q("", !0),
        e.icon === "earth" ? (A(), H(F(ty), {
          key: 2,
          class: "text-[16px]"
        })) : Q("", !0),
        e.icon === "coingecko" ? (A(), H(F(my), {
          key: 3,
          class: "text-[16px]"
        })) : Q("", !0)
      ]),
      _: 1
    }, 8, ["label", "model-value", "error", "placeholder", "max-length", "disabled"]));
  }
}), by = { class: "w-full" }, Vy = /* @__PURE__ */ D({
  __name: "TuneButtonSelect",
  props: {
    modelValue: null,
    label: null,
    hint: null,
    disabled: { type: Boolean },
    tooltip: null,
    definition: null
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    return (n, l) => {
      var a, o;
      const r = Qn("tippy");
      return A(), V("div", by, [
        e.label || (a = e.definition) != null && a.title ? (A(), H(Ce, {
          key: 0,
          hint: e.hint || ((o = e.definition) == null ? void 0 : o.description)
        }, {
          default: N(() => [
            ge(re(e.label || e.definition.title), 1)
          ]),
          _: 1
        }, 8, ["hint"])) : Q("", !0),
        qt((A(), H(Yt, {
          class: Z([[n.$attrs.class, { disabled: e.disabled }], "tune-button-select"]),
          disabled: e.disabled,
          onClick: l[0] || (l[0] = (i) => e.disabled ? null : t("select"))
        }, {
          default: N(() => [
            R("span", null, re(e.modelValue), 1),
            z(F(Ye), { class: "absolute inset-y-[12px] right-[14px] text-xs" })
          ]),
          _: 1
        }, 8, ["class", "disabled"])), [
          [r, { content: e.tooltip }]
        ])
      ]);
    };
  }
}), yy = ["disabled", "value"], gy = ["value"], My = /* @__PURE__ */ D({
  __name: "TuneSelect",
  props: {
    items: null,
    modelValue: null,
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    function n(l) {
      t("update:modelValue", l.target.value);
    }
    return (l, r) => (A(), V("select", {
      disabled: e.disabled,
      value: e.modelValue,
      class: Z(["tune-select form-select", { disabled: e.disabled }]),
      onChange: r[0] || (r[0] = (a) => n(a))
    }, [
      (A(!0), V(pe, null, Le(e.items, (a, o) => (A(), V("option", {
        key: o,
        value: a.value
      }, re(a.label), 9, gy))), 128))
    ], 42, yy));
  }
}), wy = {
  key: 0,
  class: "flex items-center first:-ml-3"
}, xy = ["value", "max", "disabled", "onInput"], $y = { class: "tune-input-duration-label" }, Sy = /* @__PURE__ */ D({
  __name: "TuneInputDuration",
  props: {
    modelValue: null,
    label: null,
    hint: null,
    definition: null,
    hideDay: { type: Boolean },
    hideMinutes: { type: Boolean },
    disabled: { type: Boolean },
    block: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, l = S({
      get() {
        return n.hideDay ? {
          hours: Math.floor(n.modelValue / 3600),
          minutes: Math.floor(n.modelValue % 3600 / 60)
        } : n.hideMinutes ? {
          days: Math.floor(n.modelValue / 86400),
          hours: Math.floor(n.modelValue % 86400 / 3600)
        } : {
          days: Math.floor(n.modelValue / 86400),
          hours: Math.floor(n.modelValue % 86400 / 3600),
          minutes: Math.floor(n.modelValue % 3600 / 60)
        };
      },
      set(s) {
        const u = s.minutes || 0, c = s.hours || 0, f = (s.days || 0) * 86400 + c * 3600 + u * 60;
        t("update:modelValue", f);
      }
    }), r = S(() => [
      {
        key: "days",
        label: "Days",
        hidden: n.hideDay || !1,
        max: 365
      },
      {
        key: "hours",
        label: "Hours",
        hidden: !1,
        max: 24
      },
      {
        key: "minutes",
        label: "Minutes",
        hidden: n.hideMinutes || !1,
        max: 60
      }
    ]), a = (s, u) => {
      isNaN(u) || u === void 0 || (l.value = { ...l.value, [s]: u });
    }, o = C([]);
    function i(s) {
      o.value.push(s);
    }
    return (s, u) => {
      var c;
      return A(), V("div", null, [
        z(F(Ce), {
          hint: e.hint || ((c = e.definition) == null ? void 0 : c.description)
        }, {
          default: N(() => {
            var d;
            return [
              ge(re(e.label || ((d = e.definition) == null ? void 0 : d.title)), 1)
            ];
          }),
          _: 1
        }, 8, ["hint"]),
        R("div", {
          class: Z([
            "tune-input-duration inline-flex overflow-hidden",
            { "w-full": e.block },
            { disabled: e.disabled }
          ]),
          onClick: u[1] || (u[1] = (d) => {
            var f;
            return (f = o.value) == null ? void 0 : f[0].focus();
          })
        }, [
          (A(!0), V(pe, null, Le(F(r), (d) => (A(), V(pe, {
            key: d.label
          }, [
            d.hidden ? Q("", !0) : (A(), V("div", wy, [
              R("input", {
                ref_for: !0,
                ref: i,
                value: F(l)[d.key],
                type: "number",
                min: "0",
                max: d.max,
                placeholder: "0",
                disabled: e.disabled,
                class: Z([
                  "bg-transparent py-2 pl-4 pr-1 outline-none",
                  { "cursor-not-allowed bg-transparent": e.disabled }
                ]),
                onClick: u[0] || (u[0] = xo(() => {
                }, ["stop"])),
                onInput: (f) => {
                  var v;
                  return a(d.key, (v = f.target) == null ? void 0 : v.valueAsNumber);
                }
              }, null, 42, xy),
              R("span", $y, re(d.label), 1)
            ]))
          ], 64))), 128))
        ], 2)
      ]);
    };
  }
});
const Ty = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [l, r] of t)
    n[l] = r;
  return n;
}, jy = /* @__PURE__ */ Ty(Sy, [["__scopeId", "data-v-39c73d23"]]);
export {
  Yt as TuneButton,
  Vy as TuneButtonSelect,
  Ly as TuneCheckbox,
  Ay as TuneCombobox,
  Ey as TuneComboboxMultiple,
  nn as TuneErrorInput,
  Xl as TuneForm,
  ou as TuneIconHint,
  rn as TuneInput,
  jy as TuneInputDuration,
  Ry as TuneInputSocial,
  Dy as TuneInputUrl,
  Ce as TuneLabelInput,
  oh as TuneListbox,
  jb as TuneListboxMultiple,
  Aa as TuneLoadingSpinner,
  Fy as TuneMenu,
  _y as TuneModal,
  Iy as TunePopover,
  ky as TuneRadio,
  My as TuneSelect,
  fh as TuneSwitch,
  $l as TuneTag,
  fr as TuneTextarea,
  Ib as TuneTextareaArray,
  Py as TuneTextareaJson
};
